 export const sa =  {
  app: {
    home: "الصفحة الرئيسية",
    playerScout: "البحث عن لاعبين",
    playerComparison: "مقارنة اللاعبين",
    playerRecruitment: "رادار",
    collections: "المجموعات",
    favoritePlayers: "اللاعبون المفضلون ",
    teamAnalytics: "تحليل الفرق",
    gameAnalysis: "تحليل المباريات",
    seasonStats: "احصائيات المواسم",
    leagueTable: "جدول ترتيب الدوري",
    scoresAndFixtures: "النتائج و المباريات",
    notifications: "الإشعارات",
    administration: "إدارة",
    inbox: "صندوف الوارد",
    teamStats: "إحصائيات الفريق",
    blog: "مدونة",
    leagues: "دوريات",
    squadBuilder: "إنشاءالتشكيلات",
    playerAlerts: "تنبيهات اللاعبين",
    searchAlerts: "تنبيهات البحث",
    videoUploadTool: "تحميل فيديوهات",
    videoPlaylists: "قائمة الفيديوهات",
    uploadedGames:"Uploaded games",
    favoriteTeams:"Favorite Teams"
  },
  playerRecruitment: {
    league: "دوري",
    selectedSeason: "الموسم المختار",
    year: "سنة",
    radar: "رادار",
    positions: "مراكز",
    numberOfPlayers: "رقم اللاعبين",
    template: "التشكيلة",
    compareWith: "مقارنة مع",
    previousPerformance: "الأداء السابق",
    xGames: "{0} مباريات",
    average: "معدل",
    leagueAverage: "معدل الدوري",
    selectSeason: "اختر موسمًا",
    positionsPlayed: "المراكز التي لعب فيها",
    minMax: "الحد الأدنى والحد الأقصى",
    top5Leagues: "الدوريات الخمس الكبرى",
    infoMessage: "اختر موسم واحد فقط لتفعيل الحد الأدنى والحد الأقصى",
    infoMessage2: "اختر نفس الموسم لكلا الاعبين",
    dataPer90MinText: "بيانات عن كل ٩٠ دقيقة",
    adjustToPossessionText: "* معدلة للحيازة",
    text: "نص",
    lollipop: "لولييبوب",
    polar: "القطبية",
    radarTemplates: {
      Goalkeeper: "حارس مرمى",
      GoalkeeperCustom1: "حارس مرمى محدد المميزات ١",
      GoalkeeperCustom2: "حارس مرمى محدد المميزات ٢",
      GoalkeeperCustom3: "حارس مرمى محدد المميزات ٣",
      GoalkeeperCustom4: "حارس مرمى محدد المميزات ٤",
      GoalkeeperCustom5: "حارس مرمى محدد المميزات ٥",
      GoalkeeperCustom6: "حارس مرمى محدد المميزات ٦",
      Defender: "مدافع",
      DefenderCustom1: "مدافع محدد المميزات ١",
      DefenderCustom2: "مدافع محدد المميزات ٢",
      DefenderCustom3: "مدافع محدد المميزات ٣",
      DefenderCustom4: "مدافع محدد المميزات ٤",
      DefenderCustom5: "مدافع محدد المميزات ٥",
      DefenderCustom6: "مدافع محدد المميزات ٦",
      FullBack: "ظهير",
      FullBackCustom1: "ظهير محدد المميزات ١",
      FullBackCustom2: "ظهير محدد المميزات ٢",
      FullBackCustom3: "ظهير محدد المميزات ٣",
      FullBackCustom4: "ظهير محدد المميزات ٤",
      FullBackCustom5: "ظهير محدد المميزات ٥",
      FullBackCustom6: "ظهير محدد المميزات ٦",
      FullBackPredictive: "ظهير",
      Midfielder: "لاعب وسط",
      MidfielderCustom1: "لاعب وسط محدد المميزات ١",
      MidfielderCustom2: "لاعب وسط محدد المميزات ٢",
      MidfielderCustom3: "لاعب وسط محدد المميزات ٣",
      MidfielderCustom4: "لاعب وسط محدد المميزات ٤",
      MidfielderCustom5: "لاعب وسط محدد المميزات ٥",
      MidfielderCustom6: "لاعب وسط محدد المميزات ٦",
      MidfielderPredictive: "لاعب وسط",
      MidfielderDefensive: "لاعب وسط مدافع",
      MidfielderOffensive: "لاعب وسط مهاجم",
      AttackingMidfielder: "متقدم وسط خط",
      MidfielderWing: "لاعب وسط واسع",
      Winger: "لاعب جناح",
      WingerCustom1: "لاعب جناح محدد المميزات ١",
      WingerCustom2: "لاعب جناح محدد المميزات ٢",
      WingerCustom3: "لاعب جناح محدد المميزات ٣",
      WingerCustom4: "لاعب جناح محدد المميزات ٤",
      WingerCustom5: "لاعب جناح محدد المميزات ٥",
      WingerCustom6: "لاعب جناح محدد المميزات ٦",
      WingerOffensive: "جناح مهاجم",
      Forward: "مهاجم",
      ForwardCustom1: "مهاجم محدد المميزات ١",
      ForwardCustom2: "مهاجم محدد المميزات ٢",
      ForwardCustom3: "مهاجم محدد المميزات ٣",
      ForwardCustom4: "مهاجم محدد المميزات ٤",
      ForwardCustom5: "مهاجم محدد المميزات ٥",
      ForwardCustom6: "مهاجم محدد المميزات ٦",
      ForwardPredictive: "مهاجم",
      WingBack: "جناح خلفي",
      WingBackCustom1: "جناح خلفي محدد المميزات ١",
      WingBackCustom2: "جناح خلفي محدد المميزات ٢",
      WingBackCustom3: "جناح خلفي محدد المميزات ٣",
      WingBackCustom4: "جناح خلفي محدد المميزات ٤",
      WingBackCustom5: "جناح خلفي محدد المميزات ٥",
      WingBackCustom6: "جناح خلفي محدد المميزات ٦",
      WingBackMedia: "جناح خلفي (SocialMedia)",
      FullBackMedia: "ظهير (SocialMedia)",
      MidfielderMedia: "لاعب وسط (SocialMedia)",
      WingerMedia: "لاعب جناح (SocialMedia)",
      ForwardMedia: "مهاجم (SocialMedia)",
      PhysicalWingBack: "جناح خلفي قوي بدنيا",
      PhysicalForward: "مهاجم بدني",
      PhysicalWinger: "جناح قوي بدنيا",
      PhysicalMidfielder: "لاعب وسط قوي بدنيا",
      PhysicalFullBack: "ظهير قوي بدنيا",
      PhysicalDefender: "مهاجم قوي بدنيا",
      PhysicalWingBackLMO: "جناح خلفي قوي بدنيا",
      PhysicalForwardLMO: "مهاجم قوي بدنيا",
      PhysicalWingerLMO: "لاعب جناح قوي بدنيا",
      PhysicalMidfielderLMO: "لاعب وسط قوي بدنيا",
      PhysicalFullBackLMO: "ظهير قوي بدنيا",
      PhysicalDefenderLMO: "مدافع قوي بدنيا"
    },
    radarTemplatesWomen: {
      Goalkeeper: "حارس مرمى",
      Defender: "مدافع",
      FullBack: "ظهير",
      FullBackPredictive: "ظهير",
      Midfielder: "لاعب وسط",
      MidfielderPredictive: "لاعب وسط",
      MidfielderDefensive: "لاعب وسط مدافع",
      MidfielderOffensive: "لاعب وسط مهاجم",
      AttackingMidfielder: "متقدم وسط خط",
      MidfielderWing: "لاعب وسط على الجناح",
      Winger: "لاعب جناح",
      WingerOffensive: "جناح مهاجم",
      Forward: " مهاجمة",
      ForwardPredictive: "مهاجمة",
      WingBack: "لاعبة جناح خلفي",
      WingBackMedia: "لاعبة جناح خلفي (SocialMedia)",
      FullBackMedia: "لاعبة ظهير (SocialMedia)",
      MidfielderMedia: "لاعبة وسط (SocialMedia)",
      WingerMedia: "لاعبة جناح (SocialMedia)",
      ForwardMedia: "مهاجمة (SocialMedia)",
      PhysicalWingBack: "لاعبة جناح خلفي قوية بدنيا",
      PhysicalForward: "مهاجمة قوية بدنيا",
      PhysicalWinger: "لاعبة جناح قوية بدنيا",
      PhysicalMidfielder: "لاعبة وسط قوية بدنيا",
      PhysicalFullBack: "ظهير قوية بدنيا",
      PhysicalDefender: "مدافعة قوية بدنية",
      PhysicalWingBackLMO: "لاعبة جناح خلفي قوية بدنيا",
      PhysicalForwardLMO: "مهاجمة قوية بدنيا",
      PhysicalWingerLMO: "لاعبة جناح قوية بدنيا",
      PhysicalMidfielderLMO: "لاعبة وسط قوية بدنيا",
      PhysicalFullBackLMO: "ظهير قوية بدنيا",
      PhysicalDefenderLMO: "مدافعة قوية بدنيا"
    },
    radarDescription: {
      basicStatistics: {
        title: "إحصائيات أساسية",
        minutes: "دقائق",
        goals: "أهداف",
        assists: "تمريرات حاسمة",
        redCards: "بطاقات حمراء",
        yellowCards: "بطاقات صفراء",
        games: "مباريات",
        goalsReceived: "أهداف بدون ضربات جزاء تم استقبالها",
        xGFaced: "xG تم استقبالها"
      },
      profiles: {
        3: {
          1: "حارس مرمى مهاري في التعامل مع الكرة بالقدمين، في التمريرات القصيرة والطويلة.",
          2: "حارس مرمى يجيد اللعب بالقدمين وخصوصا لبدء اللعب. نسب إجادة عالية للتمريرات القصيرة والطويلة.",
          3: "حترس مرمى يجيد اللعب بالقدمين. أدائه يجعله ذو قيمة هامة نظرا لدقة تمريراته",
          4: "حارس مرمى يتميز بدقة تمريراته، سواء في نصف ملعبه أو نصف ملعب المنافس",
          5: "[حارس مرمى متكمن من التعامل مع الكرة بالقدمين ويتمتع بمهارة تمرير الكرة]",
          6: "حارس مرمى يجيد اللعب بالقدمين. متمكن من تمريرات بداية اللعب ويصيب بنسب عالية في التمريرات القصيرة والطويلة.",
          7: "حارس مرمى مهاري في اللعب بالقدمين. يصيب بنسب عالية في التمريرات القصيرة والطويلة."
        },
        5: {
          1: "مدافع يتميز في المواجهة الفردية ويقوم بعدد كبير من التدخلات وقطع التمريرات.",
          2: "قلب دفاع فعال في المواجهات الدفاعية الفرديةالفردية سواء في الكرات الهوائية والتدخلات ولدية قراءة جيدة للتنبـؤ باللعب.",
          3: "قلب دفاع ذو أداء عالى في المواجهات الدفاعية الفردية، الأمر الذي يسمح له بنسبة عالية من استعادة الاستحواذ",
          4: "لاعب ذو مستوى هجومي عالي. لديه القدرة على استعادة عدد كبير من الكرات بفضل تدخله وقطعه للتمريرات.",
          5: ".مدافع فعال في التدخل ولديه القدرة على قطع عدد كبير من الكرات. يتميز بالمواجهات الفردية",
          6: "قلب دفاع يتميز باستعادة نسب كبيرة من الكرات في المبارة. مهاري في قراءة المنافس وقطع الكرة. يتميز بدقته العالية في اللعب واعتياده على التدخل .",
          7: "يتميز بقدرته على قطع عدد كبير من الكرات بفضل فاعليته واعتياده على التدخل وقرائته الجيدة لاللعب"
        },
        6: {
          1: "مدافع يساهم بكثرة في خلق فرص  و لديه نظرة جيدة للعب"
        },
        7: {
          1: "لاعب ذو أداء متزن بين الهجوم (يساهم كثيرا في بناء فرص الأهدافالأهداف المتوقعة) والدفاع (نسبة عالية من استعادة الكرة)"
        },
        8: {
          1: "مدافع قوى في المواجهات الفردية ويستعيد الكرة بنسب عالية، سواء من خلال التدخل أو من خلال قطع التمريرات."
        },
        9: {
          1: "لاعب ذو إسهامات هجومية كبيرة ,يصنع الخطورة و ويخلق الفرص"
        },
        10: {
          1: "لاعب متكامل يستحوذ على مساحة كبيرة من الملعب ولديه القدرة على استعادة الكرة وأيضا يساهم كثيرا في بناء فرص الأهداف المتوقعة لفريقه"
        },
        11: {
          1: "لاعب وسط ذو أداء دفاعي عالي وله فعالية كبيرة في التمرير على الرغم من قلة تأثيره في الهجوم."
        },
        12: {
          1: "لاعب وسط متكامل له تأثير ملحوظ في خلق فرص خطيرة ويجيد الألعاب الهوائية وأيضا ذو نسب كبيرة في قطع التمريرات والتدخل"
        },
        15: {
          1: "لاعب جناح ذو مهارة في المواجهات الفردية ولدية مستوى عالى في رفع العرضيات ويخلق فرص متوقعة أكثر من التسديدات"
        },
        16: {
          1: "لاعب يمرر كثيرا الكرات البينية ويجيد التقدم بالكرة ويخلق فرص وله تأثير في الاستحواذ في الوسط أكثر من الجناح"
        },
        17: {
          1: ".لاعب يجيد مهارة المراوغة، يتوغل من الخارج إلى الداخل ويخلق تسديدات (أهداف متوقعة) أكثر من تمريرات فتح اللعب (تمريرات حاسمة متوقعة)"
        },
        18: {
          1: "مهاجم يجيد التحرك بدون كرة حيث أن لديه قيمة عالية في الضغط الفردي الذي يتمثل في قطع التمريرات."
        },
        22: {
          1: " مهاجم يجيد التحرك لاستقبال الكرات البينية، والهروب نحو الأجناب وخلق فرص أهداف. نسبة عالية من اللمسات خارج المنطقة بالمقارنة بإجمالي اللمسات التي يقوم بها في كا مباراة."
        }
      },
      description: "الوصف",
      conjuction: " و ",
      conjuction2: " و ",
      over: "فوق",
      under: "تحت",
      respectively: ", على التوالي",
      Defending1: {
        1: " أدائه الدفاعي من بين الأسوء في الدوريات الخمس الكبرى"
      },
      Defending2: {
        1: "لا يقوم بدور جيد من الناحية الدفاعية لأن أدائة أقل من المتوسط"
      },
      Defending3: {
        1: "يقوم بدور جيد من الناحية الدفاعية لأن أدائه over_under_average في المعدل المتوسط"
      },
      Defending4: {
        1: "مستوى متميز في المهام الدفاعية مع مستوى أكثر من المتوسط"
      },
      Defending5: {
        1: "ممتاز في المهام الدفاعية وذو أداء مشابه player_positions في الدوريات الخمس الكبرى"
      },
      Saving1: {
        1: "حارس مرمى ذو أداء منخفض جدا ولديه صعوبات كثيرة في التصدي للكرة"
      },
      Saving2: {
        1: "لا يمارس دور حارس مرمى جيد لأنه أدائه أقل من المتوسط"
      },
      Saving3: {
        1: "حارس مرمى ذو أداء مقبول، متوسط مقارنة بالدوريات الخمس الكبرى، يجب أن يحسن في metric_name"
      },
      Saving4: {
        1: "حارس مرمى ذو مستوى جيد وأعلى من المتوسط في الدوريات الخمس الكبرى، يتميز بشكل خاص ب  metric_name"
      },
      Saving5: {
        1: "يعد حارس مرمى متكامل من ناحية تصديه للكرات و تمركزه. احصائياته بين أفضل ٢٠% حارس مرمى في الدوريات الخمس الكبرى الأوروبية."
      },
      Passing1: {
        1: "من ناحية تعامله مع الكرة بالقدمين يتواجد بين أسوء اللاعبين"
      },
      Passing2: {
        1: "بالنسبة للتمريرات، أدائه تحت المتوسط"
      },
      Passing3: {
        1: "أدائه مقبول من ناحية التمريرات، يتمركز بعض الشيئ over_under_average في المعدل"
      },
      Passing4: {
        1: "لاعب متميز في التمريرات، ذو مستوى جيد جدا في هذا الجانب، أعلى من المعدل بشكل كاف"
      },
      Passing5: {
        1: "ذو فعالية كبيرة في تمرير الكرات وأدائه أعلى من معظم اللاعبيين"
      },
      Aerial1: {
        1: "لاعب ضعيف جدا في الألعاب الهوائية، يتواجد بين أسوء اللاعبين في مركزه في هذا الجانب"
      },
      Aerial2: {
        1: "من ناحية انتزاع الكرة في الهواء، لا يتمتع اللاعب بمستوى جيد، حيث أنه أقل من المتوسط"
      },
      Aerial3: {
        1: "مستوى مقبول في الألعاب الهوائية، بعض الشيئ  over_under_average في المتوسط"
      },
      Aerial4: {
        1: "أداء عالي في الألعاب الهوائية، يتمتع بفعالية كبيرة في هذا الجانب"
      },
      Aerial5: {
        1: "تمركزه الاحصائيات في ألعاب الهواء بين أفضل اللاعبين "
      },
      Shooting1: {
        1: "الاحصائيات من ناحية مواجهة المرمى ضعيفة جدا، يتواجد بين أسواء اللاعبين في هذا الجانب"
      },
      Shooting2: {
        1: "المستوى من ناحية مواجهة المرمى يمكن تحسينه كثيرا، حيث أنه أقل من المتوسط"
      },
      Shooting3: {
        1: "الأداء مقبول من ناحية المهام الهجومية، بعض الشيئ over_under_average في المتوسط"
      },
      Shooting4: {
        1: "تعامل جيد جدا في منطقة الجزاء، يتمتع بمستوى يفوق ٦٠٪ من اللاعبين"
      },
      Shooting5: {
        1: "مهارة عالية في المهام الهجومية، يتمتع بأداء رائع، يتمركز بين أحسن اللاعبين في هذا الجانب"
      },
      Association1: {
        1: "أدائه مع الكرة ضعيف جدا، يتمركز بين أسوء اللاعبين في الدوريات الخمس الكبرى"
      },
      Association2: {
        1: " عليه أن يتحسن كثيرا في تعامله مع الكرة بقدميه، مستواه تحت المتوسط في هذا الجانب"
      },
      Association3: {
        1: "يتعامل جيدا مع الكرة، بعض الشيئ over_under_average في المتوسط"
      },
      Association4: {
        1: "يتعامل جيدا مع الكرة ويقدم مستوى متميز"
      },
      Association5: {
        1: "قدرة رائعة في التعامل مع الكرة بالقدمين، يتمركز بين أحسن اللاعبين في هذا الجانب"
      },
      BallHandling1: {
        1: "مستوى متدني في التحكم بالكرة، يتمركز بين أسوء اللاعبين في الدوريات الخمس الكبرى"
      },
      BallHandling2: {
        1: "فيما يتعلق بالتحكم بالكرة، أدائه أقل من المتوسط"
      },
      BallHandling3: {
        1: "مستوى مقبول من ناحية التحكم في الكرة، بعض الشيئ over_under_average في المتوسط"
      },
      BallHandling4: {
        1: "مستوى عالي فيما يتعلق بتحكمه بالكره، الاحصائيات تجعله قريبا من أفضل اللاعبين في هذا الجانب"
      },
      BallHandling5: {
        1: "قدرة استثنائية في التعامل مع الكرة، يتمركز بين أحسن اللاعبين في هذا الجانب"
      },
      Crosses1: {
        1: "أداء ضعيف في رفع الكرات نحو المنطقة، يتمركز بين أسوء اللاعبين في جانب احصائيات رفع الكرات"
      },
      Crosses2: {
        1: "أداء تحت المتوسط في خلق خطورة من خلال رفعاته للكرة"
      },
      Crosses3: {
        1: "مستوى مقبول، لكن يمكن تحسينة، في رفع الكرة نحو المنطقة، بعض الشيئ over_under_average المتوسط"
      },
      Crosses4: {
        1: "احصائيات جيدة فيما يتعلق برفع الكرة، أكثر من العادي بشكل كاف"
      },
      Crosses5: {
        1: "بين أفضل اللاعبين من ناحية رفع الكرة نحو المنطقة، وتحيدا بين ال ٢٠ الأفضل فعالية في هذا الجانب"
      },
      Carries1: {
        1: "بين ال ٢٠ لاعب ذوي الاحصائيات الأسوء فيما يتعلق بالسير بالكرة"
      },
      Carries2: {
        1: "أدائه في السير بالكرة بعيد من المتوسط بالمقارنة بلاعبين في نفس مركزه"
      },
      Carries3: {
        1: "أداء أقرب من المتوسط، بعض الشيئ over_under_average المتوسط، فيما يتعلق بالسير بالكرة"
      },
      Carries4: {
        1: "لاعب متميز وذو إحصائيات جيدة جدا فيما يتعلق بتوغله في الملعب والسير بالكرة"
      },
      Carries5: {
        1: "لاعب ماهر جدا في السير بالكرة، ذو أداء عال جدا فيما يتعلق بإحصائيات السير بالكرة"
      },
      Turnovers1: {
        1: "أداؤه سلبي للغاية مع حجم كبير من خسارة الكرة مما يسهل على الخصوم خلق الخطر. من بين الأسوأ في هذا المقياس"
      },
      Turnovers2: {
        1: " يفيد الخصوم بخسارته للكرة كثيرا في مناطق خطيرة، ويحتاج إلى التحسّن وتقليل خسارته للكرة"
      },
      Turnovers3: {
        1: "هذا اللاعب لديه مستوى over_under_average من حيث خسارة الكرة، لذلك لا يزال هناك مجال للتحسين في أدائه"
      },
      Turnovers4: {
        1: "أداء رائع في خسارة الكرة، أعلى من 60% من اللاعبين الذين يخسرون أقل عدد من الكرات"
      },
      Turnovers5: {
        1: "تجدر الإشارة إلى قلّة خسارتة الكرة، مما يجعله ضمن أفضل اللاعبين المستحوذين على الكرة لفريقه"
      },
      SequenceInvolvement1: {
        1: "فيما يتعلق باستحواذ الكرة، فإن الأرقام تتحدث بشكل سيء عن هذا اللاعب، ونادرًا ما ينهي حركاته بتسديدة"
      },
      SequenceInvolvement2: {
        1: "إن إنهائه لاستحواذ الكرة قابل للتحسين، فهو بالكاد ينهيها بتسديدة واحدة، وهذا يجعله أقل بكثير من المتوسط"
      },
      SequenceInvolvement3: {
        1: "مستوى مقبول عندما يتعلق الأمر بإنهاء الاستحواذ على الكرة أمام المرمى، بنسبة over_under_average، مع وجود إمكانية كبيرة للتحسين"
      },
      SequenceInvolvement4: {
        1: "قدرة جيدة على إنهاء استحواذ فريقه بالتسديدات التي ينتهي بعضها بالأهداف، وبذلك يقدم أداءً مميزاً في هذه الفئة"
      },
      SequenceInvolvement5: {
        1: "إنه من بين أفضل اللاعبين عندما يتعلق الأمر بإنهاء استحواذ فريقه، فهو ينهيها بتسديدات تولد الخطر"
      },
      OutPlay1: {
        1: "يمكننا ملاحظة أن اللاعب له تأثير ضئيل جداً عندما يتعلق الأمر بإرباك الهياكل الدفاعية",
      },
      OutPlay2: {
        1: "مساهمته في التقدم وكسر الدفاعات أقل من المعايير المعتادة لمركزه",
      },
      OutPlay3: {
        1: "قادر أحياناً على خلق أفضلية، ويؤدي بمستوى يقارب المتوسط لمركزه",
      },
      OutPlay4: {
        1: "يساهم كثيراً في كسر الخطوط الدفاعية وخلق عدم توازن",
      },
      OutPlay5: {
        1: "يُعتبر من بين الأفضل في مركزه في التخلص من المنافسين وخلق التقدم",
      },
      LineBreakingPasses1: {
        1: "نادراً ما يحاول أو ينجح في تمريرات تكسر الخطوط الدفاعية، ومساهمته في هذه الحالات شبه معدومة",
      },
      LineBreakingPasses2: {
        1: "يجد صعوبة في إيجاد زملاء بين الخطوط أو خلف الضغط بشكل منتظم، ومساهمته أقل من المعايير لمركزه",
      },
      LineBreakingPasses3: {
        1: "يقدم اللاعب تمريرات تكسر الخطوط من حين لآخر، ويقع في حدود المتوسط لمركزه",
      },
      LineBreakingPasses4: {
        1: "يمكننا ملاحظة أن اللاعب كثيراً ما يكسر الخطوط بتمريراته ويساعد على زعزعة كتل الخصوم",
      },
      LineBreakingPasses5: {
        1: "يعد من بين أفضل الممررين في الدوري في كسر الخطوط والتغلب على الضغط. هذه واحدة من أبرز نقاط قوته",
      },
      PassUnderPressure1: {
        1: "يبدو أنه يواجه صعوبة في الحفاظ على هدوئه أو فعاليته عند إغلاق المساحات من قِبل الخصوم",
      },
      PassUnderPressure2: {
        1: "هو لاعب يجد صعوبة في الحفاظ على دقة التمرير في مواقف الضغط العالي",
      },
      PassUnderPressure3: {
        1: "يقع اللاعب في حدود المتوسط من حيث التمرير تحت الضغط. يتعامل مع الضغط بشكل مقبول، لكن دون تنفيذ نظيف بشكل دائم",
      },
      PassUnderPressure4: {
        1: "نلاحظ أنه ينجح كثيراً في إيجاد زملائه رغم الضغط، ويؤدي فوق المتوسط في هذا النوع من التمريرات",
      },
      PassUnderPressure5: {
        1: "هدوء ودقة استثنائية عند التمرير تحت ضغط شديد. يُعتبر من بين الأفضل في مركزه في هذا الجانب",
      },
      BallReceived1: {
        1: "يتلقى عدداً قليلاً جداً من التمريرات في المناطق المتقدمة؛ ليس من اللاعبين الذين يتحركون بين الخطوط بانتظام",
      },
      BallReceived2: {
        1: "يحصل على بعض الاستلامات بدون رقابة في نصف ملعب الخصم، لكن دون انتظام كبير",
      },
      BallReceived3: {
        1: "يسجل متوسط عدد من الاستلامات بدون ضغط في المناطق الهجومية",
      },
      BallReceived4: {
        1: "يتلقى الكرة كثيراً بين الخطوط وفي مناطق خالية من الضغط",
      },
      BallReceived5: {
        1: "يجمع العديد من الاستلامات بين الخطوط، دون مدافعين وبمناطق مهمة",
      },
      OnBallPressure1: {
        1: "نادراً ما يضغط، ونادراً جداً قرب حامل الكرة. ليس لاعباً ذو شدة عالية",
      },
      OnBallPressure2: {
        1: "يقوم ببعض الضغط القوي، لكن ليس كثيراً. شدته العامة منخفضة نسبياً",
      },
      OnBallPressure3: {
        1: "يسجل متوسط عدد من الضغوط بالقرب من الخصم المستحوذ على الكرة",
      },
      OnBallPressure4: {
        1: "لاعب منضبط في الضغط، يقترب بانتظام من حامل الكرة",
      },
      OnBallPressure5: {
        1: "شديد النشاط بدون الكرة، منضبط للغاية ويعمل بجد للضغط على الخصم",
      },
      SpatialCoverage1: {
        1: "يُظهر اللاعب مساهمة محدودة جداً في شَغل والتحكم بالمساحات، مع مشاركة ضئيلة في تشكيل وهيكل الفريق التكتيكي. تغطيته للمساحات ضعيفة في الهجوم والدفاع، مما يعكس تأثيراً محدوداً على التنظيم الجماعي",
      },
      SpatialCoverage2: {
        1: "يقدم اللاعب تغطية للمساحات أقل من المتوسط، مع بعض المشاركة في شَغل الملعب لكن مع فجوات في الاستمرارية الموضعية والتناسق مع الفريق. تأثيره على الهيكل التكتيكي متقطع وأقل اتساقاً من اللاعبين الأعلى مستوى",
      },
      SpatialCoverage3: {
        1: "يعرض اللاعب تغطية للمساحات في حدود المتوسط، ويساهم بشكل مستقر في شَغل والتحكم بالمساحات. تمركزه صحيح ووظيفي في الغالب، ويشارك في الهيكل التكتيكي للفريق بتأثير معتدل في المرحلتين الهجومية والدفاعية",
      },
      SpatialCoverage4: {
        1: "يقدم اللاعب تغطية للمساحات فوق المتوسط، ويُظهر مشاركة عالية في شَغل الملعب وهيكل الفريق. قدرته على الحفاظ على الشكل والتكيف مع التحولات تسهم بشكل كبير في تماسك الفريق والتحكم في المساحات المهمة",
      },
      SpatialCoverage5: {
        1: "يصل اللاعب إلى مستوى ممتاز في تغطية المساحات، مع تحسين تمركزه للتأثير بشكل حاسم على تشكيل وهيكل الفريق التكتيكي. فهمه للعبة وتناسقه مع باقي الفريق يسمحان له بأقصى شَغل للمساحات الاستراتيجية في الهجوم والدفاع",
      },
      OffBallPressure1: {
        1: "يطبق اللاعب ضغطاً دفاعياً محدوداً للغاية بدون الكرة، ونادراً ما يهاجم الخصوم لتعطيلهم أو إجبارهم على الأخطاء. مساهمته في الضغط وهيكل الدفاع ضئيلة",
      },
      OffBallPressure2: {
        1: "يقدم اللاعب ضغطاً دفاعياً بدون الكرة أقل من المتوسط، ويتدخل أحياناً لكن بتوقيت أو تمركز غير ثابت. تأثيره على استعادة الاستحواذ أو تعطيل بناء الخصم محدود",
      },
      OffBallPressure3: {
        1: "يُظهر اللاعب مستوى متوسطاً من الضغط بدون الكرة، مساهماً بشكل ثابت في الجهد الدفاعي للفريق. تمركزه وتوقيته فعالان عموماً، ويطبق ضغطاً مناسباً لإبطاء أو الحد من خيارات الخصم",
      },
      OffBallPressure4: {
        1: "يقدم اللاعب ضغطاً دفاعياً بدون الكرة فوق المتوسط، مع تعطيل متكرر لخصومه وتقليل وقتهم ومساحتهم. جهوده منسقة جيداً، ما يساعد الفريق على الحفاظ على هيكل دفاعي قوي",
      },
      OffBallPressure5: {
        1: "يتفوق اللاعب في الضغط الدفاعي بدون الكرة، ويزعج الخصوم باستمرار، ويفرض فقدان الكرة ويحد من خيارات التمرير. شدته وتمركزه وقدرته على التوقع تعزز فعالية دفاع الفريق بشكل كبير",
      },
      Distance1: {
        1: "يغطي مسافة أقل بكثير من المتوسط (تحركاته في الملعب محدودة جداً)",
      },
      Distance2: {
        1: "المسافة التي يغطيها في المباراة أقل مما هو معتاد في كرة القدم عالية المستوى (أقل نشاطاً من المتوسط)",
      },
      Distance3: {
        1: "يغطي مسافة معقولة، بأرقام قريبة من متوسط الدوري (مشاركته البدنية متوازنة)",
      },
      Distance4: {
        1: "يغطي مسافات طويلة بانتظام، بأرقام تعكس قوة تحمل عالية (أداء بدني قوي)",
      },
      Distance5: {
        1: "حجمه البدني استثنائي. من بين الأكثر نشاطاً في الدوريات الخمس الكبرى من حيث المسافة المغطاة",
      },
      Sprint1: {
        1: "يقوم بعدد قليل جداً من الجري السريع مقارنة بالمتوسط (مجهود منخفض في العدو السريع خلال المباريات)",
      },
      Sprint2: {
        1: "وتيرة الجري السريع لديه أقل من المتوسط لمركزه (انفجار محدود في التحركات السريعة)",
      },
      Sprint3: {
        1: "يؤدي عدداً متوسطاً من الجري السريع في المباراة، ضمن المعدل المتوقع (قيم قريبة من متوسط الدوري)",
      },
      Sprint4: {
        1: "يبرز بكثرة الجري السريع، أعلى بكثير من المتوسط. يُظهر انفجاراً ثابتاً مع عدو سريع طوال المباراة",
      },
      Sprint5: {
        1: "من بين أعلى 20% من اللاعبين في حجم العدو السريع لكل 90 دقيقة. أداء بدني مميز في الجهد المتكرر عالي السرعة",
      },
      Acceleration1: {
        1: "قدرته على تغيير الإيقاع أقل من المتوسط بوضوح، إذ يقوم بعدد قليل جداً من التسارعات القوية خلال المباراة",
      },
      Acceleration2: {
        1: "عدد تسارعاته أقل من المتوسط مقارنة بلاعبين مشابهين بسبب قلة الانطلاقات القصيرة",
      },
      Acceleration3: {
        1: "يسجل عدداً معقولاً من التسارعات، قريباً من متوسط الدوري. تغييراته في الإيقاع لا تبرز، لكن أرقامه جيدة",
      },
      Acceleration4: {
        1: "يُظهر قدرة قوية على التسارع السريع والمتكرر، إذ معدل تسارعه أعلى من المتوسط بشكل واضح مع انطلاقات متكررة",
      },
      Acceleration5: {
        1: "من بين أعلى 20% من اللاعبين الأكثر انفجاراً من حيث التسارعات المتكررة، ويحافظ على أرقام أعلى بكثير من المتوسط في الانطلاقات وتغييرات الإيقاع",
      },
      Speed1: {
        1: "من المحتمل أنه لاعب بطيء بدنياً أو يدخر مجهودات عالية الشدة أثناء المباريات",
      },
      Speed2: {
        1: "يسجل سرعات قصوى أقل قليلاً من المتوسط التنافسي",
      },
      Speed3: {
        1: "يحافظ على قيم سرعة قصوى متوسطة طوال المباراة",
      },
      Speed4: {
        1: "يصل كثيراً إلى سرعات عالية، مما يدل على أنه سريع وقوي",
      },
      Speed5: {
        1: "يصل إلى سرعات قصوى عالية جداً. من المحتمل أن يكون حاسماً من حيث السرعة",
      },
      LineBreakingCarries1: {
        1: "نادراً ما يكسر الخطوط عبر الجري بالكرة. يفتقر للمبادرة في التقدم بالكرة",
      },
      LineBreakingCarries2: {
        1: "يكمل بعض الجري الذي يكسر الخطوط، لكن دون انتظام كبير",
      },
      LineBreakingCarries3: {
        1: "متوسط عدد الجري الناجح الذي يكسر الخطوط",
      },
      LineBreakingCarries4: {
        1: "يساهم في البناء بحمل الكرة كثيراً لتجاوز الخطوط ودعم التقدم",
      },
      LineBreakingCarries5: {
        1: "متخصص حقيقي في الجري بالكرة، يكسر الخطوط باستمرار وبحجم كبير",
      },
      LineBreakingActions1: {
        1: "يسجل عدداً قليلاً جداً من الأفعال التي تكسر الخطوط (تمريرات وجري). نادراً ما يخاطر",
      },
      LineBreakingActions2: {
        1: "ينتج بعض الأفعال التقدمية (تمريرات وجري)، لكن نادراً. يميل للعب بشكل أفقي أكثر",
      },
      LineBreakingActions3: {
        1: "يجمع بين التمريرات والجري التي تكسر الخطوط بانتظام. يساهم في التقدم",
      },
      LineBreakingActions4: {
        1: "ماهر وذكي في إنتاج العديد من الأفعال (تمريرات وجري) التي تكسر خطوط الخصوم",
      },
      LineBreakingActions5: {
        1: "متخصص حقيقي في التقدم. له تأثير كبير على فريقه، يكسر الخطوط باستمرار بالكرة من خلال التمريرات والجري",
      },
      OffBallRuns1: {
        1: "اللاعب يقوم بعدد قليل جداً من التحركات المتعمدة بدون الكرة، ويقدم دعماً محدوداً للمرحلة الهجومية. جريه بدون كرة نادراً ما يخلق مساحات أو يزعزع الدفاع أو يحسن التنسيق الجماعي في الاستحواذ",
      },
      OffBallRuns2: {
        1: "اللاعب يتحرك بدون الكرة بمستوى أقل من المتوسط، يدعم الهجوم أحياناً لكن يفتقر للاتساق في التوقيت أو الاتجاه أو النية التكتيكية. تأثير جريه على فتح المساحات أو تحسين البنية الهجومية محدود",
      },
      OffBallRuns3: {
        1: "اللاعب يظهر مستوى متوسط من التحركات المتعمدة بدون الكرة، يساهم بانتظام في المرحلة الهجومية. تحركاته غالباً ما تكون جيدة التوقيت ووظيفية، تخلق مساحات وتدعم اللعب الجماعي بتأثير معتدل",
      },
      OffBallRuns4: {
        1: "اللاعب يقدم نشاطاً فوق المتوسط بدون الكرة، يقوم كثيراً بتحركات متعمدة تزعزع الهياكل الدفاعية، تخلق خيارات تمرير وتفتح المساحات الهجومية. أنماط تحركاته تساهم بشكل كبير في تنسيق الفريق أثناء الاستحواذ",
      },
      OffBallRuns5: {
        1: "اللاعب يتفوق في التحركات المتعمدة بدون الكرة، يتوقع اللعب باستمرار ويقوم بجري ذكي يزيد من فرص الهجوم. توقيته، تمركزه ووعيه بالمكان يخلق تهديدات مستمرة ويحسن انسيابية الفريق في الاستحواذ",
      },
      OverMaxValue: {
        1: "أداء أعلى من القيمة القصوى في over_max_metric_name،  يجعل هذا اللاعب في هذا الجانب ضمن أفضل 10% من الدوريات الخمس الكبرى"
      },
      OverAverageSeason: {
        1: " فيما يتعلق بأدائه في over_average_metric_name فهو أعلى من متوسط الدوري league_name (over_average_metric_value مقابل average_metric_value)",
        2: "إذا قارنت أرقامه مع أرقام الدوري league_name، في over_average_metric_name يمكنك القول أن أدائه أعلى من المتوسط (over_average_metric_value vs average_metric_value)"
      },
      UnderMinValue: {
        1: "أما بالنسبة لـ under_min_metric_name، فمن المفترض أن يحسن أداءه بشكل كبير لأنه يضعه في أقل نسبة مئوية من بين أفضل 5 دوريات"
      },
      Over70Percent: {
        1: "ويبرز بشكل خاص في over_70_metric_name مع ما يزيد  over_70_metric_value لكل 90 دقيقة، على التوالي",
        2: "، أعلى من 70% في over_70_metric_name مع ما يزيد عن over_70_metric_value لكل 90 دقيقة، على التوالي",
        3: "أداء عمل أكثر من رائع في over_70_metric_name بأكثر من over_70_metric_value لكل 90 دقيقة، على التوالي"
      },
      Under30Percent: {
        1: "مضطرًا إلى العمل بجدية أكبر في under_30_metric_name  لأنه لديه أقل من under_30_metric_value لكل 90 دقيقة، على التوالي، يكون أدائه منخفضًا",
        2: "يجب أن تتحسن بشكل ملحوظ في under_30_metric_name  لأنه مع أقل من under_30_metric_value لكل 90 دقيقة، على التوالي، يكون أدائها أقل من المتوقع",
        3: "أما بالنسبة لـ under_30_metric_name بقيمة أقل من under_30_metric_value  لكل 90 دقيقة على التوالي، فعليه أن يبذل قصارى جهده للحصول على أرقام أفضل"
      },
      OverAverageSeasonMoreThanOne: {
        1: "من الجيد تسليط الضوء على أدائهم الذي يتجاوز متوسط ​​الدوري"
      },
      OverAverageStats: {
        1: "over_average_metric_name (over_average_metric_value مقابل average_metric_value في المتوسط)"
      },
      Over70PercentIndividualPressure: {
        1: "، القيام بضغط فردي جيد جدًا لاستعادة الكرة",
        2: "، الضغط العالي على الخصم لإرجاع الكرة"
      },
      Under30PercentIndividualPressure: {
        1: "عليه تكثيف ضغطه على الخصم لاستعادة الكرة أكثر",
        2: "، الاضطرار إلى بذل المزيد من الجهد من حيث الضغط على المنافس المعني"
      }
    },
    himSelf: "نفسه",
    ownSeason: "الموسم الخاص",
    minMaxTooltip: "تناسب الحد الأدنى والحد الأقصى لقيم الرادار"
  },
  login: {
    login: "تسجيل الدخول",
    latestBlogPosts: "أحدث مشاركات المدونة",
    signIn: "تسجيل الدخول",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    passwordForgotten: "نسيت كلمة المرور",
    signUp: "اشتراك",
    enter: "ادخل",
    forceTitle: "الحساب قيد الاستخدام",
    forceMessage: "الحساب متصل بالفعل بجهاز آخر. هل تريد طرد الجهاز الآخر وتوصيل الحساب في هذا الجهاز؟",
    forgotMyPassword: "نسيت كلمة المرور الخاصة بي",
    firstLogin: "تسجيل الدخول الأول",
    firstLoginMessage: "لأسباب أمنية، يجب عليك تعيين كلمة مرور جديدة عند تسجيل الدخول الأول. بالإضافة إلى اللغة المفضلة لعرض التطبيق",
    firstLoginOverview: "فيما يلي نظرة عامة على حسابك والبطولات والمنتجات التي يمكنك الوصول إليها.",
    passwordConfirmation: "تأكيد كلمة المرور",
    forgotPasswordMessage: "اكتب بريدك الإلكتروني، إذا كان هناك حساب صالح مرتبط بالبريد الإلكتروني  ستتلقى في صندوق الوارد الخاص بك الخطوات التالية لإعادة تعيين كلمة المرور الخاصة بك",
    resetPassword: "إعادة تعيين كلمة المرور",
    skipSettings: "تخطي الإعدادات",
    contact: "الاتصال",
    cookiesText: "يستخدم هذا الموقع ملفات تعريف الارتباط من Google لتقديم خدماته وتحليل حركة المرور لضمان جودة الخدمة، وإنشاء إحصاءات الاستخدام، واكتشاف ومعالجة الانتهاكات.",
    contactUs: "اتصل بنا",
    newsTitle: "جديد: قوالب جديدة!",
    newsText: "قمنا بتحديث قوالب الرادار، الإحصائيات، والمواسم لنقدم لك مزيدًا من التخصيص والتحكم. يمكنك الآن إنشاء وتعديل وتنظيم قوالبك الخاصة، مع إمكانية اختيار أن تكون عامة، خاصة أو خاضعة للإشراف. بالإضافة إلى ذلك، ستساعدك قوالب الإحصائيات والمواسم على تحسين سير عملك من خلال اختيارات أدق وأكثر توافقًا مع احتياجاتك. استكشف الخيارات الجديدة في قسم القوالب بالشريط الجانبي!"      
  },
  settings: {
    language: "لغة",
    availableLeagues: "الدوريات المتاحة",
    availableProducts: "المنتجات المتاحة",
    organization: "شركة",
    changePassword: "تغيير كلمة المرور",
    seasonTemplates: "قوالب المواسم",
    seasonTemplatesSubtitle: "قم بإنشاء قوالب الموسم الخاصة بك والتي ستكون متاحة لاحقًا للاختيار في تصنيف اللاعب وكشاف اللاعب",
    templateName: "اسم القالب",
    selectTemplate: "حدد القالب لتحريره",
    radarDefault: "الرادار الافتراضي",
    default: 'تقصير',
    tabs: {
      options: "خيارات",
      templates: "القوالب",
      availableLeagues: "دوريات متاحة",
      contactData: "بيانات الاتصال بـ GBE"
    },
    contactData: {
      userDetails: "بيانات المستخدم",
      firstName: "الاسم",
      lastName: "اللقب",
      contactDetails: "بيانات التواصل بـ GBE",
      name: "الاسم",
      phone: "الهاتف",
      mobile: "المحمول",
      email: "البريد الالكتروني",
      representativeDetails: "بيانات الوكيل"
    },
    currency: "العملة",
    fieldPreferences: "إعدادات الملعب",
    visualizationsPreferences: "إعدادات الرؤية",
    fieldColor: "لون الملعب",
    fieldColors: {
      green: "أخضر",
      blue: "أزرق",
      white: "أبيض",
      black: "أسود",
      grey: "رمادي"
    },
    defaultPlayerVisualization: "رؤية اللاعب المعدة تلقائيا",
    appPreferences: "خيارات التطبيق",
    darkMode: "رؤية قاتمة",
    showTour: "اعرض الجولة الإرشادية",
    customStats: "إحصائيات محددة",
    radarTemplates: "قوائم رادار",
    radarTemplatesSubtitle: "إنشاء قوائم بمقاييس يمكن اختيارها بخصوص أداء اللاعبين وتصنيفهم",
    radarCategories: {
      Custom1: "تحديد حسب الطلب ١",
      Custom2: "تحديد حسب الطلب ٢",
      Custom3: "تحيد حسب الطلب ٣",
      Custom4: "تحديد حسب الطلب ٤",
      Custom5: "تحديد حسب الطلب ٥",
      Custom6: "تحديد حسب الطلب ٦",
      Physical: "بدني",
      CustomPhysical1: "تحديد حسب الطلب بدني ١",
      CustomPhysical2: "تحديد حسب الطلب بدني ٢",
      CustomPhysical3: "تحيد حسب الطلب بدني ٣",
      CustomPhysical4: "تحديد حسب الطلب  بدني ٤",
      CustomPhysical5: "تحديد حسب الطلب  بدني ٥",
      CustomPhysical6: "تحديد حسب الطلب  بدني ٦",
    },
    templateRemoveTitle: "حذف رادار",
    templateRemoveMsg: "هل بالفعل ترغب في حذف الرادار؟",
    templateEditTitle: "حفظ القالب",
    templateEditMsg: "يوجد قالب غير محفوظ، هل تريد حفظه قبل تحميل قالب آخر لتحريره؟",
    category: "تصنيف",
    playerRadar: "رادا لاعب",
    teamRadar: "رادار الفريق",
    statsAlert: "ادخل على الأقل إحصائية واحدة للحفظ",
    recommended: "منصوح به",
    warning: "هناك مواقع وصلت إلى الحد الأقصى لعدد الرادارات المسموح بها. يرجى حذف أو تعديل أي قالب",
    fieldPositions: {
      default: "دريبلاب",
      fifa: "فيفا",
      spanish: "الإسبانية",
      numeric: "رقمي"
    },
    showMediaMode: 'عرض وضع الوسائط',
    statTemplates: "قوالب إحصائيات اللعبة",
    statTemplatesSubtitle: "قم بإنشاء قالب الإحصائيات الخاص بك والذي سيتم عرضه لاحقًا في جدول الإحصائيات للعبة",
  },
  playerDetail: {
    passport: "جواز سفر ",
    secondPassport: "جواز سفر تاني",
    age: "العمر",
    dateOfBirth: "تاريخ الميلاد",
    height: "الطول (سم)",
    weight: "الوزن (كجم)",
    wage: "الراتب",
    history: "المسيرة",
    positions: "المراكز",
    injuries: "الإصابات",
    transfers: "التنقلات",
    nationalTeam: "المنتخب",
    addFavorite: "إضافة إلى القائمة المفضلة",
    removeFavorite: "حذف من القائمة المفضلة",
    contractEnd: "نهاية العقد",
    yearsOld: " سنة",
    playerAvailability: "التوفر",
    playerUsage: "دقائق اللعب",
    usage: "الاستخدام",
    addToCollection: "إضافة إلى مجموعة",
    performance: "الأداء",
    info: "المعلومات",
    career: "مسيرة",
    playerStyle: "الأساليب",
    radar: "رادار",
    finishingMap: "خريطة الانهاء",
    threatMap: "خريطة الخطورة",
    keyPassMap: "خريطة التمريرات الحاسمة",
    beeswarm: "التصنيف",
    allGames: "جميع المباريات",
    eventsMap: "خريطة الفعاليات",
    fullName: "الاسم بالكامل",
    academy: "الأكاديمية",
    name: "الاسم",
    lastName: "اللقب",
    playerAvailabilityLong: "٪ من الموسم بدون إصابات أو توقفات",
    playerUsageLong: "دقائق لعب",
    playerAvailability1: "مباريات بدون إصابات أو توقفات",
    playerAvailability2: "مباريات هذا الموسم",
    playerUsage1: "دقائق اللعب",
    playerUsage2: "إجمالي دقائق الفريق",
    notMinutesThisSeason: "لم يلعب دقائق هذا الموسم",
    seasonPlaceholder: "لا يوجد موسم فعال",
    inactivePlayer: "لاعب غير فعال",
    inactivePlayerMessage: "إذا كنت ترغب في المزيد من المعلومات يمكنك طلب تقرير!",
    goRequest: "الذهاب للطلب",
    warningMinutes: "احذر! أقل من 450 دقيقة لعب، التحليل قد لايكون مماثل للواقع",
    warningSeasonGames: "موسم بأقل من 5 مباريات لعب، الحد الأدني والحد الأقصى اختيرا من الدوريات الخمس الكبرئ",
    warningStatsRemoved: 'بعض الإحصائيات غير معروضة لأنها غير متوفرة للموسم المحدد.',
    warningBeeswarm: "لم يتم عرض اللاعب لأنه لا توجد بيانات متاحة للموسم المحدد.",
    warningPlayersZeroValue: "عدم عرض {x} 0 لاعبين برصيد ",
    onlyPlayersThatFit: "فقط اللعبون الذين يتناسبون مع قائمة رادار",
    gamesPlayedNotEnough: "تم تعطيل الخيارات بسبب عدم كفاية عدد المباريات التي تم لعبها",
    gbe: "GBE",
    analysis: "التحليل",
    documents: "المستندات",
    rankDefensive: "دفاعي",
    rankBallHandling: "التعامل مع الكرة",
    rankGoal: "إسهامة في الهدف",
    rankXt: "الخطورة",
    rankIndex: "المقياس",
    visitHistory: "أرشيف الزيارات",
    placer: "الملعب",
    touchesMap: "خريطة اللمسات",
    heatMap: "خريطة اللون",
    ageProfile: "العمر",
    strongFoot: "القدم التي يجيد بها اللعب",
    player: "لاعب",
    outOf: "من",
    in: "في",
    careerTable: {
      nationalTeamCareer: "مسيرة الفريق الوطني",
      nationalTeamCompetitions: "مسابقات الفريق الوطني"
    },
    physicalProgression:"Physical Progression",
    gpi: "مؤشر اللاعبين العالمي",
    warningGPI: "متاح فقط للاعبين النشطين في دوريات ELO خلال آخر 30 يومًا",
    diffGPI: "التغير عن المباراة الأخيرة",
    rankingInTheWorld: "#{0} في العالم",
    rankingInTheLeague: "#{0} في {1}",
    max: "الحد الأقصى",
    gpiChart: "رسم بياني يعتمد على قيمة مؤشر اللاعبين العالمي في آخر {0} مباريات"
  },
  finishingMap: {
    typesOfShot: "أنواع التسديدات",
    shotStrategy: "استراتيجية التسديدات",
    areas: "المناطق",
    bodyPart: "جزء من الجسم",
    more: "أكثر",
    selectAll: "اختار الكل",
    minutes: "دقائق",
    circles: "دوائر",
    boxes: "صناديق",
    lines: "خطوط",
    games: "مباريات",
    perShot: "لكل تسديدة",
    goal: "هدف",
    missedShot: "تسديدة ضائعة",
    savedShot: "تسديدة تم التصدى لها",
    shotOnPost: "تسديدة في القائم",
    missedChance: "فرصة ضائعة",
    openPlay: "أثناء اللعب",
    regularPlay: "اللعب العادي",
    fastBreak: "في الهجمة المرتدة",
    individualPlay: "في لعبة فردية",
    setPiece: "في الكرة الثابتة",
    fromCorner: "من ضربة الزاوية",
    freeKick: "من الضربة الحرة",
    indirectFreeKick: "من الضربة الحرة الغير المباشرة",
    throwInSetPiece: "من رمية التماس",
    inBox: "داخل منطقة الجزاء",
    goalArea: "داخل منطقة الست أمتار",
    boxLeft: "يسار منطقة الجزاء",
    boxCenter: "وسط منطقة الجزاء",
    boxRight: "يمين منطقة الجزاء",
    outOfBox: "خارج منطقة الجزاء",
    outBoxDeepLeft: "خارج منطقة الجزاء في عمق اليسار",
    outBoxDeepRight: "خارج منطقة الجزاء في عمق اليمين",
    outBoxLeft: "خارج منطقة الجزاء اليسار",
    outBoxCentreLeft: "خارج منطقة الجزاء وسط اليسار",
    outBoxCentre: "خارج منطقة الجزاء الوسط",
    outBoxCentreRight: "خارج منطقة الجزاء وسط اليمين",
    outBoxRight: "خارج منطقة الجزاء -اليمين",
    left35: "+35 اليسار",
    centreLeft35: "وسط اليسار +35",
    centre35: " +35الوسط ",
    centreRight35: "وسط اليمين +35",
    right35: "اليمين +35",
    head: "بالرأس",
    rightFooted: "قدم اليمنى",
    leftFooted: "قدم يسرى",
    otherBodyPart: "أخرى",
    chart: {
      shots: "تسديدات",
      xGPerShot: "الأهداف المتوقعة لكل تسديدة",
      exceptionTextPenaltyGoals: "* تسديدات الجزاء = 0.765 xG",
      exceptionTextGKPenaltyGoals: "* تسديدات الجزاء = 0.765 xGOT",
      exceptionTextOwnGoals: "* أهداف عكسية غير محتسبه ",
      og: "هدف عكسي",
      penaltiesExcluded: "أهداف من ضربات جزاء غير محتسبة",
      ownGoalsExcluded: 'تم استبعاد الأهداف الخاصة',
      sumOfxG: "إجمالى الأهداف المتوقعة",
      exceptionShotsOutOfRange: "* لا يعرض التسديدات خارج النطاق"  
    },
    inGoal: "في المرمى",
    outOfGoal: "خارج المرمى",
    highLeft: "أعلى اليسار",
    highCenter: "أعلى  الوسط",
    highRight: "أعلى اليمين",
    lowLeft: "أسفل اليسار",
    lowCenter: "أسفل الوسط",
    lowRight: "أسفل اليمين",
    outHighLeft: "خارج أعلى اليسار",
    high: "خارج أعلى الوسط",
    outHighRight: "خارج أعلى اليمين",
    closeHighLeft: "بالقرب أعلى اليسار",
    closeHigh: "بالقرب من أعلى الوسط",
    closeHighRight: "بالقرب من أعلى اليمين",
    closeLeft: "بالقرب من أسفل اليسار",
    closeRight: "بالقرب من أسفل اليمين",
    finishingTable: "جدول الانهاء",
    onGoal: "على المرمى",
    distributionFilters: "مرشحات التوزيع",
    penalty: "ركلة جزاء",
    penaltyShootout: "ركلات الترجيح",
    onlyPercentage: "عرض النسبة المئوية",
    showAll: "عرض الكل"
  },
  keyPassMap: {
    chart: {
      keyPasses: "تمريرات مفتاحية",
      xAPerPass: "نسبة التمريرات الحاسمة المتوقعة عن كل تمريرة",
      xAOpenPlay: "نسبة التمريرات الحاسمة المتوقعة من الكرة في وضع اللعب",
      xASetPiece: "نسبة التمريرات الحاسمة المتوقعة من الكرة في وضع الثبات"
    }
  },
  beeswarm: {
    template: "القائمة",
    templates: {
      Goalkeeper: "حارس مرمى",
      Defender: "مدافعون",
      "Full-Back": "ظهير دفاعي",
      FullBack: "ظهير دفاعي",
      "Wing-Back": "جناح خلفي",
      WingBack: "جناح خلفي",
      Midfielder: "لاعب وسط",
      AttackingMidfielder: "لاعب وسط هجومي",
      Winger: "جناح",
      Forward: "مهاجمون",
      Physical: "بدني"
    },
    compareWith: "مقارنة مع",
    highlightPlayersOf: "إظهار لاعبو",
    highlightPlayers: "تسليط الضوء على اللاعبين",
    per90: "بيانات عن كل ٩٠ دقيقة من اللعب",
    highlightTeams: "تسليط الضوء على الفرق",
    filterTeams: "تصفية الفرق",
    warningZeros: "فقط للإحصائيات غير المعكوسة"
  },
  collections: {
    newCollection: "مجموعة جديدة",
    editCollection: "تعديل مجموعة",
    name: "الاسم",
    visibility: "إظهار",
    privacity: {
      publicTitle: "عامة",
      publicDescription: "ظاهرة لك ولكل ناديك",
      privateTitle: "خاصة",
      privateDescription: "ظاهرة فقط لك",
      supervisedTitle: "تم الإشراف عليها",
      supervisedDescription: "ظاهرة لك ولمشرفك"
    },
    addSuccess: "تمت الإضافة بنجاح",
    createAddSuccess: "تم الإنشاء والإضافة بنجاح",
    deleteSuccess: "تم الحذف بنجاح",
    editSuccess: "تم التحديث بنجاح",
    title: "مجموعات اللاعبين",
    publics: "عامة",
    privates: "خاصة",
    supervised: "تم الإشراف عليها",
    totalMarketValue: "قيمة السوق الإجمالية",
    avgMarketValue: "قيمة السوق المتوسطة",
    avgAge: "متوسط العمر",
    searchBarPlaceholder: "ابحث عن لاعب وقم باختياره لإضافته إلى المجموعة",
    deleteCollection: "حذف مجموعة",
    deleteCollectionMessage: "سيتم حذف المجموعة. هل أنت متأكد؟",
    removePlayer: "حذف لاعب",
    removePlayerMessage: "سيتم حذف اللاعب من المجموعة. هل أنت متأكد؟",
    subtitle: "رتب بحثك",
    notExitingTemplate: 'لا يوجد حتى الآن قوالب',
  },
  searchbar: {
    placeholder: "اكتب للبحث (مثال: `sergio sevilla´)",
    players: "اللاعبون",
    teams: "الفرق",
    games: "المباريات",
    leagues: "الدوريات",
    explore: "استكشف النتاذج",
    placeholderNoResults: "لا توجد نتائج للقائمة",
    teamPlaceholder: "لمقارنة لاعب, ابحث عنه وقم باختياره"
  },
  favorites: {
    showOnly: "اظهار فقط",
    selfFavorites: "المفضلة لي",
    clubFavorites: "المفضلة لنادي",
    contractExpiration: "انتهاء العقد",
    groupBy: "تجميع على أساس",
    noGrouped: "بدون تجميع",
    maxSelection: "الحد الاقصى",
    selectAtleastOne: "اختر واحد على الأقل",
    comparePlayers: "مقارنة لاعبين",
    selectedPlayers: "المختارون",
    subtitle: "استمر في تتبع نجوم المستقبل",
    generateXlsx: "إنشاء XLSX",
    generating: "قيد الإنشاء...",
    subscribed: "Subscribed",
    subscribedTooltip:"Subscribe to recieve a mail when a game have been played"
  },
  expiration: {
    summer: "الصيف",
    winter: "الشتاء"
  },
  positions: {
    goalkeepers: "حراس مرمى",
    defenses: "مدافعون",
    midfielders: "لاعبو الوسط",
    goalkeeper: "حارس مرمى",
    defender: "مدافع",
    defenders: "مدافعون",
    fullback: "مدافع ظهير",
    fullbacks: "مدافعون أظهرة",
    midfielder: "لاعب وسط",
    winger: "لاعب جناح",
    wingers: "لاعبو جناح",
    forward: "مهاجمون",
    forwards: "مهاجمون",
    wingback: "لاعب جناح خلفي",
    wingbacks: "لاعبو الأحنحة الخلفيون",
    noposition: "بدون مركز"
  },
  dPos: {
    1: {
      name: "حارس مرمى",
      alias: ""
    },
    2: {
      name: "الظهير الأيمن",
      alias: "RFB"
    },
    3: {
      name: "مركز الظهير الأيمن",
      alias: "RCB"
    },
    4: {
      name: "مركز الظهير الأيسر",
      alias: "LCB"
    },
    5: {
      name: "الظهير الأيسر",
      alias: "LFB"
    },
    6: {
      name: "لاعب خط وسط دفاعي",
      alias: "DM"
    },
    7: {
      name: "الجناح الأيمن",
      alias: "DM"
    },
    8: {
      name: "لاعب خط وسط",
      alias: "CM"
    },
    9: {
      name: "لاعب مهاجم",
      alias: "ST"
    },
    10: {
      name: "لاعب وسط مهاجم",
      alias: "AM"
    },
    11: {
      name: "الجناح الايسر",
      alias: "LW"
    }
  },
  charts: {
    seasonsCompareSelectLabel: "قارن مع",
    lastSeasonSelectText: "الموسم السابق",
    lastAndCurrentSeasonSelectText: "الموسم السابق + الحالي",
    currentSeasonSelectText: "الموسم الحالي",
    last20gamesSelectText: " آخر ٢٠ مبارة ",
    last10gamesSelectText: "آخر ١٠ مبارات",
    npgVsXGTitle: "الأهداف بدون ضربات جزاء VS الأهداف المتوقعة",
    totalXGLabel: "إجمالي الأهداف المتوقعة",
    xGLabel: "الأهداف المتوقعة",
    totalNPGLabel: "إجمالى الأهداف بدون ضربات جزاء",
    xGAgainstvsNPGAgainstTitle: "الأهداف المتوقعة عليه VS الأهداف بدون ضربات جزاء عليه",
    totalXGAgainstLabel: "إجمالي الأهداف المتوقعة عليه",
    xGAgainstLabel: "الأهداف المتوقعة عليه",
    totalNPGAgainstLabel: "إجمالي الأهداف المتوقعة عليه بدون ضربات جزاء ",
    xGvsxGAgainstTitle: "الأهداف المتوقعة VS الأهداف المتوقعة عليه",
    pointsVsXPointsTitle: "النقاط المكتسبة VS النقاط المتوقعة",
    xTTitle: "سير المباريات",
    totalXPoints: "إجمالي النقاط المتوقعة",
    totalPoints: "إجمالي النقاط",
    requestedReports: "التقارير المطلوبة",
    playersScouted: "اللاعبون الذين تم مراقبتهم",
    performanceVSAverageChart: "الأداء VS المتوسط",
    perPositions: "على أساس المركز",
    perLeagues: "على أساس الدوريات",
    perMonths: "على أساس الأشهر",
    perClients: "على أساس العملاء",
    ofPreposition: "من",
    idJChartTitle: "مبادرة اللعب",
    idJChartLabel: "مؤشر GI",
    vJOChartTitle: "حجم اللعب الهجومي",
    vJOChartLabel: "مؤشر OGV",
    preJOChartTitle: "دقة اللعب الهجومي",
    preJOChartLabel: "مؤشر OGPre",
    proJOChartTitle: "تطور اللعب الهجومي",
    proJOChartLabel: "مؤشر OGPro",
    chart: "الرسم البياني",
    table: "الجدول"
  },
  table: {
    history: {
      season: "موسم",
      team: "فريق",
      position: "مركز",
      side: "جانب",
      games: "مباريات",
      minutes: "دقائق",
      goals: 'NPG (G)',
      assists: 'A',
      yellowCards: 'YC',
      redCards: 'RC',
      gameLost: 'GM',
      gamesMissed: "مباريات غائب"
    },
    injury: {
      season: "موسم",
      team: "فريق",
      injury: "إصابة",
      dateFrom: "تاريخ البداية",
      dateTo: "تاريخ الانتهاء",
      daysLost: "الأيام المفقودة",
      gamesLost: "المباريات الخاسرة",
      allInjuries: "جميع الإصابات"
    },
    transfers: {
      season: "موسم",
      date: "تاريخ",
      teamFrom: " الفريق من",
      teamTo: " فريق الوجهة",
      marketValue: "القيمة السوقية",
      fee: "تكلفة",
      type: "يكتب"
    },
    caps: {
      team: "فريق",
      debut: "أول مباراة",
      games: "مباريات",
      goals: "أهداف",
      coachDuringDebut: "المدرب أثناء أول مباراة",
      debutAge: "العمر في أول مباراة"
    },
    roster: {
      country: "البلد",
      player: "اللاعب",
      positions: "المراكز",
      minutes: "الدقائق",
      games: "المباريات",
      goals: "الأهداف",
      assists: "التمريرات الحاسمة",
      cards: "البطاقات",
      gamesExplicit: "المباريات الملعوبة",
    },
    league: {
      team: "الفريق",
      games: "المباريات الملعوبة",
      gamesExplicit: "المباريات الملعوبة",
      gamesRanking: "GP",
      gamesRankingExplicit: "المباريات الملعوبة",
      points: "نقاط",
      pointsExplicit: "نقاط",
      expectedPoints: "النقاط المتوقعة",
      expectedPointsExplicit: "النقاط المتوقعة",
      goalsScored: "NPG",
      goalsScoredExplicit: "أهداف غير ركلات الجزاء",
      xG: "xG",
      xGExplicit: "الأهداف المتوقعة",
      goalsAgainst: "NPGA",
      goalsAgainstExplicit: "أهداف غير ركلات الجزاء عليه",
      xGAgainst: "xGA",
      xGAgainstExplicit: "أهداف متوقعة عليه",
      xGAgainstDiff: "فرق xGA",
      xGAgainstDiffExplicit: "الأهداف المتوقعة عليه ضد الفرق",
      form: "شكل",
      sos: "SoS",
      sosExplicit: "صعوبة الجدول",
      sosHfa: "SoS HFA",
      sosHfaExplicit: "ميزة اللعب كمضيف",
      difficultyAboveAvg: "صعوبة تفوق المتوسط",
      differentGames: "* عدد مختلف من المباريات الملعوبة",
      berth: "النتيجة"
    },
    usersOfClient: {
      userName: "الاسم",
      userRole: "المستخدم",
      devRole: "المطور",
      adminRole: "المدير",
      servicesRole: "الخدمات",
      xgRole: "XG",
      radarRole: "رادار",
      beeswarmRole: "التصنيف",
      elevenRole: "أحد عشر",
      similarityRole: "تشابه",
      gameAnalysisRole: "تحليل اللعبة",
      clientStatsRole: "إحصائيات العميل",
      created: "تاريخ الإنشاء",
      type: "النوع",
      logins: "مرات الدخول",
      lastLogin: "آخر دخول",
      trialDate: "تاريخ الانتهاء"
    },
    clientLeagues: {
      league: "الدوري",
      area: "المنطقة",
      tier: "المستوى",
      seasons: "المواسم",
      currentMatchDay: "يوم المبارات",
      regular: "عادى",
      youthLeague: "شاب",
      clientActive: "فعال",
      visibleLeagues: "الدوريات المرئية"
    },
    connections: {
      title: "المجوعات الأكثر شيوعا",
      playerFrom: "من اللاعب",
      playerTo: "الى اللاعب",
      passes: "تمريرات",
      passesTooltip: "العدد الإجمالي لتمريرات الصائبة",
      passesFinalThird: "PF ⅓",
      passesFinalThirdTooltip: "تمريرات الثلث الأخير"
    },
    playerPassMapData: {
      title: "إحصائيات التمرير",
      player: "اللاعب",
      passes: "التمريرات",
      passesPct: "% التمريرات",
      xA: "xA",
      xG: "xG",
      xT: "xThreat",
      playerTooltip: "اسم اللاعب",
      passesTooltip: "إجمالي التمريرات الملعوبة",
      passesPctTooltip: "نسبة التمريرات الصائبة",
      xATooltip: "التمريرات الحاسمة المتوقعة",
      xGTooltip: "الأهداف المتوقعة",
      xTTooltip: "الخطر المتوقع"
    },
    playerAllGames: {
      gameDate: "التاريخ",
      game: "المباراة",
      Team: "الفريق",
      positionsPlayed: "المراكز",
      minsPlayed: "الدقائق",
      gameActions: "تصرفات",
      gameDateTooltip: "تاريخ المباراة",
      gameTooltip: "المباراة",
      positionsPlayedTooltip: "المراكز التي لعب فيها",
      minsPlayedTooltip: "دقائق اللعب",
      gameActionsTooltip: "أهداف ,تمريرات حاسمة .بطاقات",
      from: "من",
      to: "إلى",
      goalText: "الهدف في",
      assistText: "التمريرة الحاسمة في",
      penaltyText: "ضربة جزاء في ال",
      ownGoalText: "هدف في مرماه في ال",
      yellowCardText: "بطاقة صفراء في ال",
      secondYellowCardText: "ثاني بطاقة صفراء في ال",
      redCardText: "بطاقة حمراء في ال",
      substitutionIN: "يدخل في ال",
      substitutionOUT: "يخرج في ال",
      suspendedText: "معاقب"
    },
    gameFlow: {
      phase: "المرحلة ",
      mins: "الدقاذق",
      team: "الفريق",
      period: "المدة",
      possession: "احتمالية.",
      possessionTooltip: "الاستحواذ",
      xT: "xThreat",
      xTTooltip: "الخطورة المتوقعة",
      pft: "ف…",
      pftTooltip: "تمريرات في الثلث الأخير",
      xG: "xG",
      xGTooltip: "أهداف متوقعة"
    }
  },
  game: {
    header: {
      gameDetails: "تفاصيل",
      gameStats: "إحصائيات",
      gameFinishingMap: "خريطة الأنهاء",
      gameKeyPassMap: "خريطة التمريرات المفتاحية",
      gamePassMap: "خريطة التمريرات",
      gameThreat: "خريطة الخطر",
      gameFlow: "المباراة في التحكم",
      gameAnalysis: "تحليل المباراة",
      possessions: "الاستحواذ",
      bench: "مقاعد",
      video: "فيديوهات مميزة"
    },
    passMap: {
      team: "الفريق",
      minutes: "الدقائق:",
      select: "اختر",
      all: "الكل",
      attacking: "هجوم",
      defending: "دفاع",
      forwards: "هجوم",
      backwards: "خلف",
      sideways: "على الأجناب",
      longBall: "تمريرة طويلة",
      successfullPasses: "تمريرات مكتملة",
      homeTeam: "المضيف",
      awayTeam: "الزائر"
    },
    stats: {
      summary: "مختصر",
      attacking: "هجوم",
      defending: "دفاعية",
      contribution: "مساهمة",
      possession: "استحواذ",
      expectedPoints: "نقاط متوقعة",
      directness: "المباشرة",
      ppda: "PPDA",
      xg: "xG",
      xG: "xG",
      xGSetPiece: "xG كرة ثابتة",
      xA: "xA",
      xASetPiece: "xA كرة ثابتة ",
      xT: "xT",
      xTSetPiece: " xT كرة ثابتة ",
      touchesInOppBox: "لمسات في منطقة المنافس",
      passesFinalThird: "تمريرات في الثلث الأخير",
      interceptions: "قطع الكرة",
      recoveries: "استعادة الكرة",
      recoveriesOppHalf: "استعادة الكرة في ملعب المنافس",
      tackles: "التدخلات",
      tacklesWasDribbled: "تدخلات / تمت مراوغته",
      fouls: "أخطاء",
      yellowCards: "بطاقات صفراء",
      redCards: "بطاقات حمراء",
      passes: "تمريرات",
      passing: "نسبة التمريرات",
      crosses: "الرفعات",
      crossing: "نسبة الرفعات",
      shots: "تسديدات",
      shotsOnTarget: "تسديدات على المرمى",
      ppdaExplicit: "تمريرات المقبولة من حركات دفاعية",
      xgExplicit: "أهداف متوقعة",
      xp: "xP",
      seasonAvg: "معدل المسابقة",
      winChance: "احتمالية الفوز",
      postGameWinChance: "احتمالية الفوز بعد المباراة",
      winChanceTooltip: "على أساس الأهداف المتوقعة المصنوعة والممنوحة",
      drawChance: "تعادل",
      xgAgainst: "xG عليه",
      averagePossession: "معدل الاستحواذ",
      averageShots: "معدل التسديدات",
      averagexG: "معدل الأهداف المتوقعة"
    },
    detail: {
      halfTime: "ما بين الشوطين",
      overTime: "وقت مستقطع",
      showStats: "إظهار إحصائية",
      hideStats: "إخفاء إحصائية",
      bench: "مقاعد",
      showShotOptions: "إظهار خيارات التسديد",
      hideShotOptions: "إخفاء خيارات التسديد",
      showPassOptions: "إظهار خيارات التمرير",
      hidePassOptions: "إخفاء خيارات التمرير",
      endGame: "نهاية المباراة",
      penalties: "ضربات الجزاء"
    },
    timeline: {
      events: {
        goal: "هدف",
        goal_ownGoal: "هدف عكسي",
        goal_penalty: "هدف من ضربة جزاء",
        card: "بطاقة",
        card_yellowCard: "بطاقة صفراء",
        card_secondYellowCard: "ثاني بطاقة صفراء ",
        card_redCard: "بطاقة حمراء",
        formationChange: "تغيير التشكيلة",
        substitution: "بديل",
        saveShot: "تسديدة تم التصدي لها  ",
        saveShot_penalty: "ضربة جزاء تم التصدي لها",
        missedShot: "تسديدة ضائعة",
        missedShot_penalty: "ضربة جزاء ضائعة",
        shotOnPost: "تسديدة في القائم",
        shotOnPost_penalty: "تسديدة  من ضربة جزاء  في القائم"
      }
    },
    gameFlow: {
      goalOf: " هدف من",
      redCardTo: "بطاقة  حمراء ل",
      missedPenalty: "ضربة جزاء ضائعة "
    },
    gameThreat: {
      typeOfPlay: "نوع التصرف",
      regularPlay: "أثناء اللعب",
      setPiece: "كرة ثابتة",
      setPiecePlay: "كرة ثابتة",
      throwInSetPiecePlay: "رمية تماس",
      throwInPlay: "رمية تماس",
      actionEnding: "طريقة الإنهاء",
      pass: "تمريرة",
      shot: "تسديدة",
      foul: "خطأ",
      other: "أخرى",
      threat: "خطر",
      legendSumOfXT: "xT إجمالي",
      legendPass: "تمريرة",
      legendShot: "تسديدة",
      legendCarryAndAction: "السير بالكرة والتصرف",
      legendCarryAndPass: "السير بالكرة والتمرير",
      legendOnlyShowing: "إظهار فقط التصرفات الفردية ذات xT أعلى من",
      legendOnlyShowingPart1: "إظهار فقط التصرفات",
      legendOnlyShowingPart2: "الإجراءات مع xT>",
      legendOnlyShowingSetPiece: "إظهار حركات الكرات الثابتة فقط مع xT>",
      legendOnlyShowingOpenPlay: "يتم عرض حركات من لعب مفتوح ذات  xT>",
      legendPlays: "تصرفات",
      legendPerPlay: "حركة لكل",
      legendCarry: "السير",
      penaltyPlay: "ضربة جزاء",
      freeKickTakenPlay: "لعبة ضربة حرة",
      cornerTakenPlay: "لعبة ضربة زاوية",
      fromCornerPlay: "لعبة ضربة زاوية",
      keeperThrowPlay: " إلقاء الحارس للكرة",
      fastBreakPlay: "هجمة مرتدة",
      indirectPlay: "لعبة غير مباشرة",
      minutes: "دقاذق",
      games: "مباريات",
      xT: "xT",
      xTPer90: "xT لكل90 "
    },
    gameAnalysis: {
      next: "التالي",
      previous: "السابق",
      phaseLabel: "مرحلة",
      phasesLabel: "مراحل",
      from: "من ال",
      to: "إلى ال",
      and: " و ",
      steps: {
        finishingMapFullGame: "خريطة الانهاء",
        keyPassMapFullGame: "خريطة التمريرات المفتاحية",
        gameFlow: "التحكم في المباراة",
        finishingMapPerPhases: "خريطة الانهاء لكل المراحل",
        keyPassMapPerPhases: "خريطة التمريرات المفتاحية لكل المراحل",
        passMapPerPhases: "خريطة التمريرات لكل المراحل"
      },
      step1: {
        table: {
          draw: "تعادل",
          win: "فوز",
          lose: "هزيمة",
          possession: "استحواذ",
          xP: "نقاط متوقعة",
          directness: "المباشرة",
          ppda: "PPDA",
          xG: "xG",
          xGOpenPlay: "xG من اللعب المفتوح",
          xGSetPiece: "xG من الكرات الثابتة"
        },
        text: {
          firstParagraph: {
            1: "تظهر الخريطة الكائنة في الجانب الأيمن الأهداف المتوقعة والمصنوعة من قبل home_team_name و away_team_name. تمثل الدوائر الممتلئة التسديدات التي انتهت بأهداف. يعتمد حجم الدوائر على قيمة الأهداف المتوقعة في كل تسديدة."
          },
          lastParagraph: {
            1: "تحتسب احتمالية الفوز وعدد النقاط المتوقعة من خلال التسديدات (١٠٠،٠٠٠ محاكاة من كل تسديدة تأخذ احتمالية هدف)."
          },
          targetHighTeamXG: {
            1: "صنعا أكبر عدد من الأهداف المتوقعة target_team_name , وأيضا rival_team_name ,"
          },
          targetHighTeamOpenPlayXG: {
            1: "جاءت من كرات متحركة target_team_name في هذه المباراة، معظم فرص"
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: "(rival_team_name بفارق عن) جاءت من كرات متحركة target_team_name في هذا اللقاء، معظم فرص "
          },
          targetHighTeamSetPieceXG: {
            1: "جاءت من كرات ثابتة target_team_name في هذا اللقاء، معظم فرص"
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: "في هذه اللعبة، تم إنشاء معظم فرص target_team_name من خلال اللعب بالركلات الثابتة (على عكس rival_team_name) "
          },
          targetHighTeamCornerXG: {
            1: "في هذه المباراة، معظم فرص target_team_name جاءت من الركلات الركنية"
          },
          targetLowTeamGoalConversion: {
            1: "لكن تحويل الأهداف كان منخفضا"
          },
          targetHighTeamXGOPandSP: {
            1: "target_team_name صنع عدد كبير من الأهداف المتوقعة، سواء من كرات متحركة أو ثابتة"
          },
          targetHighTeamGoalConversion: {
            1: " ويتمتع أيضا بقدرة فائقة لتحويل تلك الفرص إلى أهداف "
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: "، عدم القدرة على تسجيل أي من الفرص التي صنعتها"
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: " لكنه صنع خطورة لإحراز أهداف أكثر"
          },
          targetHighTeamXGvsGameRival: {
            1: "rival_team_name صنع خطورة أكثر من  target_team_name وفي هذا اللقاء"
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: " وكان من الممكن أن يسجل أهدافا أكثر. "
          },
          targetHighTeamXGZeroGoals: {
            1: " لكن لم يتمكن من الاستفادة من الفرص المصنوعة لتسجيل أهداف. "
          },
          targetHighTeamXGGoalDiff: {
            1: " تصل فرص الفوز إلى team_winning_chance .حسب المحاكاة الخاص بنا  بعد المباراة"
          },
          startTargetHighTeamOpenPlayXG: {
            1: " جاءت من كرات متحركة target_team_name معظم فرص "
          },
          startTargetHighTeamSetPieceXG: {
            1: " جاءت من كرات ثابتة. target_team_name معظم فرص "
          },
          startTargetHighTeamCornerXG: {
            1: " معظم الفرص جاءت بفضل ضربات الزاوية. "
          },
          targetSimilarTeamXG: {
            1: "في هذه اللقاء، وفيما يتعلق بالأهداف المتوقعة، كلا الفريقين صنعا نسبة أهداف متوقعة مماثلة ضد المنافس، "
          },
          targetSimilarTeamXGGoalDiff: {
            1: "تعامل بشكل أفضل عند إنهاء هذه الفرص target_team_name لكن "
          },
          targetLowTeamXGGoalDiff: {
            1: "لم يصنع خطورة للمنافسة فيما يتعلق بالأهداف المتوقعة.  target_team_name بغض النظر عن النتيجة، فإن "
          },
          targetLowTeamXGZeroGoalDiff: {
            1: "target_team_name  لم يصنع خطورة كافية للمنافس فيما يتعلق بالأهداف المتوقعة تمكنه من الفوز بالمباراة   "
          },
          rivalHighTeamXG: {
            1: "أن يصنع له خطورة كبيرة rival_team_name وسمح لل "
          },
          rivalHighTeamXGGoalDiff: {
            1: "  يمكن أن يفوز target_team_name حسب محاكاة ما بعد المباراة الخاصة بنا, team_winning_chance بهذة المباراة بنسبة "
          },
          targetHighTeamGoalConversion2: {
            1: "وجود نسبة تحويل عالية للهدف"
          },
          winningChance: {
            1: "نظرًا لعدد التسديدات وxG لكلا الفريقين، كان من المفترض أن يكون target_team_name قد فاز في هذه المباراة بفرصة فوز الفريق في المرات."
          },
          highPlayerXGManyShots: {
            1: "من المثير للاهتمام ملاحظة أن player_name أنشأ xg_value xG في لقطات shots_value"
          },
          highPlayerXGMoreThanOneGoal: {
            1: "بحاجة إلى xg_value xG لتسجيل هدف."
          },
          highPlayerXGOneGoal: {
            1: "ليسجل الهدف."
          },
          highPlayerXGAnyGoal: {
            1: "رغم عدم تمكنه من تسجيل أي هدف."
          },
          highPlayerXGNotManyShots: {
            1: "ومن الجدير بالذكر أن player_name قام بإنشاء xg_value xG في بضع لقطات"
          },
          highManyPlayerXG: {
            1: "ومن المثير للاهتمام ملاحظة أن player_name وplayer_name2 أنشأا xg_value وxg_value2 <b>xG</b> على التوالي."
          },
          highTeamXGPerShot: {
            1: "فيما يتعلق باختيار التسديدات التي تم تنفيذها بواسطة target_team_name، كانت جيدة جدًا من حيث احتمالية أن تصبح هدفًا، بمتوسط ​​xG لكل تسديدة يبلغ xg_per_shot_value."
          },
          highTeamXGPerShotVSGameRival: {
            1: "كان اختيار التسديدات لـ target_team_name أفضل بكثير من rival_team_name ، حيث كان متوسط ​​قيمة xg_per_shot_value xG لكل لقطة. "
          },
          xGTimesNotAfter70xG: {
            1: "على الرغم من ارتفاع xG الناتج، واجه target_team_name مشاكل في خلق خطر في نهاية اللعبة."
          },
          xGTimesBefore25xG: {
            1: "خلق target_team_name خطورة كبيرة خاصة في بداية الشوطين."
          },
          xGTimesAfter25xG: {
            1: "خلق target_team_name خطورة كبيرة خاصة في نهاية الشوطين."
          },
          xGTimesBefore25xGvsItself: {
            1: "شكل target_team_name أغلب الخطورة في بداية الشوط الأول."
          },
          xGTimesAfter25xGvsItself: {
            1: "شكل target_team_name أغلب الخطورة في نهاية الشوط الأول."
          },
          xGTimesBefore70xGvsItself: {
            1: "شكل target_team_name أغلب الخطورة في بداية الشوط الثاني."
          },
          xGTimesAfter70xGvsItself: {
            1: "شكل target_team_name معظم الخطورة في نهاية الشوط الثاني."
          },
          xGTimesBefore25xG2: {
            1: "بدأ target_team_name المباراة بقوة كبيرة وصنع فرصًا حققت أهدافًا متوقعة xg_value."
          },
          xGTimesAfter25xG2: {
            1: "أنهى target_team_name الشوط الأول من المباراة بفرص حققت أهدافًا متوقعة xg_value."
          },
          xGTimesBefore70xG: {
            1: "خرج target_team_name من استراحة الشوط الأول بفرص حققت أهداف xg_value المتوقعة."
          },
          xGTimesAfter70xG: {
            1: "أنهى target_team_name الشوط الثاني بفرص حققت أهدافًا متوقعة xg_value."
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: "خلق target_team_name خطورة كبيرة في نهاية الشوط الثاني."
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: "خلق target_team_name خطورة كبيرة في بداية الشوط الثاني."
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: "خلق target_team_name خطورة كبيرة في نهاية الشوط الأول."
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: "شكل target_team_name خطورة كبيرة في بداية الشوط الأول."
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: " شكّل target_team_name معظم خطورته في الشوط الأول بينما فعل rival_team_name الشيء نفسه في الشوط الثاني.  "
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: " شكّل فريق target_team_name معظم خطورته في الشوط الثاني بينما فعل فريق rival_team_name الشيء نفسه في الشوط الأول. "
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: " إنها مباراة تولد فيها معظم الخطر من حيث الأهداف المتوقعة خلال الشوط الأول."
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: "إنها مباراة تولد فيها معظم الخطر من حيث الأهداف المتوقعة خلال الشوط الثاني.  "
          },
          xGTimesFirstHalfXG: {
            1: "نجح target_team_name في خلق أكبر قدر من الخطورة في الشوط الأول."
          },
          xGTimesSecondHalfXG: {
            1: "نجح target_team_name في خلق أكبر قدر من الخطورة خلال الشوط الثاني."
          },
          xGTimesFirstHalfXGRival: {
            1: "target_team_name سمح بمعظم الخطورة على صعيد الأهداف المتوقعة في الشوط الأول."
          },
          xGTimesSecondHalfXGRival: {
            1: "target_team_name سمح بمعظم الخطورة على صعيد الأهداف المتوقعة خلال الشوط الثاني."
          },
          highInBoxXG: {
            1: "توضح خريطة التسديدات كيف أن معظم الخطورة جاءت من التسديدات داخل منطقة الجزاء."
          },
          highOutOfBoxXG: {
            1: "يمكن ملاحظة في خريطة اللقطة أنه في هذه اللعبة، قام target_team_name بتوليد الكثير من الخطورة من خارج منطقة الجزاء."
          },
          highInBoxXGRival: {
            1: "نريد أن نشير إلى أن معظم الخطورة التي استقبلها فريق target_team_name جاءت من تسديدات داخل منطقة الجزاء."
          },
          highInBoxXGRival2: {
            1: "ومن المثير للاهتمام أيضًا تسليط الضوء على أن معظم الخطورة التي استقبلها فريق target_team_name جاءت من التسديدات داخل منطقة الجزاء."
          },
          highOutOfBoxXGRival: {
            1: "قدم target_team_name أداءً جيدًا في تفادي الخطر داخل منطقة الجزاء."
          },
          highTeamChancesHighPPDARival: {
            1: "سمح عدم وجود ضغط على target_team_name، بتمريرات ppda_value لكل إجراء دفاعي، أحد المفاتيح التي تمكن فريق rival_team_name من خلق عدد كبير من الفرص."
          },
          lowPPDAWithGoalDiff: {
            1: "يسمح target_team_name فقط بتمريرات ppda_value لكل إجراء دفاعي وهو أحد مفاتيح النصر."
          },
          lowPPDA: {
            1: "لقد قام target_team_name بعمل رائع في مقاطعة ألعاب فريق rival_team_name مما سمح فقط بمتوسط ​​ppda_value من التمريرات لكل إجراء دفاعي."
          },
          highPossession: {
            1: "سيطر target_team_name على الكرة من خلال قيمة الاستحواذ"
          },
          highPPDARival: {
            1: "وكذلك توزيع سلس للكرة"
          },
          chancesCreated: {
            1: "مما سمح لهم بالحصول على عدد كبير من فرص اللعب المفتوح (chances_value). "
          },
          chancesCreatedRival: {
            1: "على الرغم من أن rival_team_name كان قادرًا على إنشاء عدد كبير من فرص اللعب المفتوح (chances_value)."
          },
          xGPerShotRival: {
            1: "على الرغم من أن rival_team_name كان قادرًا على خلق فرص أكثر خطورة باستخدام قيمة xg_per_shot_value xG لكل تسديدة. "
          },
          winGame: {
            1: "كونه أحد مفاتيح الفوز باللعبة."
          },
          notEnoughWinGame: {
            1: "لا يكفي للفوز باللعبة."
          },
          goalsFromErrorsFirstGoal: {
            1: "الهدف الأول جاء من خطأ player_error_name الذي استغله player_name "
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: "الهدف الأول والوحيد جاء من خطأ player_error_name الذي سجله player_name"
          },
          lastPhaseOfGame: {
            1: "في المرحلة الأخيرة من المباراة.  "
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: "الهدف الأخير للفوز بالمباراة جاء من خطأ player_error_name الذي أدى إلى هدف player_name."
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: "الهدف الأخير لتعادل المباراة جاء من خطأ player_error_name أدى إلى هدف player_name."
          },
          goalsFromErrorsGoalToTie: {
            1: "أدى خطأ من player_error_name إلى فرصة التعادل في المباراة لصالح target_team_name."
          },
          goalsFromErrorsGoalToLead: {
            1: "تولى target_team_name زمام المبادرة مستفيدًا من خطأ من player_error_name"
          },
          xGChance: {
            1: "مع فرصة xg_value xG."
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: "الهدف النهائي لـ rival_team_name للفوز بالمباراة جاء من خطأ player_error_name الذي أدى إلى هدف player_name. "
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: "أدى خطأ من rival_team_name إلى فرصة التعادل في المباراة لفريق Rival_team_name."
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: "أخذ rival_team_name زمام المبادرة مستفيدًا من خطأ من player_error_name "
          },
          hugeChancesMissedOneScored: {
            1: "حدث أن سجل target_team_name الفرصة الكبيرة الوحيدة التي تم إنشاؤها أثناء المباراة، وهو هدف player_name الذي نراه في خريطة xG بـ xG بقيمة xg_value."
          },
          hugeChancesMissedMoreThanOneScored: {
            1: "وحدث أن نجح target_team_name في تسجيل كل الفرص الكبيرة التي أتيحت خلال المباراة"
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: "كانت لدى player_name الفرصة الوحيدة الكبيرة لـ target_team_name للتسجيل بـ xG بقيمة xg_value."
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: "لم يتمكن target_team_name من تسجيل أي من الفرص التي تزيد قيمتها عن 40% من احتمالية أن تصبح هدفًا."
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: "حظي player_name بفرصة كبيرة لـ xg_value xG للتقدم في النتيجة."
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: "حصل target_team_name على فرص بقيمة فرص مع xG أعلى من 40% للتقدم في النتيجة."
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: "حصل target_team_name على فرص بقيمة xG عالية للتقدم في النتيجة."
          },
          shotOnPostBeforeFirstGameGoal: {
            1: "حصل player_name على فرصة للتقدم في نتيجة xg_value xG التي ارتطمت بالقائم."
          },
          beforeEndOfGame: {
            1: "وقبل نهاية المباراة،"
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: "حصل player_name على فرصة xg_value xG للفوز بالمباراة."
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: "حصل target_team_name على فرص بقيمة xG أعلى من 40% للفوز بالمباراة."
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: "حصل target_team_name على فرص بقيمة xG عالية للفوز بالمباراة."
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: "حظي player_name بفرصة كبيرة لـ xg_value xG للتقدم في النتيجة."
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: "حصل target_team_name على فرص بقيمة فرص مع xG أعلى من 40% للتقدم في النتيجة."
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: "حصل target_team_name على chances_value فرص بقيمة xG عالية للتقدم في النتيجة."
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: "حصل player_name على فرصة للتقدم في نتيجة xg_value xG التي ارتطمت بالقائم."
          },
          bigChancesMissedWhenLosingByOne: {
            1: "حصل player_name على فرصة xg_value xG لتعادل المباراة دون حظ."
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: "حصل target_team_name على فرص قيمة لتعادل المباراة مع احتمال تسجيل أعلى من 30%."
          },
          shotOnPostWhenLosingByOne: {
            1: "حصل player_name على فرصة xg_value xG لتعادل المباراة التي انتهت بضرب القائم."
          }
        }
      },
      step2: {
        table: {
          draw: "يرسم",
          win: "يفوز",
          possession: "تملُّك",
          xP: "النقاط المتوقعة",
          directness: "المباشرة",
          ppda: "PPDA",
          xA: "xA",
          xAOpenPlay: "xA اللعب المفتوح",
          xASetPiece: "xA كرات ثابتة  ",
          chancesCreated: "صناعة الفرص",
          shotsOnTarget: "تسديدات على المرمى",
        },
        text: {
          firstParagraph: {
            1: "تعرض هذه الصورة التمريرات الحاسمة المتوقعة لكل من <b style='color:home_color'>home_team_name</b> و <b>away_team_name</b>."
          },
          xAPerKeyPass: {
            1: "xA لكل تمريرة مفتاحية.  "
          },
          keyPassesGeneratedFrom: {
            1: "وخاصة التمريرات المفتاحية المتولدة من  "
          },
          highTeamXAvsXG: {
            1: "كما تظهر خريطة xA، فإن معظم الخطر الناتج عن target_team_name يأتي من اللعب الجماعي وليس من الإجراءات الفردية"
          },
          openPlay: {
            1: "لعب مفتوح"
          },
          setPiece: {
            1: "يلعب كرات ثابتة"
          },
          cornerKicks: {
            1: "ركلات ركنية"
          },
          combinationPlays: {
            1: "ألعاب مجمعة"
          },
          averageTeamXAvsXG: {
            1: "في هذه اللعبة، أنشأ target_team_name خطرًا من كلتا اللعبتين المجمعتين"
          },
          individualActions: {
            1: "والأفعال الفردية."
          },
          dangerFromIndividualActions: {
            1: "في هذه اللعبة، معظم الخطر الناتج عن target_team_name جاء من تصرفات فردية."
          },
          highTeamXAvsXGRival: {
            1: "الفرص التي سمح بها target_team_name أثناء المباراة كانت تأتي من اللعب الجماعي كما تظهر خريطة xA."
          },
          rivalStrongKeyPassesFrom: {
            1: "كان rival_team_name قوياً في التمريرات الرئيسية القادمة منه  "
          },
          manyPlayerKeyPasses: {
            1: "ومن المثير للاهتمام أن نلاحظ أن player_name أنشأ xa_value xA في التمريرات المفاتيحية key_passes"
          },
          playerAssists: {
            1: " تحتاج إلى xa_per_assist xA لكل تمريرة حاسمة. "
          },
          giveAssist: {
            1: "لتقديم تمريرة حاسمة."
          },
          noAssists: {
            1: "على الرغم من أن أياً من تمريراته لم تنتهي بالتمريرة الحاسمة."
          },
          highXANotManyShots: {
            1: "ومن المثير للاهتمام أن نلاحظ أن player_name أنشأ xa_value xA في بضع تمريرات"
          },
          manyPlayersHighXA: {
            1: " ومن المثير للاهتمام ملاحظة أن player_name و player_name2 قاما بإنشاء xa_value و xa_value2 xA على التوالي."
          },
          xATimes: {
            1: " أنتج target_team_name معظم خطورته في الشوط الأول بينما فعل rival_team_name الشيء نفسه في  "
          },
          firstHalf: {
            1: "النصف الاول."
          },
          secondHalf: {
            1: "النصف الثاني."
          },
          left: {
            1: "الجهه اليسرى"
          },
          center: {
            1: "مركز"
          },
          right: {
            1: "الجانب الأيمن"
          },
          xAFirstHalfFirstHalfRival: {
            1: "إنها لعبة تم فيها توليد معظم المخاطر فيما يتعلق بالأهداف المتوقعة أثناء"
          },
          xAFirstHalf: {
            1: "تمكن target_team_name من خلق معظم المخاطر في"
          },
          xATimesXARival: {
            1: "سمح target_team_name بالكثير من المخاطر فيما يتعلق بالأهداف المتوقعة في"
          },
          xASides: {
            1: "تم إنتاج معظم خطورة target_team_name من side_name (xa_value <b>xA</b>)"
          },
          xASidesRival: {
            1: " بينما قام rival_team_name بإنشاء أغلبيته من side_name (xa_value <b>xA</b>)"
          },
          dangerCreationRival: {
            1: " لقد جاء الخطر rival_team_name بشكل خاص من side_name (xa_value <b>xA</b>).  "
          },
          speciallyEffective: {
            1: "كان target_team_name فعالاً بشكل خاص في"
          },
          xAPerChanceCreated: {
            1: "بمتوسط ​​xa_value"
          },
          speciallyEffectiveRival: {
            1: "كان rival_team_name فعالاً بشكل خاص في  "
          }
        }
      },
      step3: {
        text: {
          chance: "فرصة",
          chances: "فرص",
          goal: "هدف",
          goals: "الأهداف",
          home: "المستضيف",
          away: "الضيف",
          last: "آخر",
          first: "أولاً",
          goalScorer: "هداف",
          goalScorers: "الهدافين",
          lastPhase: "المرحلة الأخيرة من المباراة،",
          phase: {
            1: "في هذه phase_position المرحلة من المباراة،  "
          },
          moreXT: {
            1: " <b style='color:more_color'>more_xt_team_name</b> إلى إنشاء المزيد من التهديدات المتوقعة (<b style='color:more_color'>more_xt_team_value xT</b>) مقارنة بـ <b style='color:less_color'>less_xt_team_name< /b> (<b style='color:less_color'>less_xt_team_value xT</b>)"
          },
          sameTeamMoreMinutes: {
            1: "وقام بذلك لمزيد من الدقائق في هذه الفترة (<b style='color:more_color'>more_time_xt_Minutes.</b> مقابل <b style='color:less_color'>less_time_xt_Minutes.</b> للخصم)"
          },
          rivalTeamMoreMinutes: {
            1: "ومع ذلك، كان خصمه هو من صنع الخطر لمدة أطول (<b style='color:more_color'>more_time_xt_minis دقيقة.</b> مقابل <b style='color:less_color'>less_time_xt_minis دقيقة.</b> من الخصم ) في هذه الفترة من اللعبة"
          },
          maxXTValue: {
            1: "<b style='color:max_color'>max_xt_team_name</b> هو الفريق الذي خلق أكبر قدر من الخطر (<b style='color:max_color'>max_xt_team_value xT</b>) عند <b style='color:max_color '>max_xt_team_دقيقة'</b>"
          },
          maxXTValueRival: {
            1: "، بينما أنتج <b style='color:max_rival_color'>max_xt_rival_team_name</b> أكبر قدر من الخطر (<b style='color:max_rival_color'>max_xt_rival_team_value xT</b>) عند <b style='color:max_rival_color' >max_xt_rival_team_دقيقة'</b>"
          },
          bothTeamsScoreButDraw: {
            1: "في هذه الفترة من المباراة، تمكن كلا الفريقين من التغلب على حارس مرمى الخصم في <b>number_of_goals_each_team</b> لكل منهما. الفريق المضيف من خلال <b style='color:#3366FF'>home_player_name_goals</b> والفريق الضيف من خلال <b>away_player_name_goals</b>"
          },
          oneTeamTakesTheLead: {
            1: "فيما يتعلق بالأهداف، تفوق <b style='color:replace_color'>goal_scored_team_name</b> على الخصم بفارق <b style='color:replace_color'>difference_number_of_goals</b> من الفارق حيث تغلبوا على حارس مرمىهم بأسلوب <b ='color:replace_color'>home_player_name_goals</b> كـ goal_scorer_word"
          }
        }
      },
      step4: {
        table: {
          team: "فريق",
          period: "فترة",
          possession: "استحواذ",
          ppda: "PPDA",
          xGOpenPlay: "xG OP",
          tooltip: {
            team: "فريق",
            period: "فترة",
            possession: "استحواذ",
            ppda: "التمريرات الممنوحة لكل إجراء دفاعي",
            xGOpenPlay: "xG اللعب المفتوح"
          }
        },
        text: {
          clearly: "بوضوح",
          very: "جداً",
          haveGotText1: "لديه فقط",
          haveGotText2: "ينبغي أن حصلت على أكثر من",
          gaveUpPoss: "تخلى عن الحيازة",
          lostPoss: "فقد الاستحواذ على الكرة",
          too: "أيضاً",
          possession: {
            1: "خلال هذه المرحلة من المباراة، سيطر <b style='color:team_color'>team_name</b> ب clearly_text "
          },
          equalPossession: {
            1: "في هذه المرحلة من المباراة، لم يسيطر أحد على الآخر حيث كان التعامل مع الكرة متوازنًا تمامًا، على الرغم من أنه بالنظر إلى الأرقام، <b style='color:team_color'>team_name</b> تفوق قليلاً على خصومه بأسلوب <b ='color:team_color'>possession_value%</b> من الحيازة"
          },
          lowPossessionHighPPDA: {
            1: ". <b style='color:target_team_color'>target_team_name</b> مع ضغط كرة سيئ مسموح <b style='color:rival_team_color'>rival_team_name</b> بمنح <b style='color:target_team_color'>ppda_value تمريرات لكل إجراء دفاعي</b>"
          },
          lowPossessionLowPPDA: {
            1: ", لكن <b style='color:target_team_color'>target_team_name</b> كان جيدًا في الضغط على الكرة عندما استحوذ rival_team_name على الكرة، مع <b>PPDA</b> بقيمة <b>ppda_value</b>"
          },
          highPossessionLowPPDA: {
            1: "وكان قادرًا على اللعب بسبب very_textlow شدة الضغط من فريق rival_team_name  "
          },
          highPossessionHighPPDA: {
            1: "على الرغم من أن شدة الضغط من فريق rival_team_name كانت عالية جدًا"
          },
          highPossessionHighPFT: {
            1: "استولى <b style='color:target_team_color'>target_team_name</b> على استحواذ عالي مما أعطى <b>pft_value</b> <b>تمريرات في الثلث الأخير</b> من الملعب."
          },
          highPossessionMidLowPFT: {
            1: "بغض النظر عن نسبة الاستحواذ العالية، <b style='color:target_team_color'>target_team_name</b> has_got_text <b>pft_value</b> <b>يمرر في الثلث الأخير</b>."
          },
          lowPossessionHighPFT: {
            1: "بالرغم من أن <b style='color:target_team_color'>target_team_name</b> يمتلك نصًا خلال هذه المرحلة، إلا أنه كان قادرًا على إعطاء <b>pft_value</b> <b>تمريرات في الثلث الأخير</b>."
          },
          midPossessionHighPFT: {
            1: "الاستحواذ المتساوي خلال هذه المرحلة لم يمنع <b style='color:target_team_color'>target_team_name</b> من إعطاء <b>pft_value</b> <b>تمريرات في الثلث الأخير</b>."
          },
          highPFTHighTouchesIOB: {
            1: "بصرف النظر عن التحكم في المباراة في الثلث الأخير، كان <b style='color:target_team_color'>target_team_name</b> أيضًا حاضرًا بشكل كبير في منطقة جزاء الخصم."
          },
          highPFTLowTouchesIOB: {
            1: "<b style='color:target_team_color'>target_team_name</b> سيطر على الكرة في الثلث الأخير، لكنه لم يتمكن من إدخال العديد من الكرات إلى منطقة جزاء الخصم"
          },
          highPFTMidTouchesIOB: {
            1: "بالنظر إلى عدد <b>التمريرات في الثلث الأخير</b>، فإن <b style='color:target_team_color'>target_team_name</b> كان من المفترض أن يخلق المزيد من الخطورة في منطقة جزاء الخصم"
          },
          lowPFTHighTouchesIOB: {
            1: "بالرغم من أن <b style='color:target_team_color'>target_team_name</b> لم يكمل العديد من التمريرات في الثلث الأخير، إلا أنه تمكن من الوصول إلى منطقة الخصم عدة مرات."
          },
          midPFTHighTouchesIOB: {
            1: "بالنظر إلى عدد التمريرات المكتملة في الثلث الأخير، تمكن <b style='color:target_team_color'>target_team_name</b> من الوصول إلى منطقة الخصم عدة مرات."
          },
          maxDirectness: {
            1: "تجدر الإشارة إلى أن هذه هي مرحلة اللعبة التي لعب فيها <b style='color:max_dir_color'>target_team_name</b> بشكل أكثر هجومًا باستخدام <b>مباشرة</b> بقيمة <b>directness_value</ ب>."
          },
          maxXG: {
            1: "<b style='color:target_team_color'>target_team_name</b> كان قادرًا على توليد المزيد من xG مقارنة بالمراحل الأخرى من اللعبة"
          },
          highXGFifthQuintile: {
            1: "تمكن <b style='color:target_team_color'>target_team_name</b> من تحقيق عدد كبير من الأهداف المتوقعة"
          },
          highXG: {
            1: "أنتجت كمية جيدة من الأهداف المتوقعة"
          },
          highXGLowPossession: {
            1: "رغم عدم سيطرته على الكرة"
          },
          highXGLowShots: {
            1: "فقط في بضع لقطات، مع وجود <b>xG لكل لقطة</b> بقيمة <b>xg_per_shot_value</b>"
          },
          highXGLowXGPerShot: {
            1: "على الرغم من أن xG لكل تسديدة too_textlow."
          },
          lowXGZeroXG: {
            1: "<b style='color:target_team_color'>target_team_name</b> لم يتمكن من إحداث أي خطر على الخصم"
          },
          lowXGMinXG: {
            1: "فيما يتعلق بتوليد الأهداف المتوقعة، كانت هذه مرحلة سيئة بالنسبة إلى <b style='color:target_team_color'>target_team_name</b>"
          },
          lowXGFirstQuintileXG: {
            1: "<b style='color:target_team_color'>target_team_name</b> حقق عددًا منخفضًا جدًا من الأهداف المتوقعة"
          },
          lowXGSecondQuintileXG: {
            1: "<b style='color:target_team_color'>target_team_name</b> لم يتمكن من تحقيق عدد جيد من الأهداف المتوقعة"
          },
          lowXGHighPossession: {
            1: "رغم سيطرتهم على الكرة."
          },
          lowXGHighShots: {
            1: "على الرغم من التسديد عدة مرات"
          },
          lowXGHighPFT: {
            1: "على الرغم من إكمال <b>pft_value</b> <b>التمريرات في الثلث الأخير</b> من الملعب."
          },
          midXGQuintileMinXG: {
            1: "على الرغم من أن صنع xG لم يكن سيئًا، إلا أن هذه كانت أضعف مرحلة في المباراة بالنسبة إلى <b style='color:target_team_color'>target_team_name</b> في هذا الصدد "
          },
          midXGQuintileMaxXG: {
            1: "كانت هذه هي المرحلة التي تمكن <b style='color:target_team_color'>target_team_name</b> خلالها من إنشاء أعلى <b>xG (xg_value)</b>"
          }
        }
      },
      step5: {
        table: {
          team: "فريق",
          period: "فترة",
          possession: "استحواذ",
          directness: "الوجهة",
          passesFinalThird: "ف…",
          tooltip: {
            team: "فريق",
            period: "فترة",
            possession: "استحواذ",
            directness: "المباشرة",
            passesFinalThird: "تمريرات الثلث الأخير"
          }
        },
        text: {
          last: "آخر",
          goal: "هدف",
          goals: "الأهداف",
          chance: "فرصة",
          chances: "فرص",
          first: "أولاً",
          homeTeam: "الفريق المضيف",
          awayTeam: "الفريق المستضيف ",
          home: "المضيف",
          away: "المستضيف",
          clearly: "بوضوح",
          slightly: "طفيف",
          firstOrLastPhase: {
            1: " في هذه phase_position المرحلة من المباراة،",
            2: "في فترة phase_position من المباراة، "
          },
          phase: {
            1: "خلال هذه الفترة من المباراة"
          },
          bothZeroGoalsScored: {
            1: "دون أن يتمكن أي من الفريقين من تغيير لوحة النتائج."
          },
          equalGoalsScored: {
            1: " الحصول على <b>number_goals</b> هدف"
          },
          differentGoalsScored: {
            1: "الحصول على <b>number_goals</b>  هدف"
          },
          equalPossesion: {
            1: "استحوذ كلا الفريقين على الكرة <b>poss_value%</b> بالضبط في ذلك الوقت"
          },
          morePossesion: {
            1: "<b style='color:more_color'>more_poss_team_name</b> استحوذ على الكرة لعدد أكبر من الدقائق (<b style='color:more_color'>more_poss_team_value%</b> من الوقت) مقارنة بخصمه <b style=' color:less_color'>less_poss_team_name</b> (<b style='color:less_color'>less_poss_team_value%</b> من الوقت)"
          },
          equalDirectness: {
            1: "لعب كلا الفريقين المباراة بنفس المباشرة (<b>directness_value</b> لكل منهما)"
          },
          moreDirectnessSameTeam: {
            1: "لقد كانوا أيضًا أكثر عموديًا من خصومهم، ولعبوا اللعبة بطريقة مباشرة <b style='color:more_color'>more_dir_team_value</b> مقابل <b style='color:less_color'>less_dir_team_value</b>"
          },
          moreDirectnessDifferentTeam: {
            1: "ومع ذلك، كان الفريق المضيف هو الذي لعب بشكل مباشر أكثر (<b style='color:more_color'>more_dir_team_value</b>) من خصمه (<b style='color:less_color'>less_dir_team_value</b>)"
          },
          equalChancesCreated: {
            1: "خلق كلا الفريقين نفس عدد الفرص، بالضبط <b>chances_created_value</b>  chance_text. "
          },
          moreChancesCreated: {
            1: "<b style='color:less_color'>less_cc_team_name</b> أنشأ <b style='color:less_color'>less_cc_team_value less_chance_text</b> فقط وتفوق الخصم على adverb_text (<b style='color:more_color' >تم إنشاء more_cc_team_value more_chance_text</b>)."
          },
          equalXA: {
            1: "حصل كلا الفريقين على فرص متساوية، كما هو موضح في <b>xa_value للتمريرات الحاسمة المتوقعة</b>،"
          },
          moreXA: {
            1: "أنشأ فريق home_away <b>diff_xa_team_value التمريرات الحاسمة المتوقعة</b> (<b style='color:more_color'>more_xa_team_value</b> مقابل <b style='color:less_color'>less_xa_team_value</b>) أكثر من الخصم،"
          },
          xAOpenPlay: {
            1: "إنشاء، على التوالي، <b style='color:more_color'>more_xa_op_value</b> و<b style='color:less_color'>less_xa_op_value xA Open Play</b>."
          }
        }
      },
      step6: {
        text: {
          eachOne: "كل واحد",
          respectively: "، على التوالى",
          with: "(مع <b style='color:replace_color'>other_player_name</b>)",
          playerWas: "كان اللاعب",
          playerWere: "كان اللاعبون",
          firstPhase: {
            1: "في هذا الجزء الأول من المباراة، أهم لاعب هو player_text",
            2: "أما بالنسبة للجزء الأول من اللعبة، فمن الذي برز كان"
          },
          otherPhase: {
            1: "يجب الإشارة بين <b style='color:replace_color'>min_from'</b> و<b style='color:replace_color'>min_to'</b>"
          },
          lastPhase: {
            1: "في الجزء الأخير من اللعبة، أذكر ل",
            2: "أما بالنسبة للمرحلة الأخيرة من المباراة،"
          },
          playerMaxSuccessfullPasses: {
            1: "<b style='color:replace_color'>player_name</b> حيث قام بأكبر عدد من التمريرات الناجحة لفريقه، بالضبط <b style='color:replace_color'>تمريرات successfull_passes_value</b>"
          },
          playerMaxTotalPasses: {
            1: "والذي يصبح أكثر قيمة عندما تظهر الأرقام أنه أيضًا "
          },
          playerMaxTotalPasses2: {
            1: "with_text هو اللاعب صاحب أكبر عدد من محاولات التمرير (<b style='color:replace_color'>total_passes_value passs</b>)."
          },
          playerNotMaxTotalPasses: {
            1: "على الرغم من أنه لم يحاول أكبر عدد من التمريرات (<b style='color:replace_color'>player_name</b> مع <b style='color:replace_color'>total_passes_value التمريرات</b>)."
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: "حاول خلال هذه الفترة <b style='color:replace_color'>تمريرة  total_passes_value</b> لكل منها. "
          },
          playerMaxPctPasses: {
            1: "فيما يتعلق <b style='color:replace_color'>% من التمريرات المكتملة</b>، <b style='color:replace_color'>player_name</b> له <b style='color:replace_color'>max_pct_passes_value عالية %</ب>.",
            2: " بالإشارة إلى معدل نجاح التمرير، تجدر الإشارة إلى <b style='color:replace_color'>player_name</b> مع <b style='color:replace_color'>max_pct_passes_value%</b> معدل نجاح التمرير</b >."
          },
          playerSumTotalXG: {
            1: "في هذه النافذة الزمنية، أنشأ الفريق إجمالي <b style='color:replace_color'>sum_xg_value xG</b>،",
            2: "خلال هذه الفترة، أنشأ <b style='color:replace_color'>team_name</b> <b style='color:replace_color'>xG</b> بقيمة <b style='color:replace_color'>sum_xg_value</ ب>،"
          },
          ZeroSumXG: {
            1: "على الرغم من إجراء <b style='color:replace_color'>all_team_total_passes</b> بين الفريق بأكمله، إلا أن ذلك كان بلا جدوى حيث فشلوا في خلق أي فرصة.",
            2: "<b style='color:replace_color'>all_team_total_passes</b> التي تم إجراؤها في هذه الفترة لم تولد أي فرصة للتسجيل."
          },
          playerMaxXGMaxXADiffPlayer: {
            1: "مع <b style='color:replace_color'>player_xg_name</b> مع <b style='color:replace_color'>xg_value xG</b> و<b style='color:replace_color'>player_xa_name</b> مع <b style='color:replace_color'>xa_value xA</b> هم أخطر اللاعبين من حيث خلق الفرص."
          },
          playerMaxXGMaxXASamePlayer: {
            1: "كونها <b style='color:replace_color'>player_name</b> مع <b style='color:replace_color'>xg_value xG</b> و<b style='color:replace_color'>xa_value xA</b> صانع معظم فرص فريقه."
          },
          playersMaxXGMaxXA: {
            1: " بفضل من بين آخرين لـ <b style='color:replace_color'>players_name</b> الذين قاموا بتشغيل <b style='color:replace_color'>xa_value xA</b> لكل منهم بتمريرات المفاتيح الخاصة بهم."
          },
          playerMaxXGZeroXA: {
            1: "كونه <b style='color:replace_color'>player_xg_name</b> مع <b style='color:replace_color'>xg_value xG</b> الذي كان لديه كل الفرص، وكان عليه خلقها بمفرده لم يتلق أي تمريرات رئيسية."
          },
          playersMaxXGZeroXA: {
            1: "كونه <b style='color:replace_color'>player_xg_name</b> مع <b style='color:replace_color'>xg_value xG</b> الذين حصلوا على الفرص، وكان عليهم خلقها بأنفسهم لأنهم لم يحصلوا عليها أي تمريرات رئيسية."
          },
          oneMaxConnections: {
            1: "الزوج الذي قام بأكبر عدد من التمريرات بينهما خلال هذه الفترة من المباراة كان <b style='color:replace_color'>couple_name</b>، بإجمالي <b style='color:replace_color'>connections_value التمريرات</ ب>.",
            2: "قام الثنائي المكون من <b style='color:replace_color'>couple_name</b> بتبادل <b style='color:replace_color'>connections_value</b> مرات الكرة.",
            3: "كان الثنائي <b style='color:replace_color'>couple_name</b> هما الأكثر تمريرًا للكرة في هذا الجزء من المباراة، وقد فعلوا ذلك حتى على <b style='color:replace_color'>connections_value</ ب> الفرص."
          },
          twoMaxConnections: {
            1: "كان الثنائي المتكون من <b style='color:replace_color'>couple_name</b> و<b style='color:replace_color'>couple_name2</b> أكثر الاتصالات تكرارًا خلال هذه الفترة، حيث تم تمرير الكرة إلى كل بينهما <b style='color:replace_color'>connections_value</b> مرات أخرى."
          },
          moreThanTwoMaxConnections: {
            1: "، الثنائيات مثل <b style='color:replace_color'>couple_name</b>، قاموا <b style='color:replace_color'>بتمرير قيمة connections_value</b> لبعضهم البعض. "
          },
          oneMinConnections: {
            1: "من ناحية أخرى، كان <b style='color:replace_color'>couple_name</b> هو الأقل تمريرًا للكرة لبعضهما البعض، ولم يتم تمرير سوى <b style='color:replace_color'>connections_value</b>.",
            2: "على الجانب الآخر، الترادف المكون من <b style='color:replace_color'>couple_name</b> متصل فقط <b style='color:replace_color'>connections_value</b> مرات."
          },
          twoMinConnections: {
            1: "من ناحية أخرى، <b style='color:replace_color'>couple_name</b> و <b style='color:replace_color'>couple_name2</b> نادرًا ما يتبادلان التمريرات بينهما (<b style='color:replace_color '>تمرير connections_value</b>)"
          },
          moreThanTwoMinConnections: {
            1: "لم يتم توصيل العديد من المجموعات بشكل كافٍ، مثل الثنائي <b style='color:replace_color'>couple_name</b>، والذي يعد <b style='color:replace_color'>قيمة connections_value</b> من بين المجموعات الأقل شيوعًا مجموعات."
          }
        }
      }
    },
    gamePossessionMap: {
      of: "من",
      to: "ل",
      and: "و",
      endsWith: "ينتهي ب",
      time: "وقت",
      touches: "اللمسات",
      passes: "تمريرات",
      threat: "تهديد",
      xG: "xG",
      xT: "xT",
      minutes: "دقائق",
      duration: "مدة",
      endsGoal: "ينتهي الهدف",
      endsInBox: "ينتهي في منطقة الجزاء",
      withShot: "مع تسديدة",
      withCross: "مع توزيعة",
      possession: "استحواذ",
      events: "الأحداث",
      filters: "تصفية",
      filtersWarning: "خطورة  تنطبق فقط على الاستحواذ دون تسديد",
      sumWarning: "يُطبق الفلتر على مجموع xG لجميع التسديدات في التسلسل، لذلك قد يكون أكبر من 1",
      show: "يعرض",
      sequenceNumbers: "رقم التسلسل",
      jerseyNumbers: "زي",
      pass: "تمريرة",
      carryAndPass: "حمل وتمرير",
      carryAndAction: "حمل و مبادرة",
      carryAndShot: "حمل و تسديد",
      shotFailed: "تسديدة فاشلة",
      goal: "هدف",
      savedShot: "تسديدة تم التصدي لها",
      missedShot: "تسديدة ضائعة",
      shotOnPost: "تسديدة علئ القائم",
      headerGoal: "هدف بالرأس",
      headerFailed: "رأسية ضائعة",
      failed: "فشل"
    },
    report: {
      title: "تقرير المباراة",
      maps: "خرائط",
      xGRace: "سباق xG",
      lineups: "التشكيلات",
      button: "قم بإنشاء تقرير PDF كامل عن المباراة  ",
      mobileButton: "تقرير بصيغة PDF",
      most: "معظم"
    }
  },
  general: {
    1: "واحد",
    2: "اثنين",
    3: "ثلاثة",
    4: "أربعة",
    5: "خمسة",
    create: "يخلق",
    save: "ينقذ",
    cancel: "يلغي",
    delete: "يمسح",
    edit: "يحرر",
    go: "يذهب",
    formErrors: {
      required: "الحقل مطلوب",
      passwordMatch: "كلمة المرور غير متطابقة",
      minLength: "الحد الأدنى للطول",
      maxLength: "الحد الأقصى للطول",
      emailValid: "يجب ان يكون البريد الاكتروني صحيح",
      youthAge: "يجب أن يكون العمر بين 10 و23",
      seasonYear: "يجب أن تكون السنة بين 2016 و2050",
    },
    confirmationTitle: "هل أنت متأكد؟",
    confirmationMessage: "يرجى تأكيد ما إذا كنت تريد تنفيذ الإجراء",
    yes: "نعم بالتأكيد",
    no: "لا",
    search: "بحث",
    clearFilters: "مسح المرشحات",
    minimum: "الحد الأدنى",
    maximum: "الحد الأقصى",
    minimumPercent: "(%)الحد الأدنى للنسبة المئوية",
    period: "فترة",
    exclude: "استبعاد",
    team: "فريق",
    clear: "واضح",
    all: "الجميع",
    filter: "منقي",
    noData: "لم يتم العثور على نتائج",
    noDataGivenFilters: "لم يتم العثور على نتائج مع المرشحات المحددة",
    similarityNoData: "لم يتم اضافته في أداة التشابه",
    similarityMinutesWarning: "لا توجد بيانات لأن دفائق اللعب أقل من 450 ",
    close: "يغلق",
    load: "حمولة",
    filters: "المرشحات",
    players: "اللاعبين",
    teams: "فرق",
    compare: "قارن",
    seeMore: "شاهد المزيد",
    seeLess: "انظر أقل",
    request: "طلب",
    notes: "ملحوظات",
    closeSession: "خروج",
    settings: "إعدادات",
    player: "لاعب",
    state: "حالة",
    updated: "حدّث",
    file: "ملف",
    uploadFile: "تحميل ملف",
    reports: "التقارير",
    download: "تحميل",
    new: "جديد",
    comparison: "مقارنة",
    scout: "كشاف",
    favorites: "المفضلة",
    moreOptions: "المزيد من الخيارات",
    lessOptions: "خيارات أقل",
    today: "اليوم",
    home: "المستضيف",
    away: "الضيف",
    until: "حتى",
    firstHalf: "النصف الاول",
    secondHalf: "النصف الثاني",
    firstPeriodOT: "الشوط الأول الاضافي",
    secondPeriodOT: "الشوط الثاني الاضافي",
    postponed: "مؤجل",
    stats: "احصائيات",
    yesterday: "أمس",
    last: "آخر",
    startDate: "تاريخ البدء",
    active: "نشيط",
    playerLimit: "حد اللاعبين",
    type: "يكتب",
    successMessage: "لقد كانت العملية ناجحة",
    failMessage: "لقد فشلت العملية",
    by: "بواسطة",
    checkYourInbox: "تحقق من بريدك الوارد",
    faq: "قائمة المصطلحات",
    globalSearch: "البحث العام",
    gamesLost: "المباريات المفقودة",
    outOf: "خارج",
    avgSeason: "متوسط ​​الموسم",
    leftDays: "الأيام المتبقية",
    notifyError: "إعلام بالخطأ",
    notify: "أبلغ",
    comments: "تعليقات",
    searches: "عمليات البحث",
    now: "الآن",
    twoHoursAgo: "قبل ساعتين",
    incomings: "الوصول",
    departures: "المغادرة",
    transferLoans: "القروض",
    transfers: "التحويلات",
    movements: "الحركات",
    incomes: "الدخل",
    expenditures: "النفقات",
    action: "فعل",
    target: "هدف",
    uses: "الاستخدامات",
    users: "المستخدمين",
    since: "منذ",
    mediaMode: "وضع الوسائط",
    white: "أبيض",
    enabled: "ممكّن",
    disabled: "غير ممكّن",
    left: "يسار",
    right: "يمين",
    both: "كلاهما",
    'left-both': 'يسار كلاهما',
    'right-both': 'يمين كلاهما',
    'left foot': 'يسار',
    'right foot': 'يمين',
    files: "ملفات",
    confirm: "يتأكد",
    currentStep: "الخطوة الحالية",
    phases: "المراحل",
    entries: "إدخالات",
    none: "لاشيئ",
    times: "مرات",
    darkMode: "الوضع الداكن",
    client: "عميل",
    visits: "الزيارات",
    lastVisit: "الزيارة الأخيرة",
    strong: "قوي",
    medium: "متوسط",
    weak: "ضعيف",
    goal: "هدف",
    list: "قائمة",
    map: "خريطة",
    copiedToClipboard: "نسخ إلى الحافظة",
    division: "قسم",
    many: "كثير",
    few: "عدد قليل",
    median: "الوسيط",
    topRight: "اعلى اليمين",
    topLeft: "أعلى اليسار",
    bottomRight: "أسفل اليمين",
    bottomLeft: "أسفل اليسار",
    library: "مكتبة",
    mediaLibrary: "مكتبة الوسائط",
    for: "ل",
    stat: "الإحصائيات",
    position: "مركز",
    order: "طلب",
    add: "يضيف",
    visualization: "التصور",
    basic: "أساسي",
    selectAll: "اختر الكل",
    unselectAll: "إلغاء تحديد الكل",
    distribution: "توزيع",
    end: "نهاية",
    accuracy: "دقة",
    opponent: "الخصم",
    center: "مركز",
    line: "خط",
    live: "مباشر",
    unavailable: "غير متوفره",
    calendar: "تقويم",
    activeLeague: "الدوري في التقدم",
    similarity: "تشابه",
    emptyForSelectAll: "فرّغ تحديد الكل",
    size: "مقاس",
    selectPlayersRestriction: "اختر بين 1 و{x} من اللاعبين",
    group: "مجموعة",
    alerts: "التنبيهات",
    shortcuts: "الاختصارات",
    share: "شارك",
    dataAvailable: "بعض الإحصائيات ستكون متاحة قريبًا",
    someStatsAvailableSoon: "بعض الإحصائيات ستكون متاحة قريبًا",
    monthGamesWarning: 'ألعاب الشهر المحدد ستكون متاحة قريبًا',
    competition:"مسابقة",
    code:"رمز",
    alias:"الاسم المستعار",
    never: "أبداً",
    unlimited: "غير محدود",
    user: "مستخدم",
    warning: "تحذير",
    requests: "طلبات",
    contactSales: "اتصل بالمبيعات",
    comingSoon: "قريباً!",
    youth:"شباب",
    male:"ذكر",
    processing: "يعالج",
    addNew: "إضافة جديد",
    createdBy: "أنشئ بواسطة",
    downloading: "جارٍ التنزيل",
    displayType: "نوع العرض",
    alreadyExists: 'موجود أصلا',
    aggregation:"تجميع",
    unavailableLeagues: 'لا يمكنك الوصول إلى أي من الدوريات التي لعب فيها اللاعب',
    meters:"Meters",
    quantity:"Quantity",
    allTime:"All Times",
    games:"Games",
    unit: "وحدة",
    categories: "فئات",
    maintenanceWarning: "جاري الصيانة",
    maintenanceMessage: "نقوم ببعض التحديثات حاليًا. التغييرات التي تجريها الآن لن يتم حفظها. شكرًا على صبرك!",
  },
  playerScout: {
    dlabDatabase: "قاعدة بيانات Driblab",
    league: "الدوري",
    top5: "أفضل 5",
    topCountries: "بلدان",
    tier: "الدرجة",
    division1: "الدرجة الأولى",
    division2: "الدرجة الثانية",
    division3: "الدرجة الثالثة",
    division4: "الدرجة الرابعة",
    division5: "الدرجة الخامسة",
    summary: "ملخص",
    offensive: "عن",
    defensive: "مواطنه",
    gk: "حارس مرمى",
    all: "الجميع",
    physical: "بدني",
    arrigo: "أريجو",
    yearTooltip: "مسموح سنة واحدة فقط",
    expectedThreat: "xThreat",
    expectedThreatTooltip: "التهديد مضاف إلى جميع الاستحواذات",
    expectedThreatOP: "xThreat OP",
    expectedThreatOPTooltip: "تمت إضافة التهديد إلى استحواذات اللعب المفتوح",
    expectedThreatInTeam: "xThreat في الفريق%",
    expectedThreatInTeamTooltip: "نسبة مئوية. من التهديد الذي أضافه اللاعب إلى الفريق",
    ballProgression: "تقدم الكرة",
    ballProgressionTooltip: "تقدم +10 متر",
    deepProgression: "التقدمات العميقة",
    deepProgressionTooltip: "تقدم الكرة إلى الخمس الأخير من الملعب ",
    ballRetention: "% الاحتفاظ بالكرة",
    ballRetentionTooltip: "النسبة المئوية للإجراءات التي تم فيها الاحتفاظ بالكرة بنجاح",
    ballRetentionOppHalf: "% الاحتفاظ بالكرة OH ",
    ballRetentionOppHalfExplicit: "النسبة المئوية للوقت الذي تستحوذ فيه على الكرة ولا ينتهي بك الأمر بفقدها في نصف ملعب الخصم",
    finishing: "الانهاء",
    finishingTooltip: "نسبة مئوية. من التسديدات التي انتهت بالهدف",
    scoringContribution: "مساهمة التهديف",
    scoringContributionTooltip: "تمريرات حاسمة + أهداف",
    xgPerShot: "xG لكل تسديدة ",
    xgPerGoal: "xG لكل هدف",
    headerPerCross: "رأسية لكل توزيعة",
    completedCrosses: "التوزيعات المكتملة",
    crossingPct: "توزيع %",
    crossingEfficiency: "فعالية التوزيع",
    crossingEfficiencyTooltip: "فعالية التوزيع (قيس الجودة والكمية)",
    longBalls: "الكرات الطويلة",
    longPassing: "٪ كرة طويلة",
    dribblingPct: "المراوغة ٪",
    throughBalls: "الكرات البينية",
    oppBoxTouches: "لمسات داخل منطقة جزاء الخصم",
    oppBoxTouchesTooltip: "اللمسات في منطقة جزاء الخصم",
    openPlayKeyPasses: "تمريرات مفتاح OP",
    openPlayKeyPassesTooltip: " تمريرات من اللعب المفتوح التي تنتهي بـتسديدة",
    xGBuildup: "تراكم XG",
    xGBuildupTooltip: "xG من التسلسلات التي تنتهي بلقطة شارك فيها اللاعب (باستثناء xG من التسديدة والتمريرة المفتاحية)",
    Assists: "التمريرات الحاسمة",
    passPercentage: "% تمرير",
    passPerLongBall: "تمرير لكل LB",
    passPerLongBallExplicit: "تمرير لكل كرة طويلة",
    nonPenaltyGoals: "أهداف غير ركلات الجزاء",
    xG: "xG",
    xGExplicit: "الأهداف المتوقعة",
    shots: "تسديدات",
    xGShot: "xG لكل تسديدة ",
    xGChain: "سلسلة xG",
    xGChainTooltip: "xG من التسلسلات التي تنتهي بتسديدة التي شارك فيها اللاعب",
    chancesCreated: "تمريرات تليها تسديدة",
    chances: "فرص",
    dribbles: "المراوغات",
    dribblesSuccessfull: "المراوغات ناجحة",
    touches: "اللمسات في منطقة جزاء الخصم",
    xA: "xA",
    xAExplicit: "التمريرات الحاسمة المتوقعة",
    xAOpenPlay: "xA OP",
    xAOpenPlayExplicit: "التمريرات الحاسمة المتوقعة من اللعب المفتوح",
    passesOpponentBox: "تمريرات في منطقة جزاء الخصم",
    passesOB: "تمريرات في OB",
    passesFinalThird: "تمريرات في النهائي â…“",
    passesFinalThirdTooltip: "التمريرات في الثلث الأخير",
    passesSuccessful: "التمريرات الناجحة",
    passesSuccessfulTooltip: "التمريرات الناجحة  ",
    ballProgressionPassing: "BP عن طريق التمرير",
    ballProgressionPassingTooltip: "تقدم الكرة عن طريق التمرير",
    ballProgressionDribbling: "BP عن طريق الحمل",
    ballProgressionDribblingTooltip: "تقدم الكرة عن طريق الحمل",
    passesTotal: "تمريرات",
    passesTotalTooltip: "إجمالي عدد التمريرات التي تمت محاولتها",
    shortPassesSuccessful: "نجاح. SP",
    shortPassesSuccessfulTooltip: "عدد التمريرات القصيرة المكتملة",
    shortPassesTotal: "إجمالي SP",
    shortPassesTotalTooltip: "عدد محاولات التمريرات القصيرة",
    tackles: "التدخلات *",
    adjustedTackles: "التدخلات معدلة حسب الاستحواذ",
    interceptions: "الاعتراضات *",
    adjustedInterceptions: "الاعتراضات معدلة على الحيازة",
    aerials: "هوائيات",
    aerialsPercent: "هوائيات %",
    aerialEfficiency: "فعالية الهوائيات",
    aerialEfficiencyTooltip: "الفعالية الهوائية (قياس الجودة والكمية)",
    twd: "TwD",
    tacklesWasDribbled: "تدخلات تمّ مراوغتها",
    fouls: "الأخطاء",
    indPressure: "الضغط الفردي",
    pressure: "ضغط",
    dispossessed: "مسلوب",
    recoveries: " الكرات المستردة ",
    primary: "أساسي",
    secondary: "ثانوي",
    position: "مركز",
    nationality: "جنسية",
    height: "الطول (سم)",
    minHeight: "الطول الأدنى",
    maxHeight: "الطول الأقصى",
    age: "عمر",
    minAge: "العمر الأدنى",
    maxAge: "العمر الأقصى",
    games: "المباريات",
    minGames: "الحد الأدنى لعدد مباريات اللعب",
    maxGames: "الحد الأقصى لعدد مباريات اللعب",
    minutes: "دقائق",
    minMinutes: "الحد الأدنى لعدد دقائق اللعب",
    maxMinutes: "الحد الأقصى لعدد دقائق اللعب",
    minPercentMinutes: "النسبة المئوية الأدنى دقائق اللعب",
    dates: "تواريخ",
    marketValue: "القيمة السوقية  (â‚¬)",
    teams: "فرق",
    contractEnd: "نهاية العقد",
    minValue: "القيمة السوقية الأدنى",
    maxValue: "القيمة السوقية الأقصى",
    excludeTeams: "استبعاد الفرق",
    recentSearches: "عمليات البحث الأخيرة",
    saveSearch: "حفظ البحث",
    loadSearch: "تحميل البحث",
    search: 'بحث',
    searchesList: "قوائم البحث",
    mySearches: "عمليات البحث الخاصة بي",
    mySearchesDescription: "تلك التي قمت بحفظها سابقًا",
    recentSearchesDescription: "آخر 10 عمليات بحث قمت بها",
    searchToLoad: "بحث للتحميل",
    recentSearch: "البحث الأخير",
    saveSearchSuccess: "تم حفظ البحث بنجاح",
    removeSearch: "حذف البحث",
    removeSearchMessage: "هل أنت متأكد أنك تريد حذف البحث؟",
    deleteSearchSuccess: "تم حذف البحث",
    playersFound: "تم العثور على اللاعبين",
    addAllToCollection: "أضف الكل إلى المجموعة",
    npg: "NPG",
    goals: "الأهداف",
    value: "قيمة",
    nationalTeams: "المنتخبات الوطنية",
    gbeScore: "GBE",
    dlIndex: "نتيجة",
    minGbe: "GBE الأدنى",
    goalsConceded: "الأهداف المقبولة",
    npgConceded: "NPG المقبولة",
    npgConcededTooltip: "الأهداف دون ركلات الجزاء المقبولة",
    xGOTConceded: "xG المؤطرالمقبول",
    xGOTConcededTooltip: "xG من التسديدات المؤطرةالمقبولة",
    goalsPrevented: "الأهداف التي تم التوقي منها",
    xGFacedPerShotOnTarget: "xGOT لكل تسديدة",
    xGFacedPerShotOnTargetTooltip: "xG المؤطر لكل تسديدة مقبولة",
    xGSavedPerxGFacedOnTarget: "xG الذي تم التوقي منه",
    xGSavedPerxGFacedOnTargetTooltip: "نسبة التصدي مع أخذ  بعين الاعتبار xG",
    savesPct: "٪ إنقاذ",
    savesOutOfBoxPct: "التصدي خارج منطقة الجزاء %",
    savesInBoxPct: "التصدي داخل منطقة الجزاء %",
    xGFacedPerGoal: "xG مواجه لكل هدف",
    xGFacedPerGoalTooltip: "xG اللازمة لتسجيل هدف",
    catchingPct: "% اصطياد",
    catchingTooltip: "نسبة مئوية من التصديات التي تم مسكها",
    passingOwnHalfPct: "التمرير في نصف الملعل الخاص به %",
    passingOwnHalfPctTooltip: "نسبة التمريرات الناجحة في نصف الملعب الخاص",
    passingOppHalfPct: "التمريرات في نصف ملعب الخصم ٪",
    passingOppHalfPctTooltip: "نسبة التمريرات الناجحة في نصف ملعب الخصم",
    passingContribution: "نسبة المساهمة في التمرير %",
    passingContributionTooltip: "مساهمة في التهديد بتمرير الكرة – فوق المتوسط",
    shotsPerGoal: "عدد التسديدات لكل هدف",
    passingFinalThird: "نسبة التمريرات الناجحه في النهائي â…“",
    claimAccuracy: "دقة المطالبة",
    claimAccuracyTooltip: "الكرات المطالب بها أعلى من المتوسط",
    highTurnovers: "معدل خسارة كرة مرتفع",
    highTurnoversTooltip: "خسارة كرة  أقرب من 40 مترا إلى المرمى",
    shotEndingHighTurnovers: "نهاية التسديدة HT ",
    shotEndingHighTurnoversTooltip: "تسديدة تنهيبمعدلات خسارة كرة عالية",
    goalEndingHighTurnovers: "نهاية الهدف HT",
    goalEndingHighTurnoversTooltip: "هدف ينهي بمعدلات خسارة كرة عالية",
    avgCarriesProgress: "متوسط ​​التقدم",
    avgCarriesProgressTooltip: "متوسط ​​مسافة تحريك الكرة عموديا (بالأمتار)",
    carriesChance: "انهاء فرصة",
    carriesChanceTooltip: "التحولات المتبوعة بتمريرة مفتاحية",
    carriesAssist: "إنهاء تمريرة حاسمة",
    carriesAssistTooltip: "التحولات المتبوعة بتمريرة حاسمة",
    carriesShot: "انهاء تسديدة",
    carriesShotTooltip: "التحولات المتبوعة بتسديدة",
    carriesGoal: "نهاية الهدف",
    carriesGoalTooltip: "التحولات المتبوعة بهدف",
    shotEndingSequence: "نهاية بتسديدة",
    shotEndingSequenceTooltip: "عدد التسلسلات التي انتهت بتسديدة قد شارك فيها اللاعب",
    goalEndingSequence: "نهاية الهدف",
    goalEndingSequenceTooltip: "عدد التسلسلات التي تنتهي بهدف شارك فيه اللاعب",
    gbeScoreTooltip: "مساندة مجلس إدارة الاتحاد الإنجليزي لكرة القدم",
    goalsPreventedTooltip: "الأهداف التي تم التصدى لها دون ركلات الجزاء (مواجهة xG - استقبال NPG)",
    freePlayers: "لاعبين أحرار",
    index: "فِهرِس",
    playerName: "اسم",
    teamName: "فريق",
    secondPos: "Second Pos.",
    side: "جانب",
    dob: "ولادة",
    countryName: "دولة",
    secondCountryName: "الدولة الثانية",
    leagueName: "الدوري",
    seasonYear: "موسم",
    assists: "تمريرات حاسمة",
    placeholder: "يمكنك البدء بإضافة بعض مرشحات الدوري",
    placeholder2: 'انقر فوق زر البحث لإظهار النتائج',
    passesPct: "التمريرات٪",
    passingPct: " التمريرات٪  ",
    oppBoxPasses: " التمريرات في منطقة جزاء الخصم  ",
    adjustedClearances: "تشتيتات الكرة المعدلة",
    aerialsPct: "هوائيات %",
    leagueCountryCode: "رمز البلد للدوري",
    shooting: "٪ التسديدات على المرمى",
    xtPassing: "xT من التمرير",
    xtPassingTooltip: "التهديد المضاف بالتمرير",
    xtDribbling: "xT بالتحولات",
    xtDribblingTooltip: "التهديد المضاف عن طريق التحولات",
    foot: "القدم القوية",
    aggressiveActions: "الإجراءات العدوانية",
    aggressiveActionsTooltip: "عدد محاولات التدخل في الثانيتين التاليتين بعد فقدان الاستحواذ",
    tacklesAttempted: "محاولات التدخل",
    highDefensiveActionPct: "٪ HD الإجراءات",
    highDefensiveActionPctTooltip: "نسبة الحركات الدفاعية التي تم إجراؤها على مسافة 40 مترًا من مرمى الخصم",
    individualPressureOppHalf: "الضغط في نصف ملعب الخصم",
    individualPressureOppHalfTooltip: "مقياس يقيس عدد المحاولات الناجحة (استعادة الاستحواذ) التي يقوم بها اللاعب عند الضغط على الخصم في نصف ملعب الخصم",
    xGBuildUp5Pass: "تسلسلات xG5p ",
    xGBuildUp5PassTooltip: "كمية xG التي شارك فيها اللاعب، آخر 5 تمريرات فقط (باستثناء التسديدات والتمريرات المؤدية إلى التسديدة)",
    chancesCreatedOpenPlay: "الفرص التي تم إنشاؤها OP ",
    chancesCreatedOpenPlayTooltip: "عدد التمريرات المؤدية للتسديدة أثناء اللعب المفتوح",
    fmf: {
      Defender: "مدافع",
      aerial: "جوي",
      goodDefender: "مدافع جيد",
      goodPresence: "حضور جيد",
      playmaking: "صناعة اللعب",
      Fullback: "الظهير",
      defensiveness: "الدفاعية",
      offensiveness: "الهجوم",
      fast: "سريع",
      Forward: "مهاجم",
      goalChances: "فرص الأهداف",
      goodDecissions: "قرارات جيدة",
      individualTechnique: "التقنية الفردية",
      Goalkeeper: "حارس مرمى",
      footWork: "حركة القدمين",
      leadership: "قيادة",
      Midfielder: "لاعب خط وسط دفاعي",
      balance: "توازن",
      ballRetention: "% الاحتفاظ بالكرة",
      offensivePasses: "تمريرات هجومية",
      recoveries: "الكرات  المستردة",
      shotToGoal: "تسديدة على المرمى",
      "Attacking-Midfielder": "لاعب وسط مهاجم",
      defensiveGame: "لعبة دفاعية",
      offensiveGame: "لعبة هجومية",
      Winger: "الجناح",
      crossing: "التوزيع",
      deepProgressions: "التقدمات العميقة",
      defendingEffort: "مجهود دفاعي  ",
      facing: "مواجهة"
    },
    yellowCards: "البطاقات الصفراء",
    redCards: "البطاقات الحمراء",
    alert: "تحذير",
    yearOfBirth: "سنة الميلاد",
    minYearOfBirth: "سنة الميلاد الأدنى",
    maxYearOfBirth: "سنة الميلاد الأقصى",
    women: "نساء",
    continental: "قارية",
    countryCup: " كأس الدولة",
    statsName: "اسم الإحصائية",
    abbreviation: "اختصار",
  },
  playerComparison: {
    upTo5Players: "قارن ما يصل إلى 5 لاعبين",
    requestReport: "طلب تقرير",
    searchBarPlaceholder: "لمقارنة لاعب، ابحث عنه واختره",
    allStats: "كل الاحصائيات",
    placeholder: "يمكنك البدء بإضافة بعض اللاعبين"
  },
  reports: {
    detailedInsights: "احصل على معلومات مفصلة",
    features: "مميزات التقرير",
    performance: "أداء",
    evolution: "تطور",
    compareWithMyTeam: "قارن مع فريقي",
    similarPlayers: "لاعبين مشابهين",
    potentialTeams: "الفرق المحتملة",
    requestSuccess: "تم إرسال الطلب بنجاح",
    requestAt: "مطلوب",
    reportConversation: "الإبلاغ عن المحادثة",
    writeYourMessage: "اكتب رسالتك...",
    you: "أنت"
  },
  state: {
    requested: "مطلوب",
    inProgress: "في تَقَدم",
    delivered: "تم التوصيل"
  },
  langs: {
    es: "الأسبانية",
    en: "إنجليزي",
    fr: "فرنسي",
    de: "ألمانية",
    it: "ايطالي",
    pt: "البرتغالية",
    tr: "اللغة التركية",
    jp: "اليابانية",
    cn: "صينى",
    sa: "العربية"
  },
  inbox: {
    subtitle: "ابق على اطلاع",
    new_injury_alert: "تنبيه إصابة جديدة",
    new_contract_alert: "تنبيه عقد جديد",
    new_team_alert: "تنبيه توقيع جديد",
    new_marketValue_alert: "تنبيه القيمة السوقية الجديدة",
    new_game_alert: "تنبيه مباراة جديدة لعبت",
    receive_mail: "تلقي البريد",
    receive_mail_subtitle: "احصل على بريد يومي يحتوي على اللاعبين الذين يستوفون المرشحات  ",
    receive_notifications: "إشعارات",
    receive_notifications_subtitle: "تلقي الإشعارات في التطبيق مع اللاعبين الذين يستوفون المرشحات",
    changedTo: "تغير إلى",
    alerts: "التنبيهات",
    includedIn: "متضمن في",
    noContract: "لا يوجد عقد",
    newMessages: "رسائل جديدة",
    reply: {
      reply: "Reply",
      replyTitle: "Give feedback to the client:",
      replyPlaceholder: "The user will receive the reply along with the status update"
    }
  },
  gameAnalysis: {
    subtitle: "احصل على معلومات من أحدث المباريات",
    subtitle2: "عرض المباريات في الأيام السبعة القادمة",
    seeDetail: "انظر التفاصيل"
  },
  statsNaming: {
    Possession: "استحواذ",
    TimePossession: 'وقت الاستحواذ',
    PassesPerShots: "التمريرات لكل تسديدة",
    PPDA: "PPDA",
    ExpectedPoints: "النقاط المتوقعة",
    Points: "نقاط",
    Directness: "المباشرة",
    PassesPerLongBall: "التمريرات لكل كرة طويلة",
    CrossingPerXG: "التوزيعات لكل xG",
    PenaltySavedPenaltyFaced: "تم التصدي لضربة الجزاء / مواجهة ضربة الجزاء",
    Goals: "الأهداف",
    NonPenaltyGoals: "أهداف غير ركلات الجزاء",
    NPGOpenPlay: "NPG من اللعب المفتوح",
    NPGSetPiece: "NPG من الكرات الثابتة",
    Shooting: "التسديد",
    Finishing: "الأنهاء",
    xGEfficiency: "كفاءة xG",
    HeaderPerShot: "الرئسية لكل تسديدة",
    HeaderPerCross: "الرئسية لكل عرضية",
    Assists: "التمريرات الحاسمة",
    ThroughBalls: "الكرات البينية",
    CrossEfficiency: "كفاءة العرضيات",
    ScoringContribution: "مساهمة التهديف",
    xAssistsOpenPlay: "xAssists من اللعب المفتوح",
    xAssistsSetPiece: "xAssists من الكرات الثابتة",
    xAssistsOpenPlayInTeam: "xAssists من اللعب المفتوحفي الفريق",
    xAssistsSetPieceInTeam: "xAssists من الكرات الثابتةفي الفريق",
    xGBuildupFinalThird: "تسلسل xG النهائي",
    xGChainFinalThird: "نهائي سلسلة xG â…“",
    BallProgressionPassing: "تقدم الكرة عبر التمرير",
    BallProgressionDribbling: "تقدم الكرة عبر التحولات",
    TacklesWasDribbled: "التدخلات / تم مراوغتها",
    TacklesSuccessful: "تدخلات ناجحة.",
    TacklesUnsuccessful: "تدخلات غير ناجحة",
    Interceptions: "اعتراضات",
    Clearances: "الموافقات",
    Fouls: "الأخطاء",
    Recoveries: "استردادات",
    Shots: "تسديدات",
    ShotsPerGoal: "عدد التسديدات لكل هدف",
    ShortPassesSuccessful: "التمريرات القصيرة الناجحة",
    PassingSuccessForwardPct: "التمريرات الأمامية الناجحة٪",
    PassingSuccessBackwardPct: "التمريرات الخلفية الناجحة٪",
    PassingForwardBackwardPct: "نسبة التمرير الأمامي بالنسبة خلفي",
    LongBallPerPassesPct: "% كرة طويلة لكل تمريرة",
    LongBallReceived: "تلقى الكرة الطويلة",
    LongBallReceivedOppHalf: "الكرات الطويلة المتلقات في نصف ملغب الخصم",
    OffensiveActions: "الإجراءات الهجومية",
    DribblesAttempted: "محاولة المراوغات",
    SuccessfulDribblesPct: "% المراوغات الناجحة",
    OffensiveTouchesOutBoxPct: "% اللمسات الهجومية خارج منطقة الجزاء",
    BallRetention: "% الاحتفاظ بالكرة",
    PassingPct: "% تمرير",
    PassingOwnHalfPct: "% تمرير النصف الخاص",
    PassingOppHalfPct: "٪ تمرير في نصف ملغب الخصم",
    PassingFinalThird: "التمرير إلى النهائي â…“",
    PassingFinalThirdPct: "نسبة التمرير إلى النهائي â...",
    LongBallSuccessful: "الكرات الطويلة المكتملة",
    LongBallPct: "% كرات طويلة",
    SavesPct: "التصديات",
    SavesInBoxPct: "التصديات داحل منطقة الجزاء%",
    SavesOutOfBoxPct: "نسبة التصديات خارج الصندوق ",
    xGSavedPerXGFacedOnTarget: "تم مواجهته xG/ xG تم التصدي له",
    xGFacedOnTargetPerGoalReceived: "xG تم مواجهته لكل هدف",
    xGFacedOnTargetEfficiency: "الأهداف المحظورة",
    xGFacedOnTarget: "xG المؤطر تمت مواجهته  ",
    IndividualPressure: "الضغط الفردي",
    AerialEfficiency: "الفعالية الهوائية",
    AerialWins: "الانتصارات في الثنائيات الهوائية",
    AerialWinsPct: "الانتصارات في الثنائيات الهوائية %",
    xG: "الأهداف المتوقعة",
    xGDiff: "الفرق xG",
    xGOpenPlay: "xG اللعب المفتوح",
    xGSetPiece: "xG الكرات الثابتة",
    xGPerShot: "xG لكل تسديدة",
    ChancesCreated: "صناعة الفرص",
    Crossing: "التوزيع ٪",
    OpenPlayKeyPasses: "التمريرات المفتاحية من اللعب المفتوح",
    OpenPlayKeyPassesInTeam: '% تمريرات مفتاح اللعب المفتوحة في الفريق',
    OpenPlayPassesIntoOpponentBox: "OP تمريرات في منطقة جزاء الخصم",
    OpenPlayPassesIntoOpponentBoxSuccessful: "OP تمريرات في منطقة جزاء الخصم",
    xAssists: "التمريرات الحاسمة المتوقعة",
    xGChain: "سلسلة xG",
    xGBuildup: "بناء xG",
    BallProgression: "تقدم الكرة",
    SuccessfulDribbles: "مراوغات ناجحة",
    Dispossessed: "افتكاك",
    TouchesInOpponentBox: "اللمسات في منطقة جزاء الخصم",
    xGSavedPerShot: "xG تم التصدي له لكل تسديدة",
    BallRetentionOppHalf: "% الاحتفاظ بالكرةفي نصف ملعب الخصم",
    DeepProgression: "التقدم العميق",
    DeepProgressionFinalThird: "تقدم عميق إلى النهائي â…“",
    FoulsTaken: "الأخطاء المستلمة",
    PenaltiesTaken: "ضربات الجزاء المسددة",
    BlockedCrosses: "توزيعات تم منعها",
    BlockedShots: "تسديدات تم منعها",
    Blocks: "إعترض ",
    NonPenaltyGoalsAgainst: "الأهداف دون ركلات الجزاء المقبولة",
    Headers: "الرئسيات",
    AveragePassDistance: "متوسط ​​مسافة التمرير",
    ProgressiveRuns: "جري بالكرة تقدمي",
    xT: "التهديد المتوقع (xT)",
    xTOpenPlay: "من اللعب المفتوح xT",
    xTSetPiece: "من الكرات الثابتةxT ",
    xGOT: " الأهداف المتوقعة المؤطرة",
    BadActions: 'تصرفات سيئة',
    BadActionsOwnHalf: " الأفعال السيئة في نصف الملعب الخاص",
    AerialsWonOwnBox: "الانتصارات في الثنائيات الهوائية في منطقة جزاء الخصم",
    AerialsWonOppBox: "الانتصارات في الثنائيات الهوائية في منطقة جزاء الخصم",
    AerialsTotalOppBox: "إجمالي الانتصارات في الثنائيات الهوائية في منطقة جزاء الخصم",
    AerialsTotalOwnBox: "إجمالي الانتصارات في الثنائيات الهوائية في منطقة جزاء الخصم",
    FoulsOwnHalfPct: "الأخطاء في نصف الملعب الخاص ",
    RecoveriesOppHalf: "الاستردادفي نصف ملعب الخصم",
    DuelsPct: "الثنائيات  الناجحة %",
    TacklesWasDribbledFirstThird: "التدخلات/تم مراوغتها â...",
    BallProgressionFinalThird: "تقدم الكرة  النهائي  â…“",
    DuelsTotal: "الثنائيات",
    QuickRecoveries: "الاسترداد السريع",
    ShotsPerNPG: "التسديدات لكل NPG",
    ShotsOutBox: "تسديدات من خارج منطقة الجزاء",
    GoalsOutBox: "أهداف من خارج منطقة الجزاء",
    ShootingOutBox: "التسديد من خارج منطقة الجزاء%",
    HandPassing: "% تمرير اليد",
    Catching: "امساك %",
    ClaimAccuracy: "",
    HighTurnovers: "معدل خسارة كرة عالي",
    ShotEndingHighTurnovers: "إنهاء التسديد بمعدلات خسارة كرة عالية",
    GoalEndingHighTurnovers: "إنهاء الهدف بمعدلات خسارة كرة عالية",
    AverageCarriesProgress: "متوسط ​​تقدم التحولات",
    ChanceEndingCarries: "التحولات التي تنتهي بفرصة",
    AssistEndingCarries: " التحولات التي تنتهي بتمريرة حاسمة",
    ShotEndingCarries: "التحولات التي تنتهي بتسديدة",
    GoalEndingCarries: "التحولات التي تنتهي بهدف",
    ShotEndingSequence: "تسلسل ينتهي بتسديدة",
    GoalEndingSequence: "تسلسل ينتهي بهدف",
    xGPerNPG: "xG لكل NPG",
    AerialWonOffensive: "الانتصارات في الثنائيات الهوائية الهجومية",
    AerialWonDefensive: "الانتصارات في الثنائيات الهوائية الدفاعية",
    xGAgainst: "تم استلامه xG",
    xGPerNPGAgainst: "xG لكل NPG تم استلامه",
    xGSetPieceAgainst: "تم قبوله عن الكرات الثابتة xG",
    xGPerShotAgainst: "xG لكل تسديدة يتم تلقيها",
    ShotsAgainst: "التسديدات المقبولة",
    ShotsOnTargetAgainst: "تسديدات على المرمى",
    RivalPossession: "استحواذ الخصم",
    AerialDefensivePct: "الثنائيات الهوائية الدفاعية%",
    HighRecoveries: "معدلات استرداد عالية",
    HighDefensiveActionPct: "% إجراءات دفاعية عالية",
    HighDefensiveDistance: "مسافة دفاعية عالية",
    PassesPerPossession: "التمريرات لكل استحواذ",
    LengthPerPossession: "المسافة لكل حيازة",
    xTNet: "صافي xT",
    AvgCarriesDistance: "معدل مسافةالتحولات",
    PassesForwardPct: "% التمريرات للأمام",
    TacklesAttempted: "التدخلات المحاولة",
    DuelsLost: "الثنائيات المخسورة",
    Carries: "التحولات",
    CarriesPct: "التحولات%",
    Aerials: "هوائيات",
    ProgressivePassesReceivedIntoBox: "التمريرات التقدمية المستلمة  في منطقة جزاء الخصم",
    PassesOppHalf: "التمريرات في نصف ملعب الخصم",
    CompletedCrosses: "التوزيعات المكتملة",
    ShotsOnTarget: "التسديدات على المرمى",
    AggressiveActions: "الإجراءات العدوانية",
    Crosses: "التوزيعات",
    xGBuildup5pass: "xGBildup 5 تمريرات",
    DefensiveDistance: "المسافة الدفاعية",
    SpeedSequence: "سرعة التسلسل",
    Touches: "اللمسات",
    AerialsTotalOppHalf: "إجمالي الهوائيات في نصف ملعب الخصم",
    AerialsOppHalf: " الهوائيات في نصف ملعب الخصم",
    AerialsWonOppHalfPct: "الانتصارات في  الهوائيات في نصف ملعب الخصم %",
    AerialsPctOppBox: "لانتصارات في  الهوائيات فيمنطقة جزاء الخصم %",
    AerialsPctOwnBox: "الانتصارات في  الهوائيات في منطقة جزاء الخاصة %",
    AerialDefensive: "هوائيات دفاعية",
    AerialOffensive: "هوائياتهجومية",
    AerialOffensivePct: "هوائيات هجومية%",
    IndividualPressureOppHalf: "الضغط الفردي في نصف ملعب الخصم",
    ChancesCreatedOP: "الفرص التي تم خلقتها من اللعب المفتوح",
    TouchesPerShot: "اللمسات لكل تسديدة",
    PassesFinalThirdTotalPct: "% عدد التمريرات النهائية â…“",
    xACrosses: "xA من التوزيعات",
    Passes: "التمريرات",
    PassesSuccessful: "التمريرات الناجحة",
    TacklesWasDribbledFouls: "الثنائيات الأرضية% ",
    OffsidesCaught: "التسللات",
    ProgressivePassesReceivedFinalThird: "التمريرات التقدمية المستلمة النهائية â…“",
    ProgressivePassesReceived: "التمريرات التقدمية المستلمة",
    Breadth: "سعة",
    DuelsDefTotal: "الثنائيات الدفاعية",
    DefensiveActions: "الإجراءات الدفاعية",
    ProgressivePassesReceivedOppHalf: "التمريرات التقدمية المستلمة في  نصف ملعب الخصم",
    CompletedCrossesOP: "العرضيات المكتملة من اللعب المفتوح",
    CrossingOP: "العرضيات من اللعب المفتوح %",
    PassingContribution: "المساهمة المساهمة التمرير %",
    BallProgressionOppHalfInTeam: "تقدم الكرة  في  نصف ملعب الخصم  في الفريق",
    PassesOPIntoBoxInTeam: "التمريرات من اللعب المفتوح في منطقة الجزاء في الفريق",
    TouchesOppBoxInTeam: "اللمسات داخل في منطقة الجزاء الخصم الفريق ٪",
    xGOPInTeam: "xG من اللعب المفتوح في الفريق",
    DeepPasses: "تمريرات عميقة",
    DefensiveDuelsPct: "الثنائيات الدفاعية %",
    QuickRecoveriesPct: "% استرداد سريع",
    DiffDefensiveDistanceTeam: "فرق المسافة الدفاعية في فريق",
    xTPassing: "xT من تمرير",
    xTPassing100Passes: "xT التمرير من 100 تمريرة",
    ProgressivePassesAccurate: "التمريرات التقدمية",
    PassAbility: "القدرة على التمرير",
    OPPassesIntoOppBoxPct: "التمريرات من اللعب المفتوح إلى منطقة جزاء الخصم%",
    EntriesOppBox: "الدخول إلى منطقة جزاء الخصم",
    Crosses6yardBox: "العرضيات الئ منطقةالستة ياردات ",
    Cutbacks: "التخفيضات",
    xTDribbling: "xT من المراوغة",
    AvgShotDistance: "متوسط ​​مسافة التسديد",
    xGOnTarget: " xG المؤطر",
    FinishingxGOT: "xGOT من الانهاء",
    DribblesWonOwnHalf: "المراوغات اللتي أكملت في نصف الملعب الخاص",
    DribblesOwnHalf: "المراوغات في نصف الملعب الخاص",
    DribblesOwnHalfPct: "المراوغات اللتي أكملت في نصف الملعب الخاص%",
    DribblesWonOppHalf: "المراوغات اللتي أكملت في نصف ملعب المنافس",
    DribblesOppHalf: "المراوغات في نصف الملعب الخاص",
    DribblesOppHalfPct: "المراوغات في نصف الملعب الخاص%",
    DribblesWonFinalThird: "المراوغات اللتي أكملت فيالنهائي  â…“",
    DribblesFinalThird: "المراوغات  في النهائي  â…“  ",
    DribblesFinalThirdPct: "المراوغات النهائية  %  â…“",
    ShotEndingHighRecoveries: "افتكاكات عالية تنتهي بتسديدة",
    PassingFinalThirdAgainst: "تمريرات مستلمة في الثلث الأخير",
    OpenPlayPassesIntoOpponentBoxAgainst: "تمريرات مفتوحة مستلمة في المنطقة",
    EntriesOppBoxAgainst: "دخول الخصم إلى منطقتنا",
    DeepProgressionAgainst: "تقدمات عميقة مستلمة",
    TouchesInOpponentBoxAgainst: "لمسات الخصم داخل منطقتنا",
    Score: "نتيجة",
    PDScore: "النتيجة البدنية",
    OrlegiScore: "النتيجة Orlegi",
    SirScore: "النتيجة Sirius",
    xTOPInTeam: "xT OP في الفريق",
    YellowCards: "البطاقات الصفراء",
    RedCards: "البطاقات الحمراء",
    xTOpenPlayAgainst: "xT من اللعب المفتوح تم قبوله ",
    xTSetPieceAgainst: "xT تم قبوله عن الكرات الثابتة",
    NPGOpenPlayAgainst: "تم قبول من اللعب المفتوح NPG",
    NPGSetPieceAgainst: "NPG تم قبول من الكرات الثابتة",
    PassesOppHalfPerPossession: "التمريرات في نصف ملعب الخصم لكل استحواذ",
    AverageTimeRecovery: "متوسط ​​وقت الاسترداد",
    ExpectedPassing: "التمرير المتوقع %",
    NumPossession10Passes: "الحيازة 10 تصاريح مرور 10",
    PassesReceived: "التصاريح المستلمة",
    PassesReceivedFinalThird: "التصاريح المستلمة النهائية ⅓",
    ProgressivePassesTotalPct: "% تصاريح مرور تقدمية",
    ShortPassesPct: '% تمريرات قصيرة',
    TouchesOppBoxOppTeam: "لمسات في منطقة فريقه أثناء مشاركته",
    ShotsOnTargetOppTeam: "تسديدات على المرمى مُستقبَلة أثناء مشاركته",
    NPGOppTeam: "xG بدون ركلات جزاء للفريق الخصم أثناء مشاركته",
    //Physical Stats
    TotalDistance: " المسافة الإجمالية",
    DistanceTIP: "TIP المسافة",
    DistanceOTIP: "المسافة OTIP",
    WalkingDistance: "مسافة المشي",
    JoggingDistance: "مسافة الهرولة",
    RunningDistance: "مسافة الجري",
    ExtremeAccelerations: "تسارع شديد",
    NumberOfRuns: "عدد الجريات",
    HsrNumber: "كمية HSR",
    HsrDistance: "مسافة HSR",
    HsrDistancePct: "المسافة HSR٪",
    SprintsNumber: "كمية الجري السريع",
    SprintsDistance: "مسافة الجري السريع",
    SprintNumberDeclinePct: "٪ انخفاض كمية الجري السريع",
    SprintDistanceDeclinePct: "٪ انخفاض مسافة الجري السريع",
    SprintDistancePct: "مسافة الجري السريع %",
    Accelerations: "كمية التسارع",
    ExplosiveDistance: "المسافة الانفجارية",
    MaxSpeed: "السرعة الأعلى",
    AvgMaxSpeed: "متوسط السرعة الأعلى",
    MaxAccelerations: "التسارعات الأعلى",
    //Arrigo
    BypassedPlayersByPasses: "اللاعبون المتجاوزون",
    BypassedDefendersByPasses: "المدافعون المتجاوزون",
    PassesBypassingPlayers: "التمريرات التي تتجاوز اللاعبين",
    PassesBypassingDefenders: "التمريرات التي تتجاوز المدافعين",
    BypassedPlayersPerPass: "اللاعبون المتجاوزون لكل تمريرة",
    BypassedDefendersPerPass: "المدافعون المتجاوزون لكل تمريرة",
    LineBreakingPasses: "التمريرات الكاسرة للخطوط",
    LineBreakingPassesMD: "التمريرات الكاسرة للخطوط MD",
    LineBreakingPassesM: "",
    LineBreakingThroughBalls: "الكرات البينية الكاسرة للخطوط",
    LineBreakingPassesPerPass: "نسبة التمريرات التي تخترق الخطوط من إجمالي التمريرات",
    TotalPassesUnderStrongPressure: "إجمالي التمريرات تحت ضغط قوي",
    TotalPassesUnderLightPressure: "إجمالي التمريرات تحت ضغط خفيف",
    SuccessfulPassesUnderStrongPressure: "التمريرات تحت ضغط قوي",
    SuccessfulPassesUnderLightPressure: "التمريرات تحت ضغط خفيف",
    PassingUnderStrongPressure: "٪ التمرير تحت ضغط قوي",
    PassingUnderLightPressure: "٪ التمرير تحت ضغط خفيف",
    PassReceiptsInSpaceCompleted: "استلامات التمريرات في المساحات المكتملة",
    PassReceiptsInSpace: "التمريرات المستلمة في المساحات",
    TotalStrongOnBallPressures: "إجمالي الضغوط القوية على الكرة",
    TotalLightOnBallPressures: "إجمالي الضغوط الخفيفة على الكرة",
    SuccessfulStrongOnBallPressures: "الضغوط القوية على الكرة",
    SuccessfulLightOnBallPressures: "الضغوط الخفيفة على الكرة",
    StrongOnBallPressuresPct: "٪ الضغوط القوية على الكرة",
    LightOnBallPressuresPct: "٪ الضغوط الخفيفة على الكرة",
    TimesBypassedByPasses: "تجاوز عبر التمريرات",
    TimesBypassedByCarries: "تجاوز عبر المراوغات",
    TimesBypassedByActions: "تجاوز عبر التحركات",
    BypassedPlayersByCarries: "لاعبون تم تجاوزهم عبر المراوغات",
    BypassedDefendersByCarries: "مدافعون تم تجاوزهم عبر المراوغات",
    BypassedPlayersByActions: "لاعبون تم تجاوزهم عبر التحركات",
    BypassedDefendersByActions: "مدافعون تم تجاوزهم عبر التحركات",
    CarriesBypassingPlayers: "مراوغات تتجاوز اللاعبين",
    CarriesBypassingDefenders: "مراوغات تتجاوز المدافعين",
    BypassedPlayersPerCarry: "عدد اللاعبين المتجاوزين لكل مراوغة",
    BypassedDefendersPerCarry: "عدد المدافعين المتجاوزين لكل مراوغة",
    LineBreakingCarries: "مراوغات بين الخطوط",
    LineBreakingCarriesMD: "مراوغات بين خط الوسط والدفاع",
    LineBreakingCarriesM: "مراوغات بين خط الوسط",
    LineBreakingCarriesD: "مراوغات بين خط الدفاع",
    LineBreakingCarriesPerCarry: "مراوغات بين الخطوط لكل مراوغة",
    LineBreakingActions: "تحركات بين الخطوط",
    LineBreakingActionsMD: "تحركات بين خط الوسط والدفاع",
    LineBreakingActionsM: "تحركات بين خط الوسط",
    LineBreakingActionsD: "تحركات بين خط الدفاع",
    PassesPerLineBreakingPass: "تمريرات لكل تمريرة بين الخطوط",
    CarriesPerLineBreakingCarry: "مراوغات لكل مراوغة بين الخطوط",
    LinesBrokenByPasses: "الخطوط التي تم كسرها بالتمرير",
    LinesBrokenByCarries: "الخطوط التي تم كسرها بالحمل بالكرة",
    LinesBrokenByActions: "الخطوط التي تم كسرها بالإجراءات",
    LinesBrokenPerPass: "عدد الخطوط المكسورة لكل تمريرة",
    LinesBrokenPerCarry: "عدد الخطوط المكسورة لكل حمل",
    AvgLastDefenderDistanceIP: "مسافة آخر مدافع IP",
    AvgLastDefenderDistanceOOP: "مسافة آخر مدافع OOP",
    AvgDefensiveLineDistanceIP: "مسافة خط الدفاع IP",
    AvgDefensiveLineDistanceOOP: "مسافة خط الدفاع OOP",
    AvgRBDistanceIP: "مسافة الظهير الأيمن IP",
    AvgRBDistanceOOP: "مسافة الظهير الأيمن OOP",
    AvgLBDistanceIP: "مسافة الظهير الأيسر IP",
    AvgLBDistanceOOP: "مسافة الظهير الأيسر OOP",
    AvgBlockDistanceIP: "مسافة الكتلة الدفاعية IP",
    AvgBlockDistanceOOP: "مسافة الكتلة الدفاعية OOP",
    AvgBlockAreaIP: "مساحة الكتلة الدفاعية IP",
    AvgBlockAreaOOP: "مساحة الكتلة الدفاعية OOP",
    AvgDefensiveLineWidthOOP: "عرض خط الدفاع OOP",
    AvgOffensiveLineLastThirdWidthIP: "عرض الخط الهجومي في الثلث الأخير IP",
    AvgLByIP: "موقع الظهير الأيسر IP",
    AvgRByIP: "موقع الظهير الأيمن IP",
    AvgOffensiveLineDistanceIP: "مسافة الخط الهجومي IP",
    AvgOffensiveLineLastThirdDistanceIP: "مسافة الخط الهجومي في الثلث الأخير IP",
    AvgOffensiveLineWidthIP: "عرض الخط الهجومي IP",
    OffBallRuns: "إجمالي التحركات بدون كرة",
    OffBallRunsOverlap: "تحركات من الخارج",
    OffBallRunsUnderlap: "تحركات من الداخل",
    OffBallRunsRunAhead: "تحركات للأمام",
    OffBallRunsRunBehind: "تحركات خلف الدفاع",
    OffBallRunsCrossReceiver: "تحرك لتلقي عرضية",
    OffBallRunsSupport: "تحرك لدعم حامل الكرة",
    OffBallRunsComingShort: "تحرك لدعم قريب",
    description: {
      Possession: "نسبة استحواذ الفريق على الكرة",
      TimePossession: 'وقت استحواذ الفريق على الكرة',
      PassesPerShots: "متوسط ​​عدد التمريرات لكل تسديدة",
      PPDA: "التمريرات المسموح للخصم بإكمالها لكل إجراء دفاعي ,الضغط الذي يمارسه الفريق على لاعبي الخصم عندما يكونون في حوزتهم على الكرة. تتوافق القيمة مع متوسط ​​عدد التمريرات المتتالية التي تمكن الخصم من إكمالها قبل أن يتم مقاطعته. كلما زادت القيمة، زاد عدد التمريرات المسموح للخصم بإكمالها  ",
      Directness: "يقيس مدى مباشرة الفريق. ترتبط القيمة العالية للتوجيه المباشر بكمية أكبر من التمريرات الأمامية مقارنة بالتمريرات الجانبية",
      ExpectedPoints: "عدد النقاط المتوقعة من قبل الفريق، والتي يتم حسابها بناءً على الأهداف المتوقعة التي تم تحقيقها واستقبالها. يتيح لنا هذا المقياس تقييم أداء الفريق بشكل أفضل أثناء المباراة (أو مجموعة من المباريات) بالمقارنة مع عدد النقاط التي تم تحقيقها بالفعل",
      PassesPerLongBall: "نسبة التمريرات الطويلة الناجحة من إجمالي عدد التمريرات المكتملة",
      CrossingPerXG: "نسبة الأهداف المتوقعة القادمة من العرضيات",
      PenaltySavedPenaltyFaced: "نسبة ركلات الجزاء التي تم صدها من بين جميع ركلات الجزاء التي تم مواجتها",
      Goals: "عدد الأهداف المسجلة لكل 90 دقيقة لعب",
      NonPenaltyGoals: "عدد الأهداف المسجلة لكل 90 دقيقة لعب باستثناء أهداف ضربات الجزاء",
      NPGOpenPlay: "عدد الأهداف المسجلة لكل 90 دقيقة من اللعب من خلال إجراءات اللعب المفتوح باستثناء أهداف ضربات الجزاء",
      NPGSetPiece: "عدد الأهداف المسجلة لكل 90 دقيقة من اللعب بالركلات الثابتة باستثناء أهداف ركلات الجزاء",
      Shooting: "نسبة التسديدات على المرمى",
      Finishing: "نسبة التسديدات التي تنتهي بهدف",
      xGEfficiency: "عدد الأهداف المتوقعة التي يحتاجها اللاعب لتسجيل هدف",
      HeaderPerShot: "عدد الضربات الرأسية لكل 90 دقيقة لعب",
      HeaderPerCross: "نسبة التمريرات العرضية التي استقبلها اللاعب برأسه من إجمالي عدد العرضيات التي أكملها الفريق",
      Assists: "عدد التمريرات الحاسمة لكل 90 دقيقة لعب",
      ThroughBalls: "عدد الكرات البينية التي يلعبها اللاعب أثناء اجراء هجومي لإحداث تغيير على المرمى لكل 90 دقيقة من اللعب",
      CrossEfficiency: "مقياس يجمع بين النسبة المئوية العرضيات الناجحة مع حجم العرضيات الناجحة التي تم إجراؤها ",
      ScoringContribution: "عدد التمريرات الحاسمة والأهداف لكل 90 دقيقة لعب",
      xAssistsOpenPlay: "عدد التمريرات الحاسمة المتوقعة لكل 90 دقيقة من اللعب الناتجة عن اللعب المفتوح",
      xAssistsSetPiece: "عدد التمريرات الحاسمة المتوقعة لكل 90 دقيقة من اللعب الناتجة عن الكرات الثابتة",
      xAssistsOpenPlayInTeam: "عدد التمريرات الحاسمة المتوقعة لكل في الفريق دقيقة من اللعب الناتجة عن اللعب المفتوح",
      xAssistsSetPieceInTeam: "عدد التمريرات الحاسمة المتوقعة لكل في الفريق دقيقة من اللعب الناتجة عن الكرات الثابتة",
      xGChainFinalThird: "كمية xG التي شارك بها اللاعب في الثلث الأخير",
      xGBuildupFinalThird: "كمية xG التي شارك بها اللاعب في الثلث الأخير (باستثناء التسديدات والتمريرات المؤدية إلى التسديدة)",
      BallProgressionPassing: "عدد مرات تقدم اللاعب بالكرة مسافة 10 أمتار أو أكثر بتمرير الكرة",
      BallProgressionDribbling: "عدد مرات تقدم اللاعب بالكرة مسافة 10 أمتار أو أكثر بحمل الكرة",
      TacklesWasDribbled: "مقياس يأخذ في الاعتبار النسبة المئوية للمرات التي يستعيد فيها اللاعب الكرة من خلال التدخل مقابل عدد مرات التمرير/الركض. كلما ارتفع المؤشر كان ذلك أفضل",
      TacklesSuccessful: "عدد التدخلات الناجحة التي قام بها اللاعب",
      TacklesUnsuccessful: "عدد المرات التي يفشل فيها اللاعب في الفوز بالكرة عندما ينجح الخصم في مراوغته",
      Interceptions: "عدد المرات التي يعترض فيها اللاعب تمريرة لمنع الكرة من الوصول إلى هدفها خلال 90 دقيقة من اللعب",
      Clearances: "عدد المرات التي يضرب فيها اللاعب الكرة خارج منطقة الدفاع خلال 90 دقيقة لعب",
      Fouls: "عدد الأخطاء التي يرتكبها اللاعب في كل 90 دقيقة لعب",
      Recoveries: "عدد الكرات التي يستعيدها اللاعب في كل 90 دقيقة لعب",
      Shots: "عدد التسديدات الإجمالية التي تم إجراؤها لكل 90 دقيقة لعب",
      ShotsPerGoal: "عدد التسديدات على المرمى المطلوبة لتسجيل هدف دون احتسال ركلات الجزاء",
      ShortPassesSuccessful: "التمريرات القصيرة الناجحة (أقل من 12 مترًا) لكل 90 دقيقة لعب",
      PassingSuccessForwardPct: "نسبة التمريرات الناجحة في الاتجاه الأمامي",
      PassingSuccessBackwardPct: "نسبة التمريرات الناجحة للخلف",
      PassingForwardBackwardPct: "نسبة التمريرات في الاتجاه الأمامي مقابل التمريرات للخلف",
      LongBallPerPassesPct: "نسبة التمريرات الناجحة المكتملة (> 32 مترًا) من إجمالي التمريرات التي قام بها اللاعب.",
      LongBallReceived: "عدد التمريرات الطويلة (> 32 مترًا) المستلمة",
      LongBallReceivedOppHalf: "التمريرات الطويلة (> 32 مترًا) التي يتلقاها اللاعبون في نصف ملعب الخصم",
      DribblesAttempted: "محاولات المراوغة لكل 90 دقيقة من اللعب",
      SuccessfulDribblesPct: "المراوغات الناجحة/مجموع محاولات المراوغة",
      BallRetention: "النسبة المئوية للوقت الذي تستحوذ فيه على الكرة ولا ينتهي بك الأمر بفقدها",
      PassingPct: "نسبة التمريرات الناجحة من إجمالي التمريرات التي قدمها اللاعب",
      PassingOwnHalfPct: "نسبة التمريرات المكتملة من إجمالي التمريرات التي قدمها اللاعب (التمريرات في نصف ملعبه فقط)",
      PassingOppHalfPct: "النسبة المئوية للتمريرات المكتملة من جميع التمريرات التي قدمها اللاعب (التمريرات إلى نصف ملعب الخصم فقط)",
      PassingFinalThird: "التمريرات المكتملة إلى الثلث الأخير لكل 90 دقيقة",
      PassingFinalThirdPct: "نسبة التمريرات المكتملة من جميع التمريرات التي قدمها اللاعب (التمريرات إلى الثلث الأخير فقط)",
      LongBallSuccessful: "تمريرات مكتملة لمسافة تزيد عن 32 مترًا",
      LongBallPct: "التمريرات المكتملة لمسافة تزيد عن 32 مترًا / إجمالي التمريرات لأكثر من 32 مترًا.",
      SavesPct: "نسبة التصديات من إجمالي عدد التسديدات التي تم تلقيها",
      SavesInBoxPct: "نسبة التسديدات من داخل منطقة الجزاء التي تم التصدي",
      SavesOutOfBoxPct: "نسبة التسديدات من خارج منطقة الجزاء التي تم التصدي",
      xGSavedPerXGFacedOnTarget: "المعامل الذي يشير إلى نسبة xG المتوقعة التي تم حفظها بواسطة حارس المرمى. تعني القيمة 1 في هذا المقياس أن حارس المرمى ينقذ جميع الأهداف المتوقعة من التسديدات التي يتلقاها الفريق، في حين أن القيمة 0 تعني أن جميع الأهداف المتوقعة التي يسجلها الخصم تنتهي في المرمى.",
      xGFacedOnTargetPerGoalReceived: "مقياس يشير إلى عدد الأهداف المتوقعة اللازمة لتسجيل هدف لحارس مرمى معين. الدرجة العالية في هذا المقياس تعني أنه لتحويل هدف إلى حارس المرمى هذا، من الضروري إنشاء عدد كبير من xG",
      xGFacedOnTargetEfficiency: "عدد الأهداف غير الجزاءية التي منعها حارس المرمى. هذا هو عدد الأهداف المتوقعة على المرمى التي يتلقاها حارس المرمى مطروحًا منه عدد الأهداف (غير ركلة الجزاء) التي تم تسجيلها. يشير إلى عدد الأهداف التي لم يسجلها الخصم بفضل حارس المرمى",
      xGFacedOnTarget: "إجمالي xG (تم التصدي له وتسجيله) الذي واجهه حارس المرمى",
      IndividualPressure: "مقياس يقيس عدد المحاولات الناجحة (استعادة الاستحواذ) التي يقوم بها اللاعب عند الضغط على الخصم",
      AerialEfficiency: "مقياس يجمع بين النسبة المئوية للثنائيات الهوائية الناجحة وحجم الانتصارات في الثنائيات الهوائية",
      AerialWins: "عدد الثنائيات الهوائية التي يفوز بها اللاعب في كل 90 دقيقة",
      AerialWinsPct: "عدد الثنائيات الهوائية التي يفوز بها اللاعب من إجمالي عدد الثنائيات الهوائية التي شارك فيها اللاعب ",
      xG: "الأهداف المتوقعة التي يتم إنشاؤها لكل 90 دقيقة من اللعب. يقيس هذا المقياس احتمالية إنهاء التسديدة بهدف بناءً على متغيرات مختلفة (المسافة، الزاوية، نوع اللعب، جزء من الجسم، ...) لمثل هذا الإجراء. يمكنك معرفة المزيد على <b><a href='https://www.driblab.com/analogy-team/expected-goals-xg-what-it-is-and-how-it-works'>الأهداف المتوقعة : ما هو وكيف يعمل</a></b>",
      xGDiff: "الفرق بين xG والأهداف",
      xGOpenPlay: "الأهداف المتوقعة الناتجة عن اللعب المفتوح",
      xGSetPiece: "الأهداف المتوقعة الناتجة عن الكرات الثابتة",
      xGPerShot: "متوسط ​​xG من التسديدات التي قام بها اللاعب. يقيس هذا المقياس متوسط ​​خطورة اللتسديدات. كلما زادت احتمالية وصول تسديداتك إلى المرمى.  xG أعلى لكل تسديدة يعني  أن اللاعب يختار تسديداته جيدًا.",
      ChancesCreated: "عدد التمريرات المؤدية إلى التسديدة",
      CompletedCrosses: "عدد التمريرات العرضية المكتملة لكل 90 دقيقة لعب",
      Crossing: "النسبة المئوية للعرضيات التي تم إكمالها من محاولات العرضية",
      OpenPlayKeyPasses: "عدد التمريرات التي يقوم بها اللاعب أثناء اللعب المفتوح لكل 90 دقيقة لعب",
      OpenPlayKeyPassesInTeam: 'نسبة التمريرات التي يقوم بها اللاعب أثناء اللعب المفتوح داخل الفريق',
      OpenPlayPassesIntoOpponentBox: "عدد التمريرات التي أكملها اللاعب داخل منطقة جزاء الخصم أثناء اللعب المفتوح لكل 90 دقيقة لعب",
      OpenPlayPassesIntoOpponentBoxSuccessful: "عدد التمريرات التي أكملها اللاعب داخل منطقة جزاء الخصم أثناء اللعب المفتوح لكل 90 دقيقة لعب",
      xAssists: "مقياس يحلل جودة الفرص التي يتم إنشاؤها والتي تحدث في المباراة. كل تمريرة حاسمة في التسديد لها قيمة تعتمد على احتمالية تسجيل التسديدة. يتم تعيين هذه القيمة وفقًا لمكان التمريرة، والنوع (الكرة البينية الثابتة...) وحالة اللعبة وما إلى ذلك. على عكس xG، فإن xA هو مقياس من الأفضل أن يحصل اللاعب على أرقام مساعدة أعلى من أرقام مساعدته منذ منشئ المحتوى. يمكنه فقط التحكم في جودة تمريراته (xA)، في حين أن رقم المساعدة الخاص به يعتمد على المهاجم",
      xGChain: "كمية xG التي شارك فيها اللاعب",
      xGBuildup: "يشبه سلسلة xG ولكن لا يأخذ في الاعتبار آخر لاعبين في التسلسل (باستثناء التسديدات والتمريرات المؤدية إلى التسديدة)",
      BallProgression: "عدد المرات التي يتقدم فيها اللاعب مسافة 10 أمتار أو أكثر إما عن طريق التمرير أو حمل الكرة أو مزيج من الاثنين (لكل 90 دقيقة لعب)",
      SuccessfulDribbles: "المراوغات تم إكمالها  بنجاح خلال 90 دقيقة من اللعب ",
      Dispossessed: "عدد مرات التدخل ضد اللاعب وفقد الكرة في كل 90 دقيقة من اللعب",
      TouchesInOpponentBox: "عدد مرات استحواذ اللاعب على الكرة في منطقة جزاء الخصم خلال 90 دقيقة لعب",
      xGSavedPerShot: "متوسط ​​احتمالية تسجيل هدف من التسديدات على المرمى",
      BallRetentionOppHalf: "النسبة المئوية للوقت الذي تستحوذ فيه على الكرة ولا ينتهي بك الأمر بفقدها في نصف ملعب الخصم",
      DeepProgression: "عدد مرات وصول اللاعب إلى الخمس الأخير من الملعب بحمل الكرة، بالإضافة إلى عدد مرات استحواذ اللاعب على الكرة في الخمس الأخير",
      DeepProgressionFinalThird: "عدد مرات وصول اللاعب إلى الثلث الأخير من الملعب بحمل الكرة، بالإضافة إلى عدد مرات استحواذ اللاعب على الكرة في الثلث الأخير",
      FoulsTaken: "عدد مرات ارتكاب اللاعب للخطأ خلال 90 دقيقة لعب",
      PenaltiesTaken: "عدد مرات تعرض فيها اللاعب للخطأ داخل منطقة جزاء الخصم خلال 90 دقيقة لعب",
      BlockedCrosses: "العرضيات التي يصدها اللاعب لكل 90 دقيقة لعب",
      BlockedShots: "التسديدات التي يتصدى لها اللاعب خلال 90 دقيقة لعب",
      NonPenaltyGoalsAgainst: "عدد الأهداف التي تم تسجيلها بدون ركلات جزاء لكل 90 دقيقة لعب",
      Headers: "عدد التسديدات التي تم إجراؤها بالرأس",
      AveragePassDistance: "متوسط ​​مسافة التمريرات بالأمتار",
      ProgressiveRuns: "حملات ناجحة تجعل الاستحواذ أقرب بنسبة 20% إلى مرمى الخصم",
      xT: "التهديد المتوقع (xT) هو مقياس يقيس التهديد الذي يشكله اللاعب على الخصم عن طريق حمل الكرة أو تمريرها إلى المناطق التي تكون فيها احتمالية انتهاء الاستحواذ بتسجيل هدف أعلى. يمكنك معرفة المزيد على <b><a href='https://www.driblab.com/driblab-en/expected-threat-map-visualizing-credit-at-football/'>خريطة التهديد المتوقع: تصور الرصيد على كرة القدم</a></b>",
      xTOpenPlay: "التهديد المتوقع الناتج أثناء اللعب المفتوح لكل 90 دقيقة من اللعب",
      xTSetPiece: "التهديد المتوقع الناتج عن الكرات الثابتة لكل 90 دقيقة من اللعب",
      xGOT: "الأهداف المتوقعة على المرمى. عدد الأهداف المتوقعة التي يواجهها حارس المرمى. يأخذ هذا المقياس في الاعتبار فقط التسديدات على المرمى (يتم استبعاد التسديدات الضائعة والتسديدات القائمة)",
      BadActions: 'مجموع كل الأفعال السيئة المرتكبة',
      BadActionsOwnHalf: "مجموع كل الأفعال السيئة التي ارتكبت في النصف الخاص",
      AerialsWonOwnBox: "الثنائيات الهوائية  تم الفوز بها في منطقة جزاء الخاصة",
      AerialsWonOppBox: "الثنائيات الهوائية  تم الفوز بها في منطقة جزاء المنافس",
      AerialsTotalOppBox: "اجمالي الثنائيات الهوائية في منطقة جزاء المنافس",
      AerialsTotalOwnBox: "جمالي الثنائيات الهوائية في منطقة جزاء الخاصة",
      FoulsOwnHalfPct: "نسبة الأخطاء المرتكبة في نصف ملعب الخاص",
      RecoveriesOppHalf: "عدد الكرات التي يستعيدها اللاعب في نصف ملعب الخصم لكل 90 دقيقة لعب",
      DuelsPct: "نسبة الثنائيات الناجحة",
      TacklesWasDribbledFirstThird: "نسبة المرات التي يستعيد فيها اللاعب الكرة عندما يواجهها في الثلث الأخير",
      BallProgressionFinalThird: "تقدم الكرة الى الثلث الأخير ",
      DuelsTotal: "إجمالي عدد التدخلات و الهوائيات ولمسات الكرة والمراوغات والأخطاء المرتكبة في كل 90 دقيقة",
      QuickRecoveries: "يتم الاسترداد على مسافة 40 مترًا أو أكثر من المرمى الخاص بعد 5 ثوانٍ من فقدان حيازة الكرة",
      ShotsPerNPG: "متوسط ​​عدد التسديدات لتسجيل هدف غير ركلة جزاء",
      ShotsOutBox: "عدد التسديدات من خارج منطقة الجزاء لكل 90 دقيقة",
      GoalsOutBox: "عدد الأهداف من خارج منطقة الجزاء في كل 90 دقيقة",
      ShootingOutBox: "نسبة التسديدات على المرمى من خارج منطقة الجزاء",
      HandPassing: "دقة التمرير باليدين",
      Catching: "نسبة التصديات التي يمسك فيها حارس المرمى الكرة",
      ClaimAccuracy: "يقيس مدى جودة حارس المرمى في التقاط/صد الكرات الهوائية. الرقم فوق 1 يشير إلى أن حارس المرمى يلتقط كرات هوائية أكثر من المتوقع",
      HighTurnovers: "خسارة كرة أقرب من 40 مترا من المرمى",
      ShotEndingHighTurnovers: "خسارة كرة عالية (خسارة كرة أقرب من 40 مترًا من المرمى) تنتهي بتسديدة من الفريق الخصم",
      GoalEndingHighTurnovers: "خسارة كرة عالية(خسارة كرة التي تكون على مسافة أقرب من 40 مترًا من المرمى الخاص) تنتهي بهدف للفريق المنافس",
      AverageCarriesProgress: "متوسط ​​المسافة التي يحرك فيها اللاعب الكرة عموديا في كل حمل (بالأمتار)",
      ChanceEndingCarries: "حملات لا تقل عن 7 أمتار تنتهي بتمريرة تليها تسديدة",
      AssistEndingCarries: "حملات لا تقل عن 7 أمتار تنتهي بتمريرة يتبعها هدف",
      ShotEndingCarries: "حملات لا تقل عن 7 أمتار تنتهي بتسديدة ",
      GoalEndingCarries: "حملات لا تقل عن 7 أمتار تنتهي بهدف",
      ShotEndingSequence: "عدد التسلسلات التي تنتهي بتسديدة قد شارك فيها اللاعب",
      GoalEndingSequence: "عدد التسلسلات التي تنتهي بهدف شارك فيه اللاعب",
      xGPerNPG: "الأهداف المتوقعة اللازمة لتسجيل هدف غير ركلة الجزاء",
      AerialWonOffensive: " انتصارات الثنائيات الهوائية الهجومية",
      AerialWonDefensive: " انتصارات الثنائيات الهوائية االدفاعية",
      xGAgainst: "الأهداف المتوقعة التي تم تسجيلها",
      xGPerNPGAgainst: "الأهداف المتوقعة المتلقاة لكل هدف لم يتم تسجيله من ركلة جزاء",
      xGSetPieceAgainst: "الأهداف المتوقعة الناتجة عن الكرات الثابتة التي تم استقبالها",
      xGPerShotAgainst: "الأهداف المتوقعة التي يتم تلقيها لكل تسديدة يتم تلقيها",
      ShotsAgainst: "عدد التسديدات التي يتم تلقيها لكل 90 دقيقة لعب",
      ShotsOnTargetAgainst: "عدد التسديدات على المرمى التي تم استقبالها لكل 90 دقيقة لعب",
      RivalPossession: "استحواذ الخصم",
      AerialDefensivePct: "نسبة الانتصارات الهوائية دون الاستحواذ على الكرة",
      HighRecoveries: "الاستردادات االتي تمت على مسافة 40 مترًا من مرمى الخصم",
      HighDefensiveActionPct: "النسبة المئوية للإجراءات الدفاعية (التدخلات، الاعتراضات، الصد، الأخطاء، لاعب ضد لاعب واحد) التي تم إجراؤها على مسافة 40 مترًا فوق خط الأساس",
      HighDefensiveDistance: "متوسط ​​المسافة من المرمى الخاص بجميع الإجراءات الدفاعية",
      PassesPerPossession: "عدد التمريرات لكل استحواذ",
      LengthPerPossession: "المسافة لكل استحواذ",
      xTNet: "صافي xT",
      AvgCarriesDistance: "متوسط ​​مسافة الحمل",
      PassesForwardPct: "% التمريرات للأمام",
      TacklesAttempted: "محاولات التدخلات",
      DuelsLost: "خسارة الثنائيات",
      Carries: "التحولات",
      CarriesPct: "التحولات %",
      Aerials: "هوائيات",
      ProgressivePassesReceivedIntoBox: "التمريرات التقدمية المستقبلة في الصندوق",
      PassesOppHalf: "تمريرات ناجحة تنتهي في نصف ملعب الخصم",
      ShotsOnTarget: "التسديدات على المرمى كل 90 دقيقة",
      AggressiveActions: "عدد محاولات التدخل في الثانيتين التاليتين بعد فقدان الاستحواذ",
      Crosses: "العدد الإجمالي للعرضيات لكل 90 دقيقة من اللعب",
      xGBuildup5pass: "كمية xG التي شارك فيها اللاعب، آخر 5 تمريرات فقط (باستثناء التسديدات والتمريرات المؤدية إلى التسديدة)",
      DefensiveDistance: "متوسط ​​المسافة إلى المرمى للثنائيات الدفاعية المنفذة",
      SpeedSequence: "متوسط ​​السرعة (الأمتار المغطاة على الوقت المستغرق) لجميع استحواذات الفريق",
      Touches: "عدد مرات استحواذ اللاعب على الكرة خلال 90 دقيقة لعب",
      AerialsTotalOppHalf: "إجمالي الثنائيات الهوائية في نصف ملعب الخصم لكل 90 دقيقة من اللعب ",
      AerialsOppHalf: " الثنائيات الهوائية الناجحة في نصف ملعب الخصم لكل 90 دقيقة من اللعب",
      AerialsWonOppHalfPct: "النسبة المئويةلالثنائيات الهوائية الناجحة في بنصف ملعب الخصم",
      AerialsPctOppBox: "النسبة المئوية  للثنائيات الهوائية الناجحة في منطقة جزاء الخصم",
      AerialsPctOwnBox: "النسبة المئوية  للثنائيات الهوائية الناجحة في منطقة الجزاء الخاصة ",
      AerialDefensive: "إجمالي عدد الثنائيات الهوائية عندما يستحوذ الفريق الخاص على الكرة",
      AerialOffensive: "إجمالي عدد الهوائيات عندما يستحوذ الفريق المنافس على الكرة",
      AerialOffensivePct: "النسبة المئوية للثنائيات الهوائية الناجحة عندما يستحوذ الفريق على الكرة",
      IndividualPressureOppHalf: "مقياس يقيس عدد المحاولات الناجحة (استعادة الاستحواذ) التي يقوم بها اللاعب عند الضغط على الخصم في نصف ملعب الخصم",
      ChancesCreatedOP: "عدد التمريرات المؤدية إلى التسديد أثناء اللعب المفتوح لكل 90 دقيقة لعب",
      TouchesPerShot: "عدد مرات لمس اللاعبين للكرة في كل تسديدة",
      PassesFinalThirdTotalPct: "نسبة التمريرات الناجحة إلى الثلث الأخير",
      xACrosses: "التمريرات الحاسمة المتوقعة الناتجة عن العرضيات لكل 90 دقيقة من اللعب",
      Passes: "إجمالي عدد التمريرات لكل 90 دقيقة لعب",
      PassesSuccessful: "عدد التمريرات المكتملة لكل 90 دقيقة لعب",
      TacklesWasDribbledFouls: "النسبة المئوية للتدخلات التي تم الفوز بها فيما يتعلق بإجمالي التدخلات والأخطاء المرتكبة",
      OffsidesCaught: "الوقوع في  التسلل",
      ProgressivePassesReceivedFinalThird: "التمريرات التقدمية المستلمة النهائية - ...",
      ProgressivePassesReceived: " التمريرات التقدمية المستلمة",
      Breadth: "مجموع التدخلات والتحديات والاعتراضات والأخطاء المرتكبة على جانبي الملعب",
      DuelsDefTotal: "مجموع إجمالي التدخلات و الثنائيات الهوائية الدفاعية والأخطاء المرتكبة",
      DefensiveActions: "الإجراءات الدفاعية عندما يحاول الخصم المراوغة (التدخلات والتحديات والأخطاء)",
      ProgressivePassesReceivedOppHalf: "التمريرات التقدمية المستلمة في نصف ملغب الخصم",
      CompletedCrossesOP: "العرضيات المكتملة من اللعب المفتوح",
      CrossingOP: "نسبة العرضيات المكتملة من جميع العرضيات التي تمت محاولتها من اللعب المفتوح",
      PassingContribution: "النسبة المئوية التي تقيس التهديد بالتمريرات مع الأخذ في الاعتبار موقف المتلقي",
      BallProgressionOppHalfInTeam: "تقدم الكرة في نصف ملغب الخصم في الفريق %",
      PassesOPIntoBoxInTeam: "التمريرات من اللعب المفتوح في منطقة الجزاء في الفريق",
      TouchesOppBoxInTeam: "اللمساتفي منطقة الجزاء في الفريق٪",
      xGOPInTeam: "% xG  من اللعب المفتوح في الفريق",
      DeepPasses: "تمريرات من خارج دائرة نصف قطرها 20 مترًا من مرمى الخصم وتنتهي داخل تلك المنطقة",
      DefensiveDuelsPct: "النسبة المئوية للثنائيات الدفاعية التي تم الفوز بها من إجمالي للثنائيات الدفاعية",
      QuickRecoveriesPct: "النسبة المئوية للتعافي السريع من الاعتراضات ومحاولات التدخل",
      DiffDefensiveDistanceTeam: "الفرق بين المسافة الدفاعية للاعب والمسافة الدفاعية لفريقه",
      xTPassing: "التهديد المتوقع الناتج فقط من التمريرات",
      xTPassing100Passes: "التهديد المتوقع الناتج فقط من التمريرات ولكل 100 تمريرة",
      ProgressivePassesAccurate: "تمريرات مكتملة لمسافة 10 أمتار أو أكثر في المحور X",
      PassAbility: "نسبة التمريرات المكتملة إلى التمريرات المتوقعة (xP)",
      OPPassesIntoOppBoxPct: "نسبة التمريرات المكتملة من اللعب المفتوح إلى داخل منطقة جزاء الخصم ومحاولات اللعب المفتوح إلى داخل منطقة جزاء الخصم",
      EntriesOppBox: "عدد التمريرات والتحولات داخل منطقة جزاء الخصم",
      Crosses6yardBox: "إجمالي عدد العرضيات التي تنتهي في منطقة الست ياردات",
      Cutbacks: "التمرير من خط الأساس إلى الخلف وداخل منطقة جزاء الخصم",
      xTDribbling: "التهديد المتوقع المتولد فقط من المراوغات",
      AvgShotDistance: "متوسط ​​المسافة من إجمالي عدد التسديدات",
      xGOnTarget: "الأهداف المتوقعة من التسديدات التي تم إجراؤها على المرمى. يقيس احتمالية انتهاء التسديدة بهدف باستخدام الموقع النهائي للتسديدة",
      FinishingxGOT: "نسبة التسديدات على المرمى والتي انتهت بهدف أعلى من المتوسط. يقيس هذا المقياس مقدار القيمة التي يضيفها المهاجم بجودة تسديداته",
      DribblesWonOwnHalf: "مراوغات ناجحة في نصف ملعبنا",
      DribblesOwnHalf: "عدد محاولات المراوغة في نصف ملعبنا",
      DribblesOwnHalfPct: "النسبة المئوية للمراوغات الناجحة ومحاولات المراوغة في نصف ملعبنا",
      DribblesWonOppHalf: "مراوغات ناجحة في نصف ملعب الخصم",
      DribblesOppHalf: "عدد محاولات المراوغة في نصف ملعب الخصم",
      DribblesOppHalfPct: "النسبة المئوية للمراوغات الناجحة ومحاولات المراوغة في نصف ملعب الخصم",
      DribblesWonFinalThird: "مراوغات ناجحة في الثلث الأخير",
      DribblesFinalThird: "عدد محاولات المراوغة في الثلث الأخير",
      DribblesFinalThirdPct: "النسبة المئوية للمراوغات الناجحة ومحاولات المراوغة التي تمت في الثلث الأخير",
      ShotEndingHighRecoveries: "افتكاكات عالية (على بُعد 40 مترًا أو أقل من مرمى الخصم) تنتهي بتسديدة",
      PassingFinalThirdAgainst: "التمريرات الناجحة من الخصم إلى الثلث الأخير",
      OpenPlayPassesIntoOpponentBoxAgainst: "إجمالي عدد التمريرات التي حاولها الخصم إلى منطقتنا أثناء اللعب المفتوح",
      EntriesOppBoxAgainst: "عدد التمريرات والانطلاقات من الخصم إلى منطقتنا",
      DeepProgressionAgainst: "عدد المرات التي يصل فيها الخصم إلى الخُمس الأخير من الملعب بالمراوغة، بالإضافة إلى عدد مرات الاستحواذ في أول خُمس لنا",
      TouchesInOpponentBoxAgainst: "عدد مرات استحواذ الخصم على الكرة داخل منطقتنا",
      Score: "أداء اللاعب يعتمد على مقاييس مختلفة",
      PDScore: "الأداء البدني للاعب يعتمد على مقاييس بدنية مختلفة",
      OrlegiScore: "أداء اللاعب يعتمد على مقاييس مختلفة",
      SirScore: "أداء اللاعب يعتمد على مقاييس مختلفة",
      xTOPInTeam: "التهديد المتوقع الناتج أثناء اللعب المفتوح في الفريق",
      YellowCards: "البطاقات صفراء المتلقاة",
      RedCards: "البطاقات الحمراء المتلقاة",
      xTOpenPlayAgainst: "التهديد المتوقع  المقبول أثناء اللعب المفتوح",
      xTSetPieceAgainst: "التهديد المتوقع الذي تم استقباله من خلال الكرات الثابتة",
      NPGOpenPlayAgainst: "عدد الأهداف التي تم استقبالها من خلال إجراءات اللعب المفتوح باستثناء أهداف ضربات الجزاء",
      NPGSetPieceAgainst: "عدد الأهداف التي تم تسجيلها من الكرات الثابتة باستثناء أهداف ركلات الجزاء",
      PassesOppHalfPerPossession: "التمريرات في نصف ملغب الخصم لكل استحواذ",
      AverageTimeRecovery: "متوسط ​​وقت الاسترداد",
      ExpectedPassing: "نسبة التمريرات التي كان ينبغي إكمالها",
      NumPossession10Passes: "الحيازة 10 تصاريح مرور 10",
      PassesReceived: "التصاريح المستلمة",
      PassesReceivedFinalThird: "التصاريح المستلمة النهائية ⅓",
      ProgressivePassesTotalPct: "% تصاريح مرور تقدمية",
      ShortPassesPct: '% تمريرات قصيرة',
      TouchesOppBoxOppTeam: "عدد تحركات الخصم داخل منطقة الجزاء أثناء وجود اللاعب في الملعب",
      ShotsOnTargetOppTeam: "تسديدات على المرمى استقبلها الفريق أثناء وجود اللاعب في الملعب",
      NPGOppTeam: "أهداف تم استقبالها (دون ضربات جزاء) أثناء وجود اللاعب في الملعب",
      //Physical Stats
      TotalDistance: "المسافة الإجمالية التي قطعها اللاعب خلال المباراة",
      WalkingDistance: "المسافة الإجمالية التي قطعها اللاعب خلال المباراة بسرعة أقل من 2 م/ث (7.2 كم/س)",
      JoggingDistance: "المسافة الإجمالية التي قطعها اللاعب خلال المباراة بسرعة بين 2 م/ث (7.2 كم/س) و 4 م/ث (14.4 كم/س)",
      RunningDistance: "المسافة الإجمالية التي قطعها اللاعب خلال المباراة بسرعة بين 4 م/ث (14.4 كم/س) و 5.5 م/ث (19.8 كم/س)",
      NumberOfRuns: "عدد المرات التي جرى فيها اللاعب بسرعة بين 4 م/ث (14.4 كم/س) و 5.5 م/ث (19.8 كم/س)",
      ExtremeAccelerations: "عدد المرات التي تسارع فيها اللاعب أكثر من 3 م/ث²",
      DistanceTIP: "المسافة (الفريق الممتلك للكرة) التي قطعها اللاعب خلال المباراة بحيازة الكرة",
      DistanceOTIP: "المسافة OTIP (الفريق الخصم الممتلك للكرة) التي قطعها اللاعب خلال المباراة بدون حيازة الكرة",
      HsrNumber: "عدد المرات التي تحرك فيها اللاعب بسرعة تساوي أو تزيد عن 5.5 م/ث (19.8 كم/س) ولكن أقل من 7 م/ث (25.2 كم/س) لمدة لا تقل عن ثانية واحدة",
      HsrDistance: "المسافة الإجمالية التي قطعها اللاعب خلال المباراة بسرعة تساوي أو تزيد عن 5.5 م/ث (19.8 كم/س) ولكن أقل من 7 م/ث (25.2 كم/س)",
      HsrDistancePct: "نسبة المسافة المقطوعة بسرعة عالية (HSR) من المسافة الإجمالية المقطوعة",
      SprintsNumber: "عدد المرات التي تحرك فيها اللاعب بسرعة تساوي أو تزيد عن 7 م/ث (25.2 كم/س) لمدة لا تقل عن ثانية واحدة",
      SprintsDistance: "المسافة الإجمالية التي قطعها اللاعب خلال المباراة بسرعة تساوي أو تزيد عن 7 م/ث (25.2 كم/س)",
      SprintNumberDeclinePct: "نسبة الانخفاض في عدد الركضات السريعة مقارنة بالشوط الثاني من المباراة",
      SprintDistanceDeclinePct: "نسبة الانخفاض في المسافة المقطوعة أثناء الركض السريع مقارنة بالشوط الثاني من المباراة",
      SprintDistancePct: "نسبة المسافة المقطوعة في السبرينت من المسافة الإجمالية المقطوعة",
      Accelerations: "عدد المرات التي تسارع فيها اللاعب بين 1.5 م/ث² و 3 م/ث²",
      ExplosiveDistance: "المسافة المتفجرة",
      MaxSpeed: "أقصى سرعة وصل إليها اللاعب",
      AvgMaxSpeed: "متوسط أقصى سرعة وصل إليها اللاعب",
      MaxAccelerations: "أقصى تسارع بمتر/ثانية² وصل إليه اللاعب",
      BypassedPlayersByPasses: "عدد اللاعبين في جهة المرمى من حامل الكرة في بداية حدث اللمسة، ناقص عدد اللاعبين في جهة المرمى في نهاية حدث اللمسة",
      BypassedDefendersByPasses: "عدد المدافعين في جهة المرمى من حامل الكرة في بداية حدث اللمسة، ناقص عدد المدافعين في جهة المرمى في نهاية حدث اللمسة",
      PassesBypassingPlayers: "عدد التمريرات التي تجاوزت اللاعبين",
      PassesBypassingDefenders: "عدد التمريرات التي تجاوزت المدافعين",
      BypassedPlayersPerPass: "إجمالي عدد اللاعبين الذين تم تجاوزهم لكل تمريرة",
      BypassedDefendersPerPass: "إجمالي عدد المدافعين الذين تم تجاوزهم لكل تمريرة",
      LineBreakingPasses: "التمريرات المكتملة التي تقرب الكرة بنسبة 10% على الأقل من مرمى الخصم وتعبر بين اثنين من المدافعين القريبين أو تمر خلف خط الدفاع",
      LineBreakingPassesMD: "تمريرات مكتملة اخترقت خطي الوسط والدفاع",  
      LineBreakingPassesM: "تمريرات مكتملة اخترقت خط الوسط",  
      LineBreakingThroughBalls: "تمريرات مكتملة اخترقت الخط الدفاعي",
      LineBreakingPassesPerPass: "عدد الخطوط التي يتم اختراقها لكل تمريرة",
      TotalPassesUnderStrongPressure: "إجمالي عدد التمريرات تحت ضغط قوي (ضمن 0-2 متر من أقرب لاعب منافس)",
      TotalPassesUnderLightPressure: "إجمالي عدد التمريرات تحت ضغط خفيف (ضمن 2-4 متر من أقرب لاعب منافس)",
      SuccessfulPassesUnderStrongPressure: "عدد التمريرات الناجحة تحت ضغط قوي (ضمن 0-2 متر من أقرب لاعب منافس)",
      SuccessfulPassesUnderLightPressure: "عدد التمريرات الناجحة تحت ضغط خفيف (ضمن 2-4 متر من أقرب لاعب منافس)",
      PassingUnderStrongPressure: "نسبة التمريرات الناجحة والإجمالية تحت ضغط قوي (ضمن 0-2 متر من أقرب لاعب منافس)",
      PassingUnderLightPressure: "نسبة التمريرات الناجحة والإجمالية تحت ضغط خفيف (ضمن 2-4 متر من أقرب لاعب منافس)",
      PassReceiptsInSpaceCompleted: "التمريرات التي يتم تنفيذها حيث يكون المستقبل في النصف الهجومي ولا يوجد مدافع في دائرة نصف قطرها 5 أمتار باتجاه المرمى",
      PassReceiptsInSpace: "التمريرات المستلمة في النصف الهجومي دون وجود مدافعين في دائرة نصف قطرها 5 أمتار باتجاه المرمى",
      TotalStrongOnBallPressures: "عدد الضغوط القوية على حامل الكرة (ضمن 0-2 متر)",
      TotalLightOnBallPressures: "عدد الضغوط على حامل الكرة (ضمن 2-4 متر)",
      SuccessfulStrongOnBallPressures: "عدد الضغوط القوية الناجحة على حامل الكرة (ضمن 0-2 متر)",
      SuccessfulLightOnBallPressures: "عدد الضغوط الناجحة على حامل الكرة (ضمن 2-4 متر)",
      StrongOnBallPressuresPct: "نسبة الضغوط القوية الناجحة والإجمالية على حامل الكرة (ضمن 0-2 متر من أقرب لاعب منافس)",
      LightOnBallPressuresPct: "نسبة الضغوط الناجحة والإجمالية على حامل الكرة (ضمن 2-4 متر من أقرب لاعب منافس)",
      TimesBypassedByPasses: "إجمالي عدد المرات التي تم تجاوز اللاعب فيها عبر التمريرات",
      TimesBypassedByCarries: "إجمالي عدد المرات التي تم تجاوز اللاعب فيها عبر المراوغات",
      TimesBypassedByActions: "إجمالي عدد المرات التي تم تجاوز اللاعب فيها عبر التمريرات والمراوغات معًا",
      BypassedPlayersByCarries: "إجمالي عدد الخصوم (المدافعين ولاعبي الوسط) الذين تم تجاوزهم بالمراوغات",
      BypassedDefendersByCarries: "إجمالي عدد الخصوم (المدافعين) الذين تم تجاوزهم بالمراوغات",
      BypassedPlayersByActions: "إجمالي عدد الخصوم (المدافعين ولاعبي الوسط) الذين تم تجاوزهم بالتمريرات والمراوغات معًا",
      BypassedDefendersByActions: "إجمالي عدد الخصوم (المدافعين) الذين تم تجاوزهم بالتمريرات والمراوغات معًا",
      CarriesBypassingPlayers: "عدد المراوغات التي تجاوزت لاعبين",
      CarriesBypassingDefenders: "عدد المراوغات التي تجاوزت مدافعين",
      BypassedPlayersPerCarry: "متوسط عدد الخصوم المتجاوزين لكل مراوغة",
      BypassedDefendersPerCarry: "متوسط عدد المدافعين المتجاوزين لكل مراوغة",
      LineBreakingCarries: "عدد المراوغات التي اخترقت خطًا دفاعيًا أو أكثر بنجاح",
      LineBreakingCarriesMD: "عدد المراوغات التي اخترقت خطي الوسط والدفاع بنجاح",
      LineBreakingCarriesM: "عدد المراوغات التي اخترقت خط الوسط بنجاح",
      LineBreakingCarriesD: "عدد المراوغات التي اخترقت خط الدفاع بنجاح",
      LineBreakingCarriesPerCarry: "نسبة المراوغات بين الخطوط لكل مراوغة",
      LineBreakingActions: "عدد التمريرات والمراوغات معًا التي اخترقت خطًا دفاعيًا أو أكثر بنجاح",
      LineBreakingActionsMD: "عدد التمريرات والمراوغات معًا التي اخترقت خطي الوسط والدفاع بنجاح",
      LineBreakingActionsM: "عدد التمريرات والمراوغات معًا التي اخترقت خط الوسط بنجاح",
      LineBreakingActionsD: "عدد التمريرات والمراوغات معًا التي اخترقت خط الدفاع بنجاح",
      PassesPerLineBreakingPass: "نسبة إجمالي عدد التمريرات لكل تمريرة بين الخطوط",
      CarriesPerLineBreakingCarry: "نسبة إجمالي عدد المراوغات لكل مراوغة بين الخطوط",
      LinesBrokenByPasses: "إجمالي عدد الخطوط التي تم اختراقها عبر التمريرات",
      LinesBrokenByCarries: "إجمالي عدد الخطوط التي تم اختراقها عبر المراوغات",
      LinesBrokenByActions: "إجمالي عدد الخطوط التي تم اختراقها عبر التمريرات والمراوغات معًا",
      LinesBrokenPerPass: "نسبة عدد الخطوط التي تم اختراقها لكل تمريرة",
      LinesBrokenPerCarry: "نسبة عدد الخطوط التي تم اختراقها لكل مراوغة",
      AvgLastDefenderDistanceIP: "المسافة بين آخر مدافع (الأقرب إلى مرماه) وخط المرمى في حالة الاستحواذ",
      AvgLastDefenderDistanceOOP: "المسافة بين آخر مدافع (الأقرب إلى مرماه) وخط المرمى خارج الاستحواذ",
      AvgDefensiveLineDistanceIP: "المسافة بين أقصى خط دفاعي والمرمى في حالة الاستحواذ",
      AvgDefensiveLineDistanceOOP: "المسافة بين أقصى خط دفاعي والمرمى خارج الاستحواذ",
      AvgRBDistanceIP: "المسافة بين الظهير الأيمن ومرماه في حالة الاستحواذ",
      AvgRBDistanceOOP: "المسافة بين الظهير الأيمن ومرماه خارج الاستحواذ",
      AvgLBDistanceIP: "المسافة بين الظهير الأيسر ومرماه في حالة الاستحواذ",
      AvgLBDistanceOOP: "المسافة بين الظهير الأيسر ومرماه خارج الاستحواذ",
      AvgBlockDistanceIP: "المسافة بين اللاعب الميداني الأبعد والأقرب من المرمى في حالة الاستحواذ",
      AvgBlockDistanceOOP: "المسافة بين اللاعب الميداني الأبعد والأقرب من المرمى خارج الاستحواذ",
      AvgBlockAreaIP: "مساحة الصندوق الذي يحيط بجميع اللاعبين (لقياس مدى شغل الفريق للمساحة) في حالة الاستحواذ",
      AvgBlockAreaOOP: "مساحة الصندوق الذي يحيط بجميع اللاعبين (لقياس مدى شغل الفريق للمساحة) خارج الاستحواذ",
      AvgDefensiveLineWidthOOP: "عرض خط الدفاع الأبعد عن المرمى خارج الاستحواذ",
      AvgOffensiveLineLastThirdWidthIP: "العرض الأفقي لخط الهجوم في الثلث الأخير في حالة الاستحواذ",
      AvgLByIP: "موضع الظهير الأيسر في حالة الاستحواذ",
      AvgRByIP: "موضع الظهير الأيمن في حالة الاستحواذ",
      AvgOffensiveLineDistanceIP: "المسافة بين المرمى وخط الهجوم في حالة الاستحواذ",
      AvgOffensiveLineLastThirdDistanceIP: "المسافة بين المرمى وخط الهجوم في الثلث الأخير في حالة الاستحواذ",
      AvgOffensiveLineWidthIP: "العرض الأفقي لخط الهجوم في حالة الاستحواذ",
      OffBallRuns: "تحركات متعمدة بدون كرة لدعم المرحلة الهجومية",
      OffBallRunsOverlap: "جري يمر فيه اللاعب حول زميله من الخارج (قريب من الخط الجانبي) بينما يملك زميله الكرة",
      OffBallRunsUnderlap: "جري يمر فيه اللاعب من الداخل بجانب زميله (قريب من وسط الملعب)",
      OffBallRunsRunAhead: "جري للأمام يتجاوز حامل الكرة لكنه يبقى أمام آخر مدافع",
      OffBallRunsRunBehind: "جري يخترق آخر خط دفاعي بين المدافعين وحارس المرمى",
      OffBallRunsCrossReceiver: "اللاعب يركض داخل المنطقة ليتلقى عرضية من زميل",
      OffBallRunsSupport: "اللاعب يركض ليكون على خط واحد مع حامل الكرة ويقدم خيار تمرير قريب",
      OffBallRunsComingShort: "اللاعب يتحرك نحو حامل الكرة لتقديم دعم قريب أو خيار تمرير للخلف",
    },
    subtitles: {
      Possession: "نسبة استحواذ الفريق على الكرة",
      TimePossession: 'وقت استحواذ الفريق على الكرة',
      PassesPerShots: "متوسط ​​عدد التمريرات لكل تسديدة",
      PPDA: "الضغط الذي يمارسه الفريق على لاعبي الخصم أثناء استحواذهم على الكرة",
      Directness: "كمية أكبر من التمريرات الأمامية مقارنة بالتمريرات الجانبية",
      AerialWins: "الثنائيات الهوائية الناجحة لكل 90 دقيقة",
      AerialEfficiency: "مقياس يجمع بين الثنائيات الهوائية الناجحة وإجمالي الثنائيات الهوائية لكل 90 دقيقة",
      AerialWinsPct: "النسبة المئوية للفوز في الثنائيات الهوائية",
      Assists: "التمريرات الحاسمة لكل 90 دقيقة",
      BallProgression: "التقدم عن طريق تمرير الكرة أو حملها بما لا يقل عن 10 أمتار لكل 90 دقيقة",
      Catching: "النسبة المئوية للتصديات التي يمسك فيها حارس المرمى بالكرة",
      ChancesCreated: "عدد التمريرات المؤدية للتسديدة لكل 90 دقيقة",
      ClaimAccuracy: "الكرات المجموعة أعلى من المتوسط ",
      CompletedCrosses: "العرضيات المنفذة بنجاح في كل 90 دقيقة",
      Crossing: "نسبة التمريرات الناجحة",
      Dispossessed: "خسارة كرة في 90 دقيقة",
      Finishing: "نسبة التسديدات التي تنتهي بهدف",
      xGEfficiency: "عدد الأهداف المتوقعة التي يحتاجها اللاعب لتسجيل هدف",
      Fouls: "الأخطاء المرتكبة لكل 90 دقيقة",
      FoulsTaken: "الأخطاء المستلمة لكل 90 دقيقة",
      IndividualPressure: "الجهود الناجحة (استعادة الأستحواذ) لكل 90 دقيقة",
      Interceptions: "اعتراضات الكرة لكل 90 دقيقة",
      LongBallPct: "نسبة التمريرات المكتملة لا تقل عن 32 مترًا",
      LongBallSuccessful: "تمريرات مكتملة لا تقل عن 32 مترًا لكل 90 دقيقة",
      Goals: "عدد الأهداف المسجلة لكل 90 دقيقة لعب",
      NonPenaltyGoals: "الأهداف (باستثناء ضربات الجزاء) لكل 90 دقيقة",
      NPGOpenPlay: "الأهداف (باستثناء ضربات الجزاء) من خلال إجراءات اللعب المفتوح لكل 90 دقيقة",
      NPGSetPiece: "الأهداف (باستثناء ضربات الجزاء) عن طريق الكرات الثابتة لكل 90 دقيقة",
      OpenPlayKeyPasses: "التمريرات التي تنتهي بتسديدة (باستثناء التمريرات الحاسمة) في اللعب المفتوح لكل 90 دقيقة",
      OpenPlayKeyPassesInTeam: 'نسبة التمريرات التي يقوم بها اللاعب أثناء اللعب المفتوح داخل الفريق',
      PassingFinalThird: "تمريرات ناجحة في الثلث الأخير لكل 90 دقيقة",
      PassingFinalThirdPct: "نسبة التمريرات الناجحة في الثلث الأخير",
      PassingOppHalfPct: "نسبة التمريرات الناجحة إلى نصف ملعب الخصم",
      PassingOwnHalfPct: "نسبة التمريرات الناجحة في نصف ملعبنا",
      PassingPct: "نسبة التمريرات الناجحة",
      Recoveries: "استعادة الكرة (من خلال التدخلات أو الاعتراضات) لكل 90 دقيقة",
      SavesInBoxPct: "نسبة التصديات من التسديدات في منطقة الجزاء لكل 90 دقيقة",
      SavesOutOfBoxPct: "نسبة التصديات من التسديدات خارج منطقة الجزاء لكل 90 دقيقة",
      SavesPct: "نسبة التصديات",
      ScoringContribution: "عدد التمريرات الحاسمة والأهداف لكل 90 دقيقة",
      xAssistsOpenPlay: "عدد التمريرات الحاسمة المتوقعة لكل 90 دقيقة  الناتجة عن اللعب المفتوح",
      xAssistsSetPiece: "نعدد التمريرات الحاسمة المتوقعة لكل 90 دقيقة الناتجة عن الكرات الثابتة",
      xAssistsOpenPlayInTeam: "عدد التمريرات الحاسمة المتوقعة لكل في الفريق دقيقة من اللعب الناتجة عن اللعب المفتوح",
      xAssistsSetPieceInTeam: "عدد التمريرات الحاسمة المتوقعة لكل في الفريق دقيقة من اللعب الناتجة عن الكرات الثابتة",
      xGChainFinalThird: "كمية xG التي شارك بها اللاعب في الثلث الأخير",
      xGBuildupFinalThird: "كمية xG التي شارك بها اللاعب في الثلث الأخير (باستثناء التسديدات والتمريرات المؤدية إلى التسديدة)",
      BallProgressionPassing: "عدد مرات تقدم اللاعب بالكرة مسافة 10 أمتار أو أكثر بتمرير الكرة",
      BallProgressionDribbling: "عدد مرات تقدم اللاعب بالكرة مسافة 10 أمتار أو أكثر بحمل الكرة",
      Shooting: "نسبة التسديدات (باستثناء ضربات الجزاء) على الهدف",
      Shots: "عدد التسديدات التي تم إجراؤها لكل 90 دقيقة",
      ShotsPerGoal: "متوسط ​​عدد التسديدات التي تم إجراؤها لتسجيل هدف",
      SuccessfulDribbles: "مراوغات ناجحة في كل 90 دقيقة",
      TacklesSuccessful: "إجمالي عدد التدخلات لكل 90 دقيقة",
      TacklesWasDribbled: "النسبة المئوية للثنائيات التي تم الفوز بها عن طريق التدخل",
      ThroughBalls: "عدد التمريرات التي تخترق خط الدفاع لكل 90 دقيقة",
      TouchesInOpponentBox: "عدد مرات التحكم بالكرة في منطقة الخصم لكل 90 دقيقة",
      xAssists: "التمريرات الحاسمة المتوقعة التي يتم إنشاؤها لكل 90 دقيقة",
      xG: "الأهداف المتوقعة التي تم إنشاؤها لكل 90 دقيقة",
      xGDiff: "الفرق بين xG والأهداف",
      xGOpenPlay: "الأهداف المتوقعة الناتجة عن اللعب المفتوح لكل 90 دقيقة",
      xGSetPiece: "الأهداف المتوقعة الناتجة عن الكرات الثابتة لكل 90 دقيقة",
      xGBuildup: "المشاركة في xG الذي تم بناؤه لكل 90 دقيقة",
      xGChain: "المشاركة في xG بالسلاسل لكل 90 دقيقة",
      xGPerNPG: "الأهداف المتوقعة اللازمة لتسجيل هدف غير من ركلة جزاء لكل 90 دقيقة",
      xGPerShot: "متوسط ​​xG لكل تسديدة",
      xGSavedPerShot: " متوسط ​​xG الذي تم صدّة لكل تسديدة ",
      xGSavedPerXGFacedOnTarget: "متوسط ​​xG الذي تم صدّه لكل xG واجهه على المرمى",
      xGFacedOnTargetPerGoalReceived: "هناك حاجة إلى الأهداف المتوقعة لتسجيل هدف على حارس مرمى معين",
      xGFacedOnTargetEfficiency: "عدد الأهداف غير الجزاءية التي منعها حارس المرمى لكل 90 دقيقة",
      xGFacedOnTarget: "إجمالي xG (تصدي و تسجيل) الذي واجهه حارس المرمى لكل 90 دقيقة",
      HighTurnovers: "خسارة كرةأقرب من 40 مترا من المرمى",
      OpenPlayPassesIntoOpponentBox: "التمريرات المكتملة من اللعب المفتوح من قبل اللاعب داخل منطقة جزاء الخصم لكل 90 دقيقة",
      OpenPlayPassesIntoOpponentBoxSuccessful: "التمريرات المكتملة من اللعب المفتوح من قبل اللاعب داخل منطقة جزاء الخصم لكل 90 دقيقة",
      DeepProgressionFinalThird: "مرات استحواذ اللاعب على الثلث الأخير في كل 90 دقيقة",
      ChancesCreatedOP: "عدد التمريرات المؤدية للتسديدة أثناء اللعب المفتوح لكل 90 دقيقة",
      PenaltiesTaken: "عدد مرات تعرض اللاعب للخطأ داخل منطقة جزاء الخصم خلال 90 دقيقة",
      BlockedCrosses: "العرضيات التي يصدها اللاعب لكل 90 دقيقة لعب",
      BlockedShots: "التسديدات التي يتصدى لها اللاعب خلال 90 دقيقة لعب",
      NonPenaltyGoalsAgainst: "عدد الأهداف التي تم تسجيلها بدون ركلات جزاء لكل 90 دقيقة لعب",
      Headers: "عدد التسديدات التي تم إجراؤها بالرأس",
      AveragePassDistance: "متوسط ​​مسافة التمريرات بالأمتار",
      ProgressiveRuns: "حملات ناجحة تجعل الاستحواذ أقرب بنسبة 20% إلى مرمى الخصم",
      xT: "التهديد الناتج عن تحريك الكرة إلى مناطق خطيرة كل 90 دقيقة",
      xTOpenPlay: "التهديد المتوقع الناتج أثناء اللعب المفتوح لكل 90 دقيقة من اللعب",
      xTSetPiece: "التهديد المتوقع الناتج عن الكرات الثابتة لكل 90 دقيقة من اللعب",
      xGOT: "عدد الأهداف المتوقعة التي يواجهها حارس المرمى",
      BadActions: 'مجموع كل الأفعال السيئة المرتكبة',
      BadActionsOwnHalf: "مجموع كل الأفعال السيئة التي ارتكبت في النصف الخاص",
      AerialsWonOwnBox: "الثنائيات الهوائية الناجحة في منطقة جزاء فريقه",
      AerialsWonOppBox: "الثنائيات الهوائية الناجحة في منطقة جزاء الخصم",
      AerialsTotalOppBox: "الثنائيات الهوائية في منطقة جزاء الخصم",
      AerialsTotalOwnBox: "الثنائيات الهوائية  في منطقة جزاء فريقه",
      FoulsOwnHalfPct: "نسبة الأخطاء المرتكبة في نصف ملعب فريقه",
      RecoveriesOppHalf: "عدد الكرات التي يستعيدها اللاعب في نصف ملعب الخصم لكل 90 دقيقة",
      DuelsPct: "نسبة الثنائيات الناجحة",
      TacklesWasDribbledFirstThird: "نسبة المرات التي يستعيد فيها اللاعب الكرة عندما يواجهها في الثلث الأخير",
      BallProgressionFinalThird: "عدد المرات التي يتقدم فيها اللاعب مسافة 10 أمتار أو أكثر في الثلث الأخير",
      DuelsTotal: "إجمالي عدد التدخلات و الهوائياتت ولمسات الكرة والمراوغات والأخطاء المرتكبة في كل 90 دقيقة",
      QuickRecoveries: "استرداد على مسافة 40 مترًا أو أكثر من مرمى فريقه بعد 5 ثوانٍ من فقدان الاستحواذ",
      ShotsPerNPG: "متوسط ​​عدد التسديدات لتسجيل هدف غير ركلة جزاء",
      ShotsOutBox: "عدد التسديدات من خارج منطقة الجزاء لكل 90 دقيقة",
      GoalsOutBox: "عدد الأهداف من خارج منطقة الجزاء في كل 90 دقيقة",
      ShootingOutBox: "نسبة التسديدات على المرمى من خارج منطقة الجزاء",
      HandPassing: "دقة التمرير باليدين",
      ShotEndingHighTurnovers: " خسارة كرة عالية (خسارة كرة أقرب من 40 مترًا من المرمى) تنتهي بتسديدة من الفريق الخصم",
      GoalEndingHighTurnovers: "خسارة كرة عالية (خسارة كرة التي تكون على مسافة أقرب من 40 مترًا من المرمى الخاص) تنتهي بهدف للفريق المنافس",
      AverageCarriesProgress: "متوسط ​​المسافة التي يحركها اللاعب للكرة عموديا في كل حمل (بالأمتار)",
      ChanceEndingCarries: "حملات لا تقل عن 7 أمتار تنتهي بتمريرة تليها تسديدة",
      AssistEndingCarries: "حملات لا تقل عن 7 أمتار تنتهي بتمريرة يتبعها هدف",
      ShotEndingCarries: "يحمل ما لا يقل عن 7 أمتار وينتهي بتسديدة",
      GoalEndingCarries: "يحمل ما لا يقل عن 7 أمتار تنتهي بهدف",
      ShotEndingSequence: "عدد التسلسلات التي تنتهي بهدف التي شارك فيها اللاعب",
      GoalEndingSequence: "عدد التسلسلات التي تنتهي بهدف شارك فيه اللاعب",
      AerialWonOffensive: "الثنائيات الهوائية الهجومية الناجحة لكل 90 دقيقة",
      AerialWonDefensive: "الثنائيات الهوائية الدفاعية الناجحة لكل 90 دقيقة",
      xGAgainst: "الأهداف المتوقعة المقبولة",
      xGPerNPGAgainst: "الأهداف المتوقعة المقبولة لكل هدف دون احتساب ركلات الجزاء",
      xGSetPieceAgainst: "الأهداف المتوقعة الناتجة عن الكرات الثابتة التي تم استقبالها",
      xGPerShotAgainst: "الأهداف المتوقعة التي تم تلقيها لكل تسديدة تم تلقيها",
      ShotsAgainst: "التسديدات التي يتم تلقيها في كل 90 دقيقة",
      ShotsOnTargetAgainst: "التسديدات على المرمى يتم استقبالها في كل 90 دقيقة",
      RivalPossession: "استحواذ الخصم ",
      AerialDefensivePct: "نسبة الانتصارات الهوائية دون الاستحواذ على الكرة",
      HighRecoveries: "الافتكاكات على مسافة 40 مترًا من مرمى الخصم",
      HighDefensiveActionPct: "النسبة المئوية للإجراءات الدفاعية (التدخلات، الاعتراضات، الصد، الأخطاء، لاعب ضد لاعب واحد) التي تم إجراؤها على مسافة 40 مترًا فوق خط الأساس",
      HighDefensiveDistance: "متوسط ​​المسافة من المرمى الخاص بجميع الإجراءات الدفاعية",
      PassesPerPossession: "عدد التمريرات لكل حيازة",
      LengthPerPossession: "المسافة لكل حيازة",
      xTNet: "صافي xT",
      AvgCarriesDistance: "متوسط ​​مسافة الحمل",
      PassesForwardPct: "% التمريرات للأمام",
      TacklesAttempted: "التدخلات",
      DuelsLost: "الثنائيات غير ناجحة",
      Carries: "يحمل",
      CarriesPct: "% يحمل",
      Aerials: "هوائيات",
      ProgressivePassesReceivedIntoBox: "التمريرات التقدمية المستقبلة في الصندوق",
      PassesOppHalf: "تمريرات ناجحة تنتهي في نصف ملعب الخصم",
      LongBallReceived: "عدد التمريرات الطويلة (> 32 مترًا) المستلمة",
      ShotsOnTarget: "التسديدات على المرمى كل 90 دقيقة",
      AggressiveActions: "عدد محاولات التدخل في الثانيتين التاليتين بعد فقدان الاستحواذ",
      Crosses: "العدد الإجمالي  للعرضيات لكل 90 دقيقة من اللعب",
      xGBuildup5pass: "كمية xG التي شارك فيها اللاعب، آخر 5 تمريرات فقط (باستثناء التسديدات والتمريرات المؤدية إلى التسديدة)",
      DefensiveDistance: "متوسط ​​المسافة إلى المرمى من الثنائيات الدفاعية المنفذة",
      SpeedSequence: "متوسط ​​السرعة (الأمتار التي يغطيها على الوقت المستغرق) لجميع استحواذات الفريق",
      Touches: "عدد مرات استحواذ اللاعب على الكرة خلال 90 دقيقة لعب",
      AerialsTotalOppHalf: "إجمالي الثنائيات الهوائية  في نصف ملعب الخصم لكل 90 دقيقة من اللعب",
      AerialsOppHalf: "الثنائيات الهوائية الناجحة في نصف ملعب الخصم لكل 90 دقيقة من اللعب",
      AerialsWonOppHalfPct: "النسبة المئوية للثنائيات الهوائية الناجحة بنصف ملعب الخصم",
      AerialsPctOppBox: "نسبة الثنائيات الهوائية الناجحة داخل منطقة الخصم ",
      AerialsPctOwnBox: "نسبة الثنائيات الهوائية الناجحة داخل منطقة الجزاء الخاصة",
      AerialDefensive: "إجمالي عدد الهوائيات عندما يستحوذ الفريق على الكرة",
      AerialOffensive: "إجمالي عدد الهوائيات عندما يستحوذ الفريق المنافس على الكرة",
      AerialOffensivePct: "نسبة الانتصارات  الهوائية عندما يستحوذ الفريق على الكرة",
      IndividualPressureOppHalf: "الاستحواذات المسعادة  من قبل اللاعب عند الضغط على الخصم في نصف ملعبه",
      TouchesPerShot: "عدد مرات لمس اللاعبين للكرة في كل تسديدة",
      PassesFinalThirdTotalPct: "نسبة التمريرات الناجحة إلى الثلث الأخير",
      xACrosses: "التمريرات الحاسمة المتوقعة الناتجة عن العرضيات لكل 90 دقيقة من اللعب",
      Passes: "إجمالي عدد التمريرات لكل 90 دقيقة لعب",
      PassesSuccessful: "عدد التمريرات المكتملة لكل 90 دقيقة لعب",
      TacklesWasDribbledFouls: "النسبة المئوية للتدخلات التي تم الفوز بها فيما يتعلق بإجمالي التدخلات والأخطاء المرتكبة",
      OffsidesCaught: "الوقوع في التسلل",
      ProgressivePassesReceivedFinalThird: "التمريرات التقدمية المستلمة النهائية - ...",
      ProgressivePassesReceived: "التمريرات التقدمية المستلمة",
      Breadth: "مجموع التدخلات والتحديات والاعتراضات والأخطاء المرتكبة على جانبي الملعب لكل 90 دقيقة",
      DuelsDefTotal: "مجموع إجمالي التدخلات و الثنائيات الهوائية الدفاعية والأخطاء المرتكبة ",
      DefensiveActions: "الإجراءات الدفاعية عندما يحاول الخصم المراوغة (التدخلات والتحديات والأخطاء)",
      ProgressivePassesReceivedOppHalf: "التمريرات التقدمية المستلمة  في نصف ملغب الخصم",
      CompletedCrossesOP: "العرضيات المكتملة من اللعب المفتوح",
      CrossingOP: "نسبة العرضيات المكتملة من جميع العرضيات التي تمت محاولتها من اللعب المفتوح",
      CrossingPerXG: "نسبة الأهداف المتوقعة التي تأتي من العرضيات داخل منطقة الجزاء",
      PassesPerLongBall: "عدد التمريرات الناجحة لكل تمريرة طويلة",
      PassingContribution: "النسبة المئوية التي تقيس التهديد بالتمريرات مع الأخذ في الاعتبار موقف المتلقي",
      BallProgressionOppHalfInTeam: "% تطور الكرة في نصف ملعب الخصم في الفريق",
      PassesOPIntoBoxInTeam: "% تمريرات من اللعب المفتوح داخل منطقة الجزاء في الفريق  ",
      TouchesOppBoxInTeam: "% اللمسات داخل منطقة جزاء الخصم في الفريق ",
      xGOPInTeam: " % xG  من اللعب المفتوح في الفريق",
      DeepPasses: "تمريرات من خارج دائرة نصف قطرها 20 مترًا من مرمى الخصم وتنتهي داخل تلك المنطقة",
      DefensiveDuelsPct: "النسبة المئوية للثنائيات الدفاعية الناجحة من إجمالي الثنائيات الدفاعية",
      QuickRecoveriesPct: "النسبة المئوية للاسترداد السريع من الاعتراضات ومحاولات التدخل",
      DiffDefensiveDistanceTeam: "الفرق بين المسافة الدفاعية للاعب والمسافة الدفاعية لفريقه",
      xTPassing: "التهديد المتوقع الناتج فقط من التمريرات",
      xTPassing100Passes: "التهديد المتوقع الناتج فقط من التمريرات ولكل 100 تمريرة",
      ProgressivePassesAccurate: "تمريرات مكتملة لمسافة 10 أمتار أو أكثر في المحور X",
      PassAbility: "نسبة التمريرات المكتملة إلى التمريرات المتوقعة (xP)",
      OPPassesIntoOppBoxPct: "نسبة التمريرات المكتملة من اللعب المفتوح إلى داخل منطقة جزاء الخصم ومحاولات اللعب المفتوح إلى داخل منطقة جزاء الخصم",
      EntriesOppBox: "عدد التمريرات والحملات داخل منطقة جزاء الخصم",
      Crosses6yardBox: "إجمالي عدد العرضيات التي تنتهي في منطقة الست ياردات",
      Cutbacks: "التمرير من خط الأساس إلى الخلف وداخل منطقة جزاء الخصم",
      xTDribbling: "التهديد المتوقع المتولد فقط من المراوغات",
      AvgShotDistance: "متوسط ​​المسافة من إجمالي عدد التسديدات",
      xGOnTarget: "الأهداف المتوقعة من التسديدات التي يتم إجراؤها على المرمى في كل 90 دقيقة.",
      FinishingxGOT: "نسبة التسديدات على المرمى والتي انتهت بهدف أعلى من المتوسط",
      DribblesAttempted: "عدد المراوغات لكل 90 دقيقة",
      DribblesWonOwnHalf: "مراوغات ناجحة في نصف ملعبنا",
      DribblesOwnHalf: "عدد محاولات المراوغة في نصف ملعبه",
      DribblesOwnHalfPct: "النسبة المئوية للمراوغات الناجحة ومحاولات المراوغة في نصف ملعبنا",
      DribblesWonOppHalf: "مراوغات ناجحة في نصف ملعب الخصم",
      DribblesOppHalf: "عدد محاولات المراوغة في نصف ملعب الخصم",
      DribblesOppHalfPct: "النسبة المئوية للمراوغات الناجحة ومحاولات المراوغة في نصف ملعب الخصم",
      DribblesWonFinalThird: "مراوغات ناجحة في الثلث الأخير",
      DribblesFinalThird: "عدد محاولات المراوغة في الثلث الأخير",
      DribblesFinalThirdPct: "النسبة المئوية للمراوغات الناجحة ومحاولات المراوغة التي تمت في الثلث الأخير",
      ShotEndingHighRecoveries: "افتكاكات عالية (على بُعد 40 مترًا أو أقل من مرمى الخصم) تنتهي بتسديدة",
      PassingFinalThirdAgainst: "التمريرات الناجحة من الخصم إلى الثلث الأخير",
      OpenPlayPassesIntoOpponentBoxAgainst: "إجمالي عدد التمريرات التي حاولها الخصم إلى منطقتنا أثناء اللعب المفتوح",
      EntriesOppBoxAgainst: "عدد التمريرات والانطلاقات من الخصم إلى منطقتنا",
      DeepProgressionAgainst: "عدد المرات التي يصل فيها الخصم إلى الخُمس الأخير من الملعب بالمراوغة، بالإضافة إلى عدد مرات الاستحواذ في أول خُمس لنا",
      TouchesInOpponentBoxAgainst: "عدد مرات استحواذ الخصم على الكرة داخل منطقتنا",
      Score: "أداء اللاعب يعتمد على مقاييس مختلفة",
      PDScore: "الأداء البدني للاعب يعتمد على مقاييس بدنية مختلفة",
      OrlegiScore: "أداء اللاعب يعتمد على مقاييس مختلفة",
      SirScore: "أداء اللاعب يعتمد على مقاييس مختلفة",
      xTOPInTeam: "التهديد المتوقع الناتج أثناء اللعب المفتوح في الفريق",
      YellowCards: "البطاقات الصفراء المستلمة لكل 90 دقيقة من اللعب",
      RedCards: "البطاقات الحمراء المستلمة لكل 90 دقيقة من اللعب",
      xTOpenPlayAgainst: "التهديد المتوقع الذي يتم استقباله أثناء اللعب المفتوح لكل 90 دقيقة من اللعب",
      xTSetPieceAgainst: "التهديد المتوقع الذي يتم استقباله من خلال الكرات الثابتة لكل 90 دقيقة من اللعب",
      NPGOpenPlayAgainst: "عدد الأهداف التي تم تسجيلها بدون ركلات جزاء لكل 90 دقيقة من اللعب من خلال إجراءات اللعب المفتوح",
      NPGSetPieceAgainst: "عدد الأهداف التي تم تسجيلها بدون ركلات جزاء لكل 90 دقيقة من اللعب من خلال الكرات الثابتة",
      PassesOppHalfPerPossession: "التمريرات  في نصف ملغب الخصم لكل استحواذ",
      AverageTimeRecovery: "متوسط ​​وقت الاسترداد",
      ExpectedPassing: "نسبة التمريرات التي كان ينبغي إكمالها",
      NumPossession10Passes: "الحيازة 10 تصاريح مرور 10",
      PassesReceived: "التصاريح المستلمة",
      PassesReceivedFinalThird: "التصاريح المستلمة النهائية ⅓",
      ProgressivePassesTotalPct: "% تصاريح مرور تقدمية",
      ShortPassesPct: '% تمريرات قصيرة',
      TouchesOppBoxOppTeam: "عدد تحركات الخصم داخل منطقة الجزاء أثناء وجود اللاعب في الملعب",
      ShotsOnTargetOppTeam: "تسديدات على المرمى استقبلها الفريق أثناء وجود اللاعب في الملعب",
      NPGOppTeam: "أهداف تم استقبالها (دون ضربات جزاء) أثناء وجود اللاعب في الملعب",
      //Physical Stats
      TotalDistance: "المسافة الكلية",
      HsrDistance: "مسافة الجري عالية السرعة > 19.8 كم/ساعة",
      HsrNumber: "الجري عالي السرعة  > 19.8 كم/ساعة",
      HsrDistancePct: "المسافة HSR٪",
      SprintsNumber: "سرعة الجري السريع > 25.2 كم/ساعة ",
      SprintsDistance: "مسافة لجري السريع > 25.2 كم/ساعة",
      SprintNumberDeclinePct: "انخفاض كمية الجري السريع %",
      SprintDistanceDeclinePct: "% انخفاض مسافة الجري السريع",
      SprintDistancePct: "مسافة الجري السريع %",
      Accelerations: "كمية التسارع",
      MaxSpeed: "السسرعة القصوى",
      AvgMaxSpeed: "متوسط أقصى سرعة وصل إليها اللاعب",
      MaxAccelerations: "أقصى تسارع بمتر/ثانية² وصل إليه اللاعب",
      BypassedPlayersByPasses: "عدد اللاعبين في جهة المرمى من حامل الكرة في بداية حدث اللمسة، ناقص عدد اللاعبين في جهة المرمى في نهاية حدث اللمسة",
      BypassedDefendersByPasses: "عدد المدافعين في جهة المرمى من حامل الكرة في بداية حدث اللمسة، ناقص عدد المدافعين في جهة المرمى في نهاية حدث اللمسة",
      PassesBypassingPlayers: "عدد التمريرات التي تجاوزت اللاعبين",
      PassesBypassingDefenders: "عدد التمريرات التي تجاوزت المدافعين",
      BypassedPlayersPerPass: "إجمالي عدد اللاعبين الذين تم تجاوزهم لكل تمريرة",
      BypassedDefendersPerPass: "إجمالي عدد المدافعين الذين تم تجاوزهم لكل تمريرة",
      LineBreakingPasses: "التمريرات المكتملة التي تقرب الكرة بنسبة 10% على الأقل من مرمى الخصم وتعبر بين اثنين من المدافعين القريبين أو تمر خلف خط الدفاع",
      LineBreakingPassesMD: "تمريرات مكتملة اخترقت خطي الوسط والدفاع",  
      LineBreakingPassesM: "تمريرات مكتملة اخترقت خط الوسط",  
      LineBreakingThroughBalls: "تمريرات مكتملة اخترقت الخط الدفاعي",
      LineBreakingPassesPerPass: "عدد الخطوط التي يتم اختراقها لكل تمريرة",
      TotalPassesUnderStrongPressure: "إجمالي عدد التمريرات تحت ضغط قوي (ضمن 0-2 متر من أقرب لاعب منافس)",
      TotalPassesUnderLightPressure: "إجمالي عدد التمريرات تحت ضغط خفيف (ضمن 2-4 متر من أقرب لاعب منافس)",
      SuccessfulPassesUnderStrongPressure: "عدد التمريرات الناجحة تحت ضغط قوي (ضمن 0-2 متر من أقرب لاعب منافس)",
      SuccessfulPassesUnderLightPressure: "عدد التمريرات الناجحة تحت ضغط خفيف (ضمن 2-4 متر من أقرب لاعب منافس)",
      PassingUnderStrongPressure: "نسبة التمريرات الناجحة والإجمالية تحت ضغط قوي (ضمن 0-2 متر من أقرب لاعب منافس)",
      PassingUnderLightPressure: "نسبة التمريرات الناجحة والإجمالية تحت ضغط خفيف (ضمن 2-4 متر من أقرب لاعب منافس)",
      PassReceiptsInSpaceCompleted: "التمريرات التي يتم تنفيذها حيث يكون المستقبل في النصف الهجومي ولا يوجد مدافع في دائرة نصف قطرها 5 أمتار باتجاه المرمى",
      PassReceiptsInSpace: "التمريرات المستلمة في النصف الهجومي دون وجود مدافعين في دائرة نصف قطرها 5 أمتار باتجاه المرمى",
      TotalStrongOnBallPressures: "عدد الضغوط القوية على حامل الكرة (ضمن 0-2 متر)",
      TotalLightOnBallPressures: "عدد الضغوط على حامل الكرة (ضمن 2-4 متر)",
      SuccessfulStrongOnBallPressures: "عدد الضغوط القوية الناجحة على حامل الكرة (ضمن 0-2 متر)",
      SuccessfulLightOnBallPressures: "عدد الضغوط الناجحة على حامل الكرة (ضمن 2-4 متر)",
      StrongOnBallPressuresPct: "نسبة الضغوط القوية الناجحة والإجمالية على حامل الكرة (ضمن 0-2 متر من أقرب لاعب منافس)",
      LightOnBallPressuresPct: "نسبة الضغوط الناجحة والإجمالية على حامل الكرة (ضمن 2-4 متر من أقرب لاعب منافس)",
      TimesBypassedByPasses: "إجمالي عدد المرات التي تم تجاوز اللاعب فيها عبر التمريرات",
      TimesBypassedByCarries: "إجمالي عدد المرات التي تم تجاوز اللاعب فيها عبر المراوغات",
      TimesBypassedByActions: "إجمالي عدد المرات التي تم تجاوز اللاعب فيها عبر التمريرات والمراوغات معًا",
      BypassedPlayersByCarries: "إجمالي عدد الخصوم (المدافعين ولاعبي الوسط) الذين تم تجاوزهم بالمراوغات",
      BypassedDefendersByCarries: "إجمالي عدد الخصوم (المدافعين) الذين تم تجاوزهم بالمراوغات",
      BypassedPlayersByActions: "إجمالي عدد الخصوم (المدافعين ولاعبي الوسط) الذين تم تجاوزهم بالتمريرات والمراوغات معًا",
      BypassedDefendersByActions: "إجمالي عدد الخصوم (المدافعين) الذين تم تجاوزهم بالتمريرات والمراوغات معًا",
      CarriesBypassingPlayers: "عدد المراوغات التي تجاوزت لاعبين",
      CarriesBypassingDefenders: "عدد المراوغات التي تجاوزت مدافعين",
      BypassedPlayersPerCarry: "متوسط عدد الخصوم المتجاوزين لكل مراوغة",
      BypassedDefendersPerCarry: "متوسط عدد المدافعين المتجاوزين لكل مراوغة",
      LineBreakingCarries: "عدد المراوغات التي اخترقت خطًا دفاعيًا أو أكثر بنجاح",
      LineBreakingCarriesMD: "عدد المراوغات التي اخترقت خطي الوسط والدفاع بنجاح",
      LineBreakingCarriesM: "عدد المراوغات التي اخترقت خط الوسط بنجاح",
      LineBreakingCarriesD: "عدد المراوغات التي اخترقت خط الدفاع بنجاح",
      LineBreakingCarriesPerCarry: "نسبة المراوغات بين الخطوط لكل مراوغة",
      LineBreakingActions: "عدد التمريرات والمراوغات معًا التي اخترقت خطًا دفاعيًا أو أكثر بنجاح",
      LineBreakingActionsMD: "عدد التمريرات والمراوغات معًا التي اخترقت خطي الوسط والدفاع بنجاح",
      LineBreakingActionsM: "عدد التمريرات والمراوغات معًا التي اخترقت خط الوسط بنجاح",
      LineBreakingActionsD: "عدد التمريرات والمراوغات معًا التي اخترقت خط الدفاع بنجاح",
      PassesPerLineBreakingPass: "نسبة إجمالي عدد التمريرات لكل تمريرة بين الخطوط",
      CarriesPerLineBreakingCarry: "نسبة إجمالي عدد المراوغات لكل مراوغة بين الخطوط",
      LinesBrokenByPasses: "إجمالي عدد الخطوط التي تم اختراقها عبر التمريرات",
      LinesBrokenByCarries: "إجمالي عدد الخطوط التي تم اختراقها عبر المراوغات",
      LinesBrokenByActions: "إجمالي عدد الخطوط التي تم اختراقها عبر التمريرات والمراوغات معًا",
      LinesBrokenPerPass: "نسبة عدد الخطوط التي تم اختراقها لكل تمريرة",
      LinesBrokenPerCarry: "نسبة عدد الخطوط التي تم اختراقها لكل مراوغة",
      AvgLastDefenderDistanceIP: "المسافة بين آخر مدافع (الأقرب إلى مرماه) وخط المرمى في حالة الاستحواذ",
      AvgLastDefenderDistanceOOP: "المسافة بين آخر مدافع (الأقرب إلى مرماه) وخط المرمى خارج الاستحواذ",
      AvgDefensiveLineDistanceIP: "المسافة بين أقصى خط دفاعي والمرمى في حالة الاستحواذ",
      AvgDefensiveLineDistanceOOP: "المسافة بين أقصى خط دفاعي والمرمى خارج الاستحواذ",
      AvgRBDistanceIP: "المسافة بين الظهير الأيمن ومرماه في حالة الاستحواذ",
      AvgRBDistanceOOP: "المسافة بين الظهير الأيمن ومرماه خارج الاستحواذ",
      AvgLBDistanceIP: "المسافة بين الظهير الأيسر ومرماه في حالة الاستحواذ",
      AvgLBDistanceOOP: "المسافة بين الظهير الأيسر ومرماه خارج الاستحواذ",
      AvgBlockDistanceIP: "المسافة بين اللاعب الميداني الأبعد والأقرب من المرمى في حالة الاستحواذ",
      AvgBlockDistanceOOP: "المسافة بين اللاعب الميداني الأبعد والأقرب من المرمى خارج الاستحواذ",
      AvgBlockAreaIP: "مساحة الصندوق الذي يحيط بجميع اللاعبين (لقياس مدى شغل الفريق للمساحة) في حالة الاستحواذ",
      AvgBlockAreaOOP: "مساحة الصندوق الذي يحيط بجميع اللاعبين (لقياس مدى شغل الفريق للمساحة) خارج الاستحواذ",
      AvgDefensiveLineWidthOOP: "عرض خط الدفاع الأبعد عن المرمى خارج الاستحواذ",
      AvgOffensiveLineLastThirdWidthIP: "العرض الأفقي لخط الهجوم في الثلث الأخير في حالة الاستحواذ",
      AvgLByIP: "موضع الظهير الأيسر في حالة الاستحواذ",
      AvgRByIP: "موضع الظهير الأيمن في حالة الاستحواذ",
      AvgOffensiveLineDistanceIP: "المسافة بين المرمى وخط الهجوم في حالة الاستحواذ",
      AvgOffensiveLineLastThirdDistanceIP: "المسافة بين المرمى وخط الهجوم في الثلث الأخير في حالة الاستحواذ",
      AvgOffensiveLineWidthIP: "العرض الأفقي لخط الهجوم في حالة الاستحواذ",
      OffBallRuns: "تحركات متعمدة بدون كرة لدعم المرحلة الهجومية",
      OffBallRunsOverlap: "جري يمر فيه اللاعب حول زميله من الخارج (قريب من الخط الجانبي) بينما يملك زميله الكرة",
      OffBallRunsUnderlap: "جري يمر فيه اللاعب من الداخل بجانب زميله (قريب من وسط الملعب)",
      OffBallRunsRunAhead: "جري للأمام يتجاوز حامل الكرة لكنه يبقى أمام آخر مدافع",
      OffBallRunsRunBehind: "جري يخترق آخر خط دفاعي بين المدافعين وحارس المرمى",
      OffBallRunsCrossReceiver: "اللاعب يركض داخل المنطقة ليتلقى عرضية من زميل",
      OffBallRunsSupport: "اللاعب يركض ليكون على خط واحد مع حامل الكرة ويقدم خيار تمرير قريب",
      OffBallRunsComingShort: "اللاعب يتحرك نحو حامل الكرة لتقديم دعم قريب أو خيار تمرير للخلف",
    },
    abbr: {
      Possession: "POS%",
      TimePossession: "TP",
      PassesPerShots: "PPS",
      PPDA: "PPDA",
      ExpectedPoints: "xP",
      Points: "P",
      Directness: "DIR",
      PassesPerLongBall: "PPLB",
      CrossingPerXG: "CPxG",
      PenaltySavedPenaltyFaced: "PSPF",
      Goals: "GOA",
      NonPenaltyGoals: "NPG",
      NPGOpenPlay: "NPGOP",
      NPGSetPiece: "NPGSP",
      Shooting: "SHO%",
      Finishing: "FIN%",
      xGEfficiency: "xGE",
      HeaderPerShot: "HPS",
      HeaderPerCross: "HPC",
      Assists: "ASS",
      ThroughBalls: "TB",
      CrossEfficiency: "CE",
      ScoringContribution: "SC",
      xAssistsOpenPlay: "xAOP",
      xAssistsSetPiece: "xASP",
      xAssistsOpenPlayInTeam: "xAOPiT",
      xAssistsSetPieceInTeam: "xASPiT",
      xGBuildupFinalThird: "xGBUPFT",
      xGChainFinalThird: "xGCFT",
      BallProgressionPassing: "BPP",
      BallProgressionDribbling: "BPD",
      TacklesWasDribbled: "TWD%",
      TacklesSuccessful: "STA",
      Interceptions: "INT",
      Clearances: "CLE",
      Fouls: "FOU",
      Recoveries: "REC",
      Shots: "SHO",
      ShotsPerGoal: "SPG",
      ShortPassesSuccessful: "SPS",
      PassingSuccessForwardPct: "PSF%",
      PassingSuccessBackwardPct: "PSB%",
      PassingForwardBackwardPct: "PFB%",
      LongBallPerPassesPct: "LBP%",
      LongBallReceived: "LBR",
      LongBallReceivedOppHalf: "LBROH",
      OffensiveActions: "OA",
      DribblesAttempted: "DAT",
      SuccessfulDribblesPct: "SD%",
      OffensiveTouchesOutBoxPct: "OTOB%",
      BallRetention: "BR",
      PassingPct: "PA%",
      PassingOwnHalfPct: "POH%",
      PassingOppHalfPct: "POPH%",
      PassingFinalThird: "PFT",
      PassingFinalThirdPct: "PT%",
      LongBallSuccessful: "LBS",
      LongBallPct: "LB%",
      SavesPct: "S%",
      SavesInBoxPct: "SIB%",
      SavesOutOfBoxPct: "SOOB%",
      xGSavedPerXGFacedOnTarget: "xGSPFOT",
      xGFacedOnTargetPerGoalReceived: "xGFOTPGR",
      xGFacedOnTargetEfficiency: "xGFOTE",
      xGFacedOnTarget: "xGFOT",
      IndividualPressure: "IP",
      AerialEfficiency: "AE",
      AerialWins: "AEW",
      AerialWinsPct: "AE%",
      xG: "xG",
      xGDiff: "xGD",
      xGOpenPlay: "xGOP",
      xGSetPiece: "xGSP",
      xGPerShot: "xGPS",
      ChancesCreated: "CC",
      CompletedCrosses:"SCR",
      Crossing: "CR%",
      OpenPlayKeyPasses: "OPKP",
      OpenPlayKeyPassesInTeam: "OPKPiT%",
      OpenPlayPassesIntoOpponentBox: "OPPOPPB",
      OpenPlayPassesIntoOpponentBoxSuccessful: "OPPOPPBS",
      xAssists: "xA",
      xGChain: "xGC",
      xGBuildup: "xGBUP",
      xGBuildupInTeam: "xGBUPiT",
      BallProgression: "BP",
      SuccessfulDribbles: "SDR",
      Dispossessed: "TOV",
      TouchesInOpponentBox: "TOB",
      xGSavedPerShot: "xGSS",
      BallRetentionOppHalf: "BROPPH",
      DeepProgression: "DP",
      DeepProgressionFinalThird: "DPFT",
      FoulsTaken: "FOUR",
      PenaltiesTaken: "PT",
      BlockedCrosses: "BC",
      BlockedShots: "BS",
      Blocks: "BLO",
      NonPenaltyGoalsAgainst: "NPGC",
      Headers: "HEA",
      AveragePassDistance: "APD",
      ProgressiveRuns: "PRC",
      xT: "xT",
      xTOpenPlay: "xTOP",
      xTSetPiece: "xTSP",
      xGOT: "xGOT",
      BadActions: "BA",
      BadActionsOwnHalf: "BAOH",
      AerialsWonOwnBox: "AWOB",
      AerialsWonOppBox: "AWOPPB",
      AerialsTotalOppBox: "ATOPPB",
      AerialsTotalOwnBox: "ATOB",
      FoulsOwnHalfPct: "FOH%",
      RecoveriesOppHalf: "ROH",
      DuelsPct: "D%",
      TacklesUnsuccessful: "UTA",
      LongBallSuccessful: "SLB",
      TacklesWasDribbledFirstThird: "TWDFT",
      TacklesWasDribbledSecondThird: "TWDST",
      TacklesWasDribbledFinalThird: "TWDFT",
      BallProgressionFinalThird: "BPFT",
      DuelsTotal: "DT",
      QuickRecoveries: "QR",
      ShotsPerNPG: "SPNPG",
      ShotsOutBox: "SOB",
      GoalsOutBox: "GOB",
      ShootingOutBox: "SOB%",
      HandPassing: "HP",
      Catching: "CAT",
      ClaimAccuracy: "CA",
      HighTurnovers: "HTOV",
      ShotEndingHighTurnovers: "SEHT",
      GoalEndingHighTurnovers: "GEHT",
      AverageCarriesProgress: "ACP",
      ChanceEndingCarries: "CEC",
      AssistEndingCarries: "AEC",
      ShotEndingCarries: "SEC",
      GoalEndingCarries: "GEC",
      ShotEndingSequence: "SES",
      GoalEndingSequence: "GES",
      xGPerNPG: "xGPNPG",
      AerialWonOffensive: "AWO",
      AerialWonDefensive: "AWD",
      xGAgainst: "xGC",
      xGDiffAgainst: "xGDC",
      xGPerNPGAgainst: "xGPNPGA",
      xGOpenPlayAgainst: "xGOPC",
      xGSetPieceAgainst: "xGSPC",
      xGPerShotAgainst: "xGSC",
      ShotsAgainst: "STC",
      ShotsOnTargetAgainst: "SOTC",
      RivalPossession: "RP",
      AerialDefensivePct: "AD%",
      HighRecoveries: "HR",
      HighDefensiveActionPct: "HDA%",
      HighDefensiveDistance: "HDD",
      PassesPerPossession: "PPP",
      LengthPerPossession: "LPP",
      xTNet: "xTN",
      AvgCarriesDistance: "ACD",
      PassesForwardPct: "PF%",
      TacklesAttempted: "ATA",
      DuelsLost: "DL",
      Carries: "CARR",
      CarriesPct: "CARR%",
      Aerials: "AER",
      ProgressivePassesReceivedIntoBox: "PPRIB",
      PassesOppHalf: "POPH",
      ShotsOnTarget: "SOT",
      AggressiveActions: "AA",
      Crosses: "CRO",
      xGBuildup5pass: "xGBUP5",
      DefensiveDistance: "DD",
      SpeedSequence: "SS",
      Touches: "TOU",
      AerialsTotalOppHalf: "ATOPPH",
      AerialsOppHalf: "AOPPH",
      AerialsWonOppHalfPct: "AWOH%",
      AerialsPctOppBox: "AOPPB%",
      AerialsPctOwnBox: "AOB%",
      AerialDefensive: "AD",
      AerialOffensive: "AO",
      AerialOffensivePct: "AO%",
      IndividualPressureOppHalf: "IPOPPH",
      ChancesCreatedOP: "CCOP",
      TouchesPerShot: "TPS",
      PassesFinalThirdTotalPct: "PFT%",
      xACrosses: "xAC",
      Passes: "PAS",
      PassesSuccessful: "SPA",
      TacklesWasDribbledFouls: "TWDF",
      OffsidesCaught: "OC",
      ProgressivePassesReceivedFinalThird: "PPRFT",
      ProgressivePassesReceived: "PPR",
      Breadth: "BRD",
      DuelsDefTotal: "DDT",
      DefensiveActions: "DA",
      ProgressivePassesReceivedOppHalf: "PPROH",
      CompletedCrossesOP: "CCOP",
      CrossingOP: "COP",
      PassingContribution: "PC",
      BallProgressionOppHalfInTeam: "BPOPPHiT",
      PassesOPIntoBoxInTeam: "POBIT",
      TouchesOppBoxInTeam: "TOBIT",
      xGOPInTeam: "xGOPiT",
      DeepPasses: "DP",
      DefensiveDuelsPct: "DD%",
      DefensiveDistance: "DD",
      QuickRecoveriesPct: "QR%",
      DiffDefensiveDistanceTeam: "DDDT",
      xTPassing: "xTP",
      xTPassing100Passes: "xTP100",
      ProgressivePassesAccurate: "APP",
      xP: "xP",
      PassAbility: "PA",
      OPPassesIntoOppBoxPct: "OPPIOB%",
      EntriesOppBox: "EOPPB",
      Crosses6yardBox: "C6YB",
      Cutbacks: "CUT",
      xTDribbling: "xTD",
      AvgShotDistance: "ASD",
      xGOnTarget: "xGOT",
      FinishingxGOT: "FxGOT",
      DribblesWonOwnHalf: "DWOH",
      DribblesOwnHalf: "DOH",
      DribblesOwnHalfPct: "DOH%",
      DribblesWonOppHalf: "DWOPH",
      DribblesOppHalf: "DOPH",
      DribblesOppHalfPct: "DOPH%",
      DribblesWonFinalThird: "DWFT",
      DribblesFinalThird: "DFT",
      DribblesFinalThirdPct: "DFT%",
      ShotEndingHighRecoveries: "SEHR",
      PassingFinalThirdAgainst: "PFTC",
      OpenPlayPassesIntoOpponentBoxAgainst: "OPPOBC",
      EntriesOppBoxAgainst: "EOBC",
      DeepProgressionAgainst: "DPC",
      TouchesInOpponentBoxAgainst: "TOBC",
      Score: "SCO",
      PDScore: "SCO",
      OrlegiScore: "SCO",
      SirScore: "SCO",
      xTOPInTeam: "xTOPiT",
      YellowCards: "YC",
      RedCards: "RC",
      xTOpenPlayAgainst: "xTOPC",
      xTSetPieceAgainst: "xTSPC",
      NPGOpenPlayAgainst: "NPG OPC",
      NPGSetPieceAgainst: "NPG SPC",
      PassesOppHalfPerPossession: "POHP",
      AverageTimeRecovery: "ATR",
      ExpectedPassing: "xP%",
      NumPossession10Passes: "P10P",
      PassesReceived: "PR",
      PassesReceivedFinalThird: "PRLFT",
      ProgressivePassesTotalPct: "PP%",
      ShortPassesPct: "SP%",
      TouchesOppBoxOppTeam: "TOBOT",
      ShotsOnTargetOppTeam: "SOTOT",
      NPGOppTeam: "NPGOT",
      //Physical Stats
      TotalDistance: "DST",
      WalkingDistance: "WLKD",
      JoggingDistance: "JOGD",
      RunningDistance: "RUND",
      ExtremeAccelerations: "XACC",
      NumberOfRuns: "RUNQ",
      HsrDistance: "HSRD",
      HsrNumber: "HSRQ",
      HsrDistancePct: "HSRD%",
      SprintsNumber: "SPRQ",
      SprintsDistance: "SPRD",
      SprintNumberDeclinePct: "SQD%",
      SprintDistanceDeclinePct: "SDD%",
      SprintDistancePct: "SPRD%",
      Accelerations: "ACC",
      MaxSpeed: "MS",
      AvgMaxSpeed: "AvgMS",
      MaxAccelerations: "MACC",
      BypassedPlayersByPasses: "ByPP",
      BypassedDefendersByPasses: "ByPD",
      PassesBypassingPlayers: "PByPP",
      PassesBypassingDefenders: "PByPD",
      BypassedPlayersPerPass: "ByPPPP",
      BypassedDefendersPerPass: "ByPDPP",
      LineBreakingPasses: "LBP",
      LineBreakingPassesMD: "LBPMD",
      LineBreakingPassesM: "LBPM",
      LineBreakingThroughBalls: "LBTB",
      LineBreakingPassesPerPass: "LBPP",
      TotalPassesUnderStrongPressure: "TPUSP",
      TotalPassesUnderLightPressure: "TPUP",
      SuccessfulPassesUnderStrongPressure: "SPUSP",
      SuccessfulPassesUnderLightPressure: "SPULP",
      PassingUnderStrongPressure: "PUSP%",
      PassingUnderLightPressure: "PULP%",
      PassReceiptsInSpaceCompleted: "PRMS",
      PassReceiptsInSpace: "PRS",
      TotalStrongOnBallPressures: "TSBP",
      TotalLightOnBallPressures: "TBP",
      SuccessfulStrongOnBallPressures: "SSBP",
      SuccessfulLightOnBallPressures: "SLBP",
      StrongOnBallPressuresPct: "SBP%",
      LightOnBallPressuresPct: "BP%",
      TimesBypassedByPasses: "ByPPAS",
      TimesBypassedByCarries: "ByPC",
      TimesBypassedByActions: "ByPA",
      BypassedPlayersByCarries: "ByPPC",
      BypassedDefendersByCarries: "ByPDC",
      BypassedPlayersByActions: "ByPPA",
      BypassedDefendersByActions: "ByPDA",
      CarriesBypassingPlayers: "CByPP",
      CarriesBypassingDefenders: "CByPD",
      BypassedPlayersPerCarry: "ByPPPC",
      BypassedDefendersPerCarry: "ByPDPC",
      LineBreakingCarries: "LBC",
      LineBreakingCarriesMD: "LBCMD",
      LineBreakingCarriesM: "LBCM",
      LineBreakingCarriesD: "LBCD",
      LineBreakingCarriesPerCarry: "LBCC%",
      LineBreakingActions: "LBA",
      LineBreakingActionsMD: "LBAMD",
      LineBreakingActionsM: "LBAM",
      LineBreakingActionsD: "LBAD",
      PassesPerLineBreakingPass: "PPLBP",
      CarriesPerLineBreakingCarry: "CPLBC",
      LinesBrokenByPasses: "LBByP",
      LinesBrokenByCarries: "LBByC",
      LinesBrokenByActions: "LBByA",
      LinesBrokenPerPass: "LBPP",
      LinesBrokenPerCarry: "LBPC",
      AvgLastDefenderDistanceIP: "ALDDIP",
      AvgLastDefenderDistanceOOP: "ALDDIP",
      AvgDefensiveLineDistanceIP: "ALDDIP",
      AvgDefensiveLineDistanceOOP: "ALDDIP",
      AvgRBDistanceIP: "ARBDIP",
      AvgRBDistanceOOP: "ARBDOOP",
      AvgLBDistanceIP: "ALBDIP",
      AvgLBDistanceOOP: "ALBDOOP",
      AvgBlockDistanceIP: "ABDIP",
      AvgBlockDistanceOOP: "ABDOOP",
      AvgBlockAreaIP: "ABAIP",
      AvgBlockAreaOOP: "ABAOOP",
      AvgDefensiveLineWidthOOP: "ADLWOOP",
      AvgOffensiveLineLastThirdWidthIP: "AOLLTWIP",
      AvgLByIP: "ALBIP",
      AvgRByIP: "ARBIP",
      AvgOffensiveLineDistanceIP: "AOLDIP",
      AvgOffensiveLineLastThirdDistanceIP: "AOLTDIP",
      AvgOffensiveLineWidthIP: "AOLWIP",
      OffBallRuns: "OBR",
      OffBallRunsOverlap: "OBRO",
      OffBallRunsUnderlap: "OBRU",
      OffBallRunsRunAhead: "OBRA",
      OffBallRunsRunBehind: "OBRB",
      OffBallRunsCrossReceiver: "OBRCR",
      OffBallRunsSupport: "OBRS",
      OffBallRunsComingShort: "OBRCS",
    }
  },
  team: {
    averageAge: "متوسط عمر",
    transferBalance: "فرق الصرف",
    roster: "قائمة",
    transfers: "التنقلات",
    trends: "اتجاهات",
    loans: "أعارات",
    loanFrom: "اعارة من",
    loanTo: "اعارة الى",
    latestGames: "أحدث المباريات",
    latestXGames: "أحدث المباريات {0}",
    playingFor: "يلعب مع",
    overview: "ملخص",
    visualization: "التصور",
    location: "موقع",
    outcome: "حصيلة",
    beeswarm: "تصنيف",
    parentTeam: "الفريق الأعلى",
    childTeam: "فريق الشباب",
    preferredFormation: "التشكيل المفضل",
    viewType: "نوع العرض",
    overviewTab: {
      axisXTotal: "المجموع",
      axisXper90: "لكل 90'",
      dataPerGameText: "البيانات لكل لعبة",
      season: "موسم",
      last: "آخر",
      current: "حاضِر",
      TeamStyle: "أسلوب",
      TeamDefensive: "دفاعي",
      TeamOffensive: "هجومي",
      TeamCustom1: "مخصص 1",
      TeamCustom2: "مخصص 2",
      TeamCustom3: "مخصص 3",
      TeamCustom4: "مخصص 4",
      coach: "مدرب",
      groups: {
        Goals: {
          name: "الأهداف",
          desc: "يُظهر أهداف ركلات الجزاء والأهداف غير الجزاءية (اللعب المفتوح والركلة الثابتة)."
        },
        Assists: {
          name: "التمريرات الحاسمة",
          desc: "اللاعبون الذين حققوا أكثر التمريرات الحاسمة (اللعب المفتوح والركلات الثابتة) هذا الموسم."
        },
        xG: {
          name: "الأهداف المتوقعة",
          desc: "الأهداف المتوقعة من اللعب المفتوح والركلات الثابتة"
        },
        xA: {
          name: "التمريرات الحاسمة المتوقعة",
          desc: "التمريرات الحاسمة المتوقعة من اللعب المفتوح والركلات الثابتة."
        },
        Finishing: {
          name: "الانهاء",
          desc: "نسبة التسديدات التي تنتهي بهدف."
        },
        ScoringContribution: {
          name: "مساهمة التهديف",
          desc: "عدد التمريرات الحاسمة والأهداف للفريق."
        },
        xT: {
          name: "التهديد المتوقع",
          desc: "التهديد المتوقع الناتج عن اللعب المفتوح والركلات الثابتة وxT السلبية."
        }
      },
      stats: {
        openPlay: "اللعب المفتوح",
        setPiece: "الركلات الثابتة",
        negative: "سلبي",
        npg: "أهداف غير ركلات الجزاء",
        goalsPenalty: "أهداف من ضربات الجزاء  ",
        npgOpenPlay: "NPG من اللعب المفتوح",
        npgSetPiece: "NPG من الركلات الثابتة",
        assists: "التمريرات الحاسمة",
        assistsOpenPlay: " التمريرات الحاسمة من اللعب المفتوح",
        assistsSetPiece: "التمريرات الحاسمة من الركلات الثابتة ",
        xGOpenPlay: "xG اللعب المفتوح",
        xGSetPiece: "xG الركلات الثابتة",
        xAOpenPlay: "xA اللعب المفتوح",
        xASetPiece: "xA  الركلات الثابتة ",
        nonPenaltyShots: "تسديدات غير ركلات جزاء",
        penaltyShots: "ضربات الجزاء",
        xT: "التهديد المتوقع",
        xTOpenPlay: "xT اللعب المفتوح",
        xTSetPiece: "xT  الركلات الثابتة",
        xTNeg: "xT السلبي",
        totalFinishing: "الانهاء",
        nonPenaltyFinishing: " إنهاء دون ركلات الجزاء",
        goalsPenaltyFinishing: "إنهاء ركلة الجزاء",
        walkingDistance: "المشي",
        joggingDistance: "الهرولة",
        runningDistance: "الركض",
        hsrDistance: "HSR",
        sprintsDistance: "العدو",
        runningNumber: "عدد الجري",
        hsrNumber: "سبرينتات HSR",
        sprintsNumber: "عدد السبرينتات",
        maxSpeed: "السرعة القصوى",
        accelerations: "التسارعات",
        extremeAccelerations: "التسارع الشديد",
        maxAcceleration: "أقصى تسارع"
      }
    },
    teamAnalysis: "تحليل الفريق",
    agentView: {
      positions: {
        gk: "حارس مرمى",
        leftFullback: "ظهير أيسر",
        centralDefender: "مدافع محوري",
        rightFullback: "ظهير أيمن",
        midfielder: "لاعب خط وسط",
        attackingMidfielder: " منوسط ميدان هجومي ",
        leftWinger: "الجناح الايسر",
        rightWinger: "الجناح الأيمن",
        fw: "مهاجم"
      },
      groups: {
        contractEnd: "شهور",
        age: "سنوات من العمر",
        availability: "التوفر"
      },
      placer: {
        legend: "القوة على أساس العمر والعقد والتوافر والأداء"
      }
    },
    transfersTab: {
      valueMovements: "قيمة الحركات",
      valueTransfers: "قيمة التنقلات",
      valueLoans: "قيمة الاعارات",
      avgAgeMovements: "متوسط عمر التنقلات",
      avgAgeTransfers: "متوسط عمر التنقلات",
      avgAgeLoans: "متوسط عمر الاعارات",
      operations: {
        buys: {
          buy: "يشتري",
          loan: "يعير",
          "end of loan": "نهاية الاعاراة",
          "free transfer": "حر",
          free: "حر",
          "loan transfer": "الاعاراة",
          other: "آخر"
        },
        sells: {
          buy: "يبيع",
          loan: "يعير",
          "end of loan": "نهاية الاعاراة",
          "free transfer": "حر",
          free: "حر",
          "loan transfer": "اعارة",
          other: "آخر",
          retired: "متقاعد"
        }
      }
    },
    trendsTab: {
      streaks: "الشرائط",
      wins: "انتصارات",
      cleanSheets: "شباك نظيفة",
      goalPeriods: "فترات تسجيل الأهداف",
      concededGoalPeriods: "فترات استقبال الأهداف",
      comebacks: "العودة",
      avgTime: "متوسط ​​الوقت",
      kindOfGoals: "نوع من الأهداف",
      percentWinning: "% الفوز",
      percentDrawing: "٪ التعادل",
      percentLosing: "% خسارة",
      totalOf: "مجموع ال",
      minutes: "دقائق",
      before: "قبل",
      after: "بعد",
      playedOn: "لعبت على",
      scored: "يحرز هدف",
      conceded: "قبل",
      ownGoals: "الأهداف العكسية",
      phasesOfGame: "مراحل اللعبة",
      buildup: "البناء",
      midfieldProgression: "التقدم في الوسط",
      attackOpposition: "الهجوم على الخصم",
      attackingTransition: "التحول للهجوم",
      highPress: "الضغط العالي",
      midBlock: "البلوك المتوسط",
      lowBlock: "البلوك المنخفض",
      defensiveTransition: "التحول للدفاع"
    },
    onOff: "تشغيل/إيقاف",
    dragUpTo5Players: "اسحب ما يصل إلى 5 لاعبين",
    selectUpTo5Players: "اختر ما يصل إلى 5 لاعبين",
    onOffTab: {
      G90: "الأهداف 90",
      GA90: "الأهداف ضد 90",
      diffG90: "فارق الأهداف 90",
      XG90: "xG 90",
      XGA90: "xG 90 مقبول",
      diffXG90: "الفرق xG 90",
      playersOn: "Combo ON",
      playersOff: "Combo OFF",
      ground: "أرضي",
      playersOnThePitch: "اللاعبين في الملعب",
      playersOffThePitch: "اللاعبين خارج الملعب",
      attackTitle: "هجوم",
      attackSubTitle: "إحصائيات الهجوم",
      defenseTitle: "دفاع",
      defenseSubTitle: "إحصائيات دفاعية",
      associationTitle: "منظمة",
      associationSubTitle: "إحصائيات المنظمة",
      comboOn: "التحرير والسرد النشط",
      comboOff: "اي شيء اخر",
      diffGoals90: "G Diff 90",
      goals90: "الأهداف من غير ركلات الجزاء 90",
      goalsAgainst90: "أهداف من غير ركلات الجزاء المقبولة 90",
      xgAgainstPer90: "xG  90المقبولة ",
      xgDiffPer90: "xG Diff 90",
      xgPer90: "xG 90",
      xt90: "xT 90",
      shotsOnTarget90: "تسديدات على المرمى 90",
      touchesOppBox90: "اللمسات مقابل صندوق 90",
      shotsOnTargetAgainst90: "تسديدات على المرمى المقبولة 90 ",
      ppda90: "PPDA 90",
      xa90: "xA 90 ",
      directness90: "المباشرة 90",
      possession: "الاستحواذ ٪",
      pctPasses: " التمريرات ٪",
      pctPassesFinalThird: "تمريرات الثلث الأخير ٪",
      placeholder: "ابدأ باختيار فريق",
      subtitle: "حسّن مقاييس الفريق عن طريق إضافة أو إزالة لاعبين من التشكيلة"
    },
    terms: {
      short: "المدى القصير",
      mid: "المدى المتوسط",
      long: "المدى البعيد"
    },
    report: {
      title: 'تقرير الفريق',
      selectedPeriod: 'الفترة المختارة',
      stackedCharts: 'الرسوم البيانية المكدسة',
      radars: "الرادارات",
      generalData: 'البيانات العامة',
      scoringChances: 'فرص التسجيل',
      areasReport: 'تقرير المناطق',
      setPieceReport: 'تقرير الكرات الثابتة',
      corners: 'الركنيات',
      cornersAgainst: 'الركنيات ضد',
      indirectFreeKicks: 'الركلات الحرة غير المباشرة',
      indirectFreeKicksAgainst: 'الركلات الحرة غير المباشرة ضد',
      freeKicks: 'الركلات الحرة',
      freeKicksAgainst: 'الركلات الحرة ضد',
      penaltys: 'ركلات الجزاء',
      freeKicksContribution: 'مساهمة الركلات الحرة',
      shotsContribution: 'مساهمة التسديدات',
      topXPlayersByStats: 'أفضل {x} لاعبين حسب الإحصائيات',
      lastShotZone: 'منطقة التسديدة الأخيرة',
      throwSide: 'جانب الرمية',
      kindOfThrow: 'نوع الرمية',
      scored: 'مسجل',
      against: 'ضد',
      perGame: 'لكل مباراة',
      total: 'الإجمالي',
      efficiency: 'الكفاءة',
      organizedAttack: 'الهجوم المنظم',
      offTransition: 'التحول الهجومي',
      chances: 'الفرص',
      chancesScored: 'الفرص المسجلة',
      chancesAgainst: 'الفرص ضد',
      goalsScored: 'الأهداف المسجلة',
      goalsAgainst: 'الأهداف ضد',
      goalsOrganizedAttack: 'أهداف الهجوم المنظم',
      goalsOffTransition: 'أهداف التحول الهجومي',
      goalsSetPiece: 'أهداف الكرات الثابتة',
      goalsOrganizedAttackScored: 'أهداف الهجوم المنظم المسجلة',
      goalsOrganizedAttackAgainst: 'أهداف الهجوم المنظم ضد',
      goalsOffTransitionScored: 'أهداف التحول الهجومي المسجلة',
      goalsOffTransitionAgainst: 'أهداف التحول الهجومي ضد',
      goalsSetPieceScored: 'أهداف الكرات الثابتة المسجلة',
      goalsSetPieceAgainst: 'أهداف الكرات الثابتة ضد',
      crossSide: 'جانب العرضية',
      externalShot: 'تسديدة خارجية',
      innerPlay: 'اللعب الداخلي',
      throwIn: 'رمية تماس',
      box: 'المنطقة',
      zone2: 'المنطقة 2',
      goalsPerPhases: 'الأهداف لكل مرحلة'
    },    
    minutesAlert: "*عرض فقط اللاعبين الذين لعبوا 450 دقيقة أو أكثر",
    minutesException: "لا يوجد لاعبون لعبوا 450 دقيقة أو أكثر. عرض جميع اللاعبين",
    analysis: "تحليل",
    substitutions: "البدائل",
    attackZones: "مناطق الهجوم",
    formations: "التشكيلات",
    shotZones: "مناطق التسديد",
    crossings: "التوزيعات",
    byTime: "بالوقت",
    byPosition: "حسب المركز",
    byPlayer: "بواسطة اللاعب",
    W: "الفوز",
    D: "التعادل",
    L: "خسارة",
    substitutionsByGame: "التبديلات حسب المباراة",
    substitutionsShort: "التبديلات",
    avgSeasonShort: "متوسط موسم",
    startingAt: "يبدأ من",
    endingAt: "تنتهي عند",
    startingAtInfo: "يُظهر نسبة الامتلاكات بناءً على موقع الحدث الأول",
    endingAtInfo: "يُظهر نسبة الامتلاكات بناءً على موقع الحدث الأخير",
    endingWithShot: "تنتهي بتسديدة",
    endingInBox: " تنتهي في منطقة الجزاء",
    pfX: "PF {x}",
    bySide: "بالجانب",
    cornerKicks: "ركلات الركنية",
    included: "متضمنة",
    excluded: "مستبعد",
    onlyCorner: "الركنية فقط",
    sizeByMarketValue: "الحجم حسب القيمة السوقية",
    timeInTeam: "مواسم في الفريق",
    newSignings: "التوقيعات الجديدة",
    sizeBy: "الحجم حسب",
    connections: "روابط",
    assistant: "ممرر",
    finisher: "منهي",
    playersMinutesAlert: "عرض اللاعبين الذين لعبوا دقائق فقط في الموسم المحدد"
  },
  leagueTable: {
    subtitle: "تحقق من كيفية سير الدوريات"
  },
  leagueMatchdays: {
    byRound: "حسب الجولة",
    byDate: "حسب التاريخ",
    byTeam: "حسب الفريق"
  },  
  teamStats: {
    subtitle: "قارن بين أداء الفرق",
    xGDiffPerGame: "xGD",
    xGDiffPerGameExplicit: "الفرق بين الأهداف المتوقعة والأهداف",
    expectedPointsDiff: "xPD",
    expectedPointsDiffExplicit: "الفرق بين النقاط المتوقعة والنقاط",
    games: "GAM",
    gamesExplicit: "المباريات الملعوبة",
    pointsPerGame: "PPG",
    pointsPerGameExplicit: "النقاط لكل مبارات"
  },
  roles: {
    ROLE_USER: "مستخدم",
    ROLE_ADMIN: "مسؤل",
    ROLE_REPORTS: "التقارير",
    ROLE_API: "Driblab API",
    ROLE_PHYSICAL_DATA: "بيانات بدنية",
    ROLE_VIDEO: "Capture",
    ROLE_EVENTING_DATA: "Driblab XY",
    "ROLE_DRIBLAB_HUB": "Driblab Hub",
    "ROLE_TRACKING": "تتبع",
    "ROLE_ARRIGO": "Arrigo",
    "ROLE_API_description": "قم باستخراج معلومات اللاعب والفريق والمبارات والدوري بسهولة بصيغة JSON.",
    "ROLE_EVENTING_DATA_description": "تعمق في الإحصائيات باستخدام المخططات الرادارية وتصنيفات اللاعبين والخرائط والمزيد استنادًا إلى أكثر من 100 مقياس أداء.",
    "ROLE_PHYSICAL_DATA_description": "الوصول إلى بيانات اللياقة البدنية وتصفية اللاعبين حسب مقاييس الأداء المختلفة (المسافة، السرعة، سباقات السرعة، التسارع ...).",
    "ROLE_VIDEO_description": "قم بتوفير مقاطع فيديو وتشكيلات واحصل على مباريات موسومة بالأحداث والإحصائيات لإجراء تحليل متعمق.",
    "ROLE_DRIBLAB_HUB_description": "تتبع المهام الاستكشافية وإدارتها بكفاءة باستخدام التقويمات والملاحظات والتنبيهات ومشاركة المستندات.",
    "ROLE_TRACKING_description": "احصل على البيانات الموضعية لجميع اللاعبين في اللعبة من خلال واجهة برمجة التطبيقات (API) الخاصة بنا لإجراء تحليل شامل.",
    "ROLE_ARRIGO_description": "يجمع بين eventing و tracking في مقاييس مبتكرة تتجاوز التقليدي وتضيف قيمة لكل حركة.",
    "ROLE_REPORTS_description": "اطلب تقارير استكشافية مفصلة من فريق المحللين لدينا للعثور على الفريق أو اللاعب المثالي."
  },
  administration: {
    newClient: "عميل جديد",
    newUser: "مستخدم جديد",
    editClient: "تحرير العميل",
    editUser: "تحرير المستخدم",
    clientName: "اسم",
    permissions: "الأذونات",
    releaseUser: "الافراج عن المستخدم",
    connectAsUser: "الاتصال كمستخدم",
    releaseModalTitle: "الافراج عن تأكيد المستخدم",
    releaseModalMessage: "سيتلقى المستخدم رسالة بريد إلكتروني حول حسابه الجديد. هل أنت متأكد أنك تريد إبلاغه؟",
    clientType: {
      Driblab: "Driblab",
      Team: "فريق",
      Brand: "ماركة",
      Federation: "الاتحاد",
      Media: "وسائط",
      Agency: "وكالة",
      Individual: "فردي"
    },
    userType: {
      Ownership: "ملكية",
      SportingDirector: "المدير الرياضي",
      Brand: "ماركة",
      Federation: "الاتحاد",
      Media: "وسائط",
      Agency: "وكالة",
      Individual: "فردي",
      Scout: "كشاف",
      Coach: "مدرب"
    },
    visibleYears: "سنوات مرئية",
    areaModalTitle: "تفعيل/إلغاء تنشيط تأكيد الدوريات",
    areaModalMessage: "هل أنت متأكد من تفعيل/إلغاء تنشيط جميع الدوريات من المنطقة المحددة؟",
    countStats: "عد الإحصائيات ",
    userClientModalTitle: "المستخدم موجود بالفعل في عميل آخر",
    eventing: "Eventing",
    hub: "Hub"
  },
  dashboards: {
    lastGame: "تحليل المباراة الاخيرة",
    lastGameSimple: "أخرمباراة",
    seeAllGameInfo: "الاطلاع على جميع معلومات مباراة",
    nextGame: "معاينة  المباراة القادمة",
    myTeam: "فريقي",
    lastMatchdayGames: "آخر مباراة",
    lastAdded: "آخر اضافة",
    myFavorites: "مفضلتي",
    seeAllFavorites: "رؤية جميع المفضلات",
    placeholderFavorites: "يمكنك إضافة المفضلة من تفاصيل اللاعب",
    placeholderTeamFavorites: "You can add favorites from team detail",
    myCollections: "مجموعاتي",
    placeholderCollections: "ليس لديك أي مجموعات حتى الآن",
    lastCreated: "آخر إنشاء",
    seeAllCollections: "شاهد جميع المجموعات",
    seeRival: "شاهد الخصم",
    seeMyTeam: "شاهد فريقي",
    title: "نظرة عامة على لوحة القيادة",
    subtitle: "مرحبًا بعودتك",
    recentPlayers: "اللاعبين الجدد",
    lastScouted: "آخر اللاعبين الذين تم استطلاعهم ",
    scout: "كشاف",
    reportsRequested: "التقارير",
    lastRequested: "آخر طلب",
    goInbox: "اذهب إلى البريد الوارد",
    placeholderLastScouted: "يمكنك البحث عن اللاعبين في الشريط الأيسر أو في أداة الكشف",
    placeholderReports: "يمكنك طلب تقارير من تفاصيل اللاعبين",
    nationalPlayers: "أهم اللاعبين الوطنيين في الدول الأخرى",
    lastGames: "آخر المبارايات",
    nationalPlayersShort: "اللاعبين الوطنيين في بلدان أخرى",
    nextMatchdayGames: "المباراة القادمة",
    injuredPlayers: "اللاعبين المصابين",
    atPresent: "في الوقت الحاضر",
    seeAllPlayers: "رؤية جميع اللاعبين",
    suspendedPlayers: "اللاعبين الموقوفين",
    placeholderInjured: "لا يوجد لاعبين مصابين",
    teamValueImpacted: "تأثير قيمة الفريق",
    placeholderSuspended: "لا يوجد لاعبين موقوفين",
    placeholderNextGame: "لا توجد مباراة متاحة",
    placeholderNoGames: "لا توجد مبارايات متاحة حتى الآن ",
    placeholderLastMatchDayNotFound: "آخر جولة  غير متوفرة",
    placeholderNextMatchDayNotFound: "الجولة القادمة غير متاحة",
    usersMostSearch: "المستخدمون الذين أجروا معظم عمليات البحث",
    lastTwoDays: "خلال اليومين الماضيين",
    searchesHistory: "تاريخ البحث",
    dayByDay: "يوميًا",
    activeUsersTitle: "المستخدمين النشطين",
    activeUsersSubtitle: "تم تسجيل واحد على الأقل في الشهر الماضي",
    onlineUsersTitle: "مستخدمين على الهواء",
    onlineUsersSubtitle: "ابحث عن شيء ما في الساعة الماضية",
    searchesPerformed: "تم إجراء عمليات البحث",
    onlyClients: "العملاء فقط",
    activeClientsTitle: "العملاء النشطين",
    activeClientsSubtitle: "لديك مستخدم نشط واحد على الأقل",
    last24Hours: "أخر 24 ساعه",
    activityHistory: "سجل النشاط",
    loginHistory: "تاريخ الوصول",
    failLogins: "فشل الوصول",
    successLogins: "الوصول بنجاح",
    clientStats: "إحصائيات العميل",
    playersMostSearch: "اللاعبون الذين لديهم أكبر عدد من عمليات البحث",
    toolsMoreUsed: "المزيد من الأدوات المستخدمة",
    hotPlayers: "اللاعبين الأكثر بحثا",
    last_month: "الشهر الماضي",
    last_week: "الأسبوع الماضي",
    last_day: "بالأمس",
    nClients: "عدد العملاء",
    userDashboard: "لوحة تحكم المستخدم",
    userDashboardSubtitle: "ملخص نشاط الحساب",
    offlineDaysOfClient: "الأيام دون اتصال لكل عميل",
    hideNoConnected: "إخفاء غير المتصلين",
    onlyTrial: "عملاء الاختبار فقط",
    daysWithoutLogin: "الأيام دون تسجيل الدخول",
    trialDays: "أيام الاختبار"
  },
  faq: {
    subtitle: " تعرف أكثر على  Driblab PRO ",
    categories: {
      playerMetrics: "مقاييس اللاعب",
      teamMetrics: "مقاييس الفريق",
      positions: "مراكز الفريق",
      tools: "أدوات",
      api: "واجهة برمجة التطبيقات",
      videos: "دروس",
      playerPositions: "مواقع اللاعبين"
    },
    positions: {
      GK: "حارس مرمى",
      DR: "المدافع الأيمن / الظهير الأيمن (RB)",
      DC: " مدافع  محوري / قلب دفاع (CB)",
      DL: "المدافع الأيسر / الظهير الأيسر (LB)",
      DMR: "  الجناح الأيمن الخلفي (RWB)",
      DMC: "لاعب وسط دفاعي محوري (CDM)",
      DML: " الجناح الأيسر الخلفي (LWB)",
      MR: "لاعب وسط أيمن (RM)",
      MC: "لاعب خط وسط (CM)",
      ML: "لاعب وسط أيسر (LM)",
      AMR: " لاعب وسط هاجومي أيمن / الجناح الأيمن (RW) ",
      AMC: " لاعب وسط هجومي / لاعب خط الوسط المتقدم",
      AML: "لاعب وسط هجومي  أيسر / جناح أيسر (LW)",
      FWR: "المهاجم الأيمن / المهاجم الأيمن (RS) ",
      FW: "مهاجم / مهاجم (ST)",
      FWL: "المهاجم الأيسر / المهاجم الأيسر (LS)"
    },
    metrics: {
      categories: {
        Association: "منظمة",
        Saving: "تصدي",
        Shooting: "تسديد",
        Defending: "الدفاع",
        Passing: "تمرير",
        BallHandling: "التعامل مع الكرة",
        Aerial: "هوائي",
        Physical: "بدني",
        Predictive: "نوقعي",
        Arrigo: "أريجو",
        Score: "نتيجة",
        Turnovers: "خسائر الكرة",
        Carries: "حملات",
        SequenceInvolvement: "المشاركة في التسلسل",
        Crosses: "التوزيعات ",
        Distance: "مسافة",
        Sprint: "سبرينت",
        Acceleration: "التسارع",
        MaxAcceleration: "أقصى تسارع",
        Speed: "السرعة",
        OutPlay: "تجاوز الخصم",
        LineBreakingPasses: "تمريرات تكسر الخطوط",
        LineBreakingCarries: "مراوغات تكسر الخطوط",
        LineBreakingActions: "تحركات كسر الخطوط",
        PassUnderPressure: "تمريرة تحت الضغط",
        BallReceived: "استلام الكرة",
        OnBallPressureReceived: "الضغط عند الاستحواذ",
        OnBallPressure: "الضغط على حامل الكرة",
        SpatialCoverage: "التغطية المكانية",
        OffBallPressure: "الضغط بدون كرة",
        OffBallRuns: "تحركات بدون كرة",
        NoCategory: "آخرون",
        subcategories: {
          Quality: "الجودة",
          Quantity: "الكمية",
          TeamComparison: "مقارنة الفرق",
          Receptions: "استلامات",
          LongBalls: "كرات طويلة",
          Efficiency: "الفعالية",
          Ratio: "النسبة",
          Defensive: "دفاعي",
          Offensive: "هجومي",
          Foot: "قدم",
          Progression: "تقدم",
          TopValue: "أعلى قيمة",
          Predictive: "نوقعي",
          Distance: "مسافة",
          Aerial: "هوائي",
          Crosses: "التوزيعات ",
          NoCategory: "آخرون",
        },
        desc: {
          Association: "منظمة",
          Saving: "تصدي",
          Shooting: "تسديد",
          Defending: "الدفاع",
          Passing: "تمرير",
          BallHandling: "التعامل مع الكرة",
          Aerial: "هوائي",
          Physical: "بدني",
          Predictive: "نوقعي",
          Arrigo: "أريجو",
          Score: "نتيجة",
          Turnovers: "خسائر الكرة",
          Carries: "حملات",
          SequenceInvolvement: "المشاركة في التسلسل",
          Crosses: "التوزيعات ",
          Distance: "المسافة المقطوعة بسرعات مختلفة",
          Sprint: "الجري بسرعات مختلفة",
          Acceleration: "التسارع",
          Speed: "السرعة",
          OutPlay: "التغليف",
          LineBreakingPasses: "تمريرات تكسر الخطوط",
          LineBreakingCarries: "مراوغات تكسر الخطوط",
          LineBreakingActions: "تحركات كسر الخطوط",
          PassUnderPressure: "تمريرة تحت الضغط",
          BallReceived: "استلام الكرة",
          OnBallPressureReceived: "الضغط عند الاستحواذ",
          OnBallPressure: "الضغط على حامل الكرة",
          SpatialCoverage: "السيطرة على الملعب",
          OffBallPressure: "الضغط بدون كرة",
          OffBallRuns: "تحركات بدون كرة",
        },
        abbr: {
          Association: "منظمة",
          Saving: "تصدي",
          Shooting: "تسديد",
          Defending: "الدفاع",
          Passing: "تمرير",
          BallHandling: "التعامل مع الكرة",
          Aerial: "هوائي",
          Physical: "بدني",
          Predictive: "نوقعي",
          Arrigo: "أريجو",
          Score: "نتيجة",
          Turnovers: "خسائر الكرة",
          Carries: "حملات",
          SequenceInvolvement: "المشاركة في التسلسل",
          Crosses: "التوزيعات",
          Distance: "المسافة",
          Sprint: "الجري",
          Acceleration: "التسارع",
          MaxAcceleration: "أقصى تسارع",
          Speed: "السرعة",
          OutPlay: "التغليف",
          LineBreakingPasses: "تمريرات تكسر الخطوط",
          LineBreakingCarries: "مراوغات تكسر الخطوط",
          LineBreakingActions: "تحركات كسر الخطوط",
          PassUnderPressure: "تمريرة تحت الضغط",
          BallReceived: "استلام الكرة",
          OnBallPressureReceived: "الضغط عند الاستحواذ",
          OnBallPressure: "الضغط على حامل الكرة",
          SpatialCoverage: "السيطرة على الملعب",
          OffBallPressure: "الضغط بدون كرة",
          OffBallRuns: "تحركات بدون كرة",
        },
      },
      types: {
        1: "لكل 90",
        2: "نسبة مئوية",
        3: "معدل",
        4: "كفاءة",
        5: "متوسط",
        6: "لكل لعبة",
        7: "فرق",
        8: "الأعلى"
      }
    },
    api: {
      subtitle: "الحصول على البيانات من طلبات مختلفة",
      resourcesTitle: "موارد",
      authentication: "المصادقة",
      authText: "من أجل الاتصال بواجهة برمجة التطبيقات (API)، يجب عليك  استعمان request the header `Authorization` with value `Bearer {API_TOKEN}`",
      generate: "يولد",
      tokenPlaceholder: "إذا لم يكن لديك token أو انتهت صلاحيته، فانقر فوق 'Generate'",
      pathParameters: "إعدادات المسار",
      queryParameters: "أطلب الإعدادات",
      responseModel: "نموذج الاستجابة",
      tokenWarning: "* قم بإنشاء token لاستخدام API",
      pathParamsWarning: " * هناك إعدادات المسار غير معبأة",
      genericDescription: "واجهة برمجة التطبيقات (API) تتيح للمطورين الوصول إلى البيانات أو دمج الوظائف في تطبيقاتهم الخاصة. توفر واجهة برمجة التطبيقات الخاصة بإحصائيات كرة القدم وصولًا شاملًا إلى مجموعة متنوعة من البيانات حول البلدان، البطولات، الفرق، اللاعبين، المباريات والمزيد. باستخدام هذه الواجهة، يمكنك بناء تطبيقات تستفيد من بياناتنا الغنية لكرة القدم للتحليلات، التصورات، أو حلول مبتكرة أخرى.",
      methods: {
        getAllCountries: "تسترجع هذه الطريقة قائمة كاملة بجميع البلدان المتوفرة في واجهة برمجة التطبيقات، بما في ذلك تفاصيل رئيسية مثل المعرف الفريد واسم كل بلد. يعتبر هذا النقطة النهائية مثاليًا للتطبيقات التي تحتاج إلى بيانات كرة القدم الجغرافية، مما يتيح ميزات مثل اختيار البلد، التصفية، والتحليل. كما أنها مورد أساسي للتفاعل مع نقاط نهاية أخرى تعتمد على معلمة `countryId`، مما يضمن تنقلًا وتكاملًا سلسًا مع مجموعة البيانات الأوسع للواجهة.",
        getCountryDetail: "توفر هذه الطريقة معلومات تفصيلية حول بلد معين متاح في واجهة برمجة التطبيقات. باستخدام هذه النقطة النهائية، يمكنك استرجاع بيانات مثل اسم البلد، رمزه، وأي بيانات وصفية ذات صلة. تعتبر هذه الطريقة مفيدة بشكل خاص للتطبيقات التي تحتاج إلى تفاصيل مخصصة لكل بلد لتحسين تجربة المستخدم، مثل عرض معلومات سياقية أو إنشاء رؤى مخصصة بناءً على البيانات الجغرافية. تكمل هذه الطريقة نقاط نهاية أخرى عن طريق السماح باستكشاف أعمق للبلد المحدد.",
        getCountryCompetitions: "تسترجع هذه الطريقة قائمة بجميع البطولات المتوفرة داخل بلد معين. تعتبر موردًا قيمًا لبناء ميزات تسمح للمستخدمين باستكشاف البطولات حسب المنطقة، مما يوفر طريقة سلسة لربط بيانات البلدان مع البطولات المرتبطة بها. تعتبر هذه النقطة النهائية أساسية للتطبيقات التي تركز على محتوى كرة القدم المحلي أو التحليلات الإقليمية.",
        getAllCompetitionTypes: "تعيد هذه الطريقة قائمة بجميع أنواع البطولات المتوفرة في واجهة برمجة التطبيقات، مثل الدوريات، الكؤوس، والبطولات الدولية. تعتبر هذه النقطة النهائية مثالية لتصنيف البطولات وتوفير عرض منظم للمستخدمين لأنواع الأحداث المختلفة المغطاة. تعتبر مفيدة بشكل خاص لإنشاء ميزات مثل الفلاتر أو القوائم المنسدلة التي تسمح للمستخدمين باستكشاف بيانات كرة القدم بناءً على طبيعة البطولة.",
        getAllCompetitions: "تسترجع هذه الطريقة قائمة شاملة بجميع البطولات المتوفرة في واجهة برمجة التطبيقات، بغض النظر عن النوع أو الموقع. تعتبر هذه النقطة النهائية مفيدة للتطبيقات التي تحتاج إلى عرض أو تحليل مجموعة واسعة من البطولات، مما يتيح للمستخدمين استكشاف الأحداث واختيارها حسب اهتماماتهم.",
        getCompetitionAvailable: "تسترجع هذه الطريقة قائمة البطولات التي تم تحديدها حاليًا كمتوفرة في واجهة برمجة التطبيقات. يضمن هذا أن البيانات المسترجعة محدثة وجاهزة للاستخدام في التطبيقات. تعتبر مفيدة بشكل خاص للمطورين الذين يبنون ميزات تعتمد على البطولات النشطة أو المتاحة، مما يتيح للمستخدمين استكشاف الأحداث ذات الصلة دون مواجهة بيانات قديمة أو غير مكتملة.",
        getCompetitionDetail: "توفر هذه الطريقة معلومات تفصيلية حول بطولة معينة متاحة في واجهة برمجة التطبيقات. تعتبر مفيدة بشكل خاص للتطبيقات التي تتطلب معلومات متعمقة حول البطولات، مما يتيح ميزات مثل العروض التفصيلية، الرؤى السياقية، أو خيارات التصفية بناءً على خصائص البطولة.",
        getCompetitionSeasons: "تسترجع هذه الطريقة قائمة بجميع المواسم المرتبطة ببطولة معينة. تعتبر هذه النقطة النهائية أساسية للتطبيقات التي تهدف إلى تقديم تغطية شاملة لتاريخ أو الوضع الحالي للبطولة، مما يسمح للمستخدمين باستكشاف البيانات موسمًا بموسم.",
        getSeasonAvailable: "توفر هذه الطريقة قائمة بالمواسم التي تم تحديدها كمتوفرة حاليًا في واجهة برمجة التطبيقات. تعتبر مفيدة بشكل خاص للتطبيقات التي تركز على أحداث كرة القدم المباشرة أو الجارية، مما يسمح للمستخدمين بالتفاعل مع البيانات المتعلقة بالمواسم الحالية.",
        getSeasonDetail: "تسترجع هذه الطريقة معلومات تفصيلية حول موسم معين، بما في ذلك خطه الزمني، البطولة المرتبطة به، والبيانات الوصفية الرئيسية. تعتبر هذه النقطة النهائية أساسية للتطبيقات التي تحتاج إلى رؤى متعمقة حول موسم معين، مما يتيح ميزات مثل نظرات عامة على الموسم، التصفية حسب البطولة، أو عرض الجداول الزمنية التفصيلية لتفاعل المستخدم.",
        getSeasonTeams: "توفر هذه الطريقة قائمة بجميع الفرق المشاركة في موسم معين. تعتبر مثالية للميزات مثل إدارة قوائم الفرق، تحليل أداء الفرق، أو إنشاء فلاتر خاصة بالموسم للمستخدمين.",
        getSeasonPlayer: "تسترجع هذه الطريقة قائمة بجميع اللاعبين المسجلين في موسم معين. تعتبر مثالية لبناء ميزات مثل قوائم اللاعبين، تتبع الأداء، أو تصفية اللاعبين بناءً على الموسم المحدد.",
        getSeasonPlayerStats: "توفر هذه الطريقة إحصاءات تفصيلية لجميع اللاعبين في موسم معين. تعتبر مفيدة بشكل خاص للتطبيقات التي تركز على التحليلات، مقارنات اللاعبين، أو إنشاء تصورات ديناميكية لإنجازات اللاعبين خلال الموسم.",
        getSeasonArrigoMetrics:"توفر هذه الطريقة إحصاءات مُجمّعة لجميع اللاعبين في موسم مُحدد. وهي مفيدة بشكل خاص للتطبيقات التي تُركز على التحليلات، ومقارنات اللاعبين، أو إنشاء تصورات ديناميكية لإنجازات اللاعبين طوال الموسم.",
        getGameTeamPhysicalStats: "تسترجع هذه الطريقة إحصاءات الأداء البدني للفرق في مباراة معينة. تعتبر مثالية للتطبيقات التي تحلل مستويات اللياقة البدنية للفرق، اتجاهات الأداء البدني، أو تقديم تحليلات تفصيلية لجهود الفريق أثناء المباراة.",
        getSeasonTeamStats: "توفر هذه الطريقة إحصاءات شاملة لجميع الفرق المشاركة في موسم معين. تعتبر مفيدة بشكل خاص للتطبيقات التي تركز على تحليل الفرق، ملخصات الموسم، أو مقارنات أداء الفرق طوال الموسم.",
        getSeasonCoaches: "تسترجع هذه الطريقة قائمة بجميع المدربين الذين أداروا الفرق خلال موسم معين. تعتبر مفيدة بشكل خاص للتطبيقات التي تركز على رؤى الموسم، تحليل المدربين، أو تتبع التغيرات في إدارة الفرق على مدار الموسم.",
        getSeasonGames: "توفر هذه الطريقة قائمة بجميع المباريات التي تم لعبها في موسم معين. تعتبر مثالية للتطبيقات التي تحتاج إلى عرض جداول موسم كامل، تحليل نتائج المباريات، أو توفير بيانات شاملة لمباريات الموسم للمستخدمين.",
        getSeasonGamesMatchday: "تسترجع هذه الطريقة جميع المباريات ليوم مباراة معين داخل موسم محدد. تعتبر مفيدة بشكل خاص للتطبيقات التي تهدف إلى عرض جداول أيام المباريات، تحليل الجولات المحددة، أو تقديم رؤى مركزة حول مجموعة معينة من المباريات خلال الموسم.",
        getSeasonLeagueTable: "توفر هذه الطريقة جدول ترتيب الدوري لموسم معين، بما في ذلك الترتيب، النقاط، الانتصارات، التعادلات، الخسائر، وإحصاءات أخرى ذات صلة لكل فريق. تعتبر هذه النقطة النهائية أساسية للتطبيقات التي تركز على تتبع ترتيب الفرق، تحليل تطور الدوري، أو تقديم ترتيب محدث للمستخدمين طوال الموسم.",
        getTeamDetail: "توفر هذه الطريقة معلومات تفصيلية حول فريق معين، بما في ذلك اسمه، سنة تأسيسه، ملعبه، وبيانات وصفية أخرى. تعتبر هذه النقطة النهائية مثالية للتطبيقات التي تتطلب رؤى مخصصة للفريق، مما يتيح ميزات مثل ملفات تعريف الفرق التفصيلية، السياق التاريخي، أو تحسين تجارب المستخدمين مع بيانات غنية متعلقة بالفريق.",
        getTeamLoans: "تسترجع هذه الطريقة معلومات حول الصفقات المؤقتة (الإعارات) التي تشمل فريقًا معينًا. تعتبر هذه النقطة النهائية مفيدة بشكل خاص للتطبيقات التي تركز على تحليل الانتقالات، إدارة قوائم الفرق، أو تتبع حركات اللاعبين خلال موسم.",
        getTeamRoster: "توفر هذه الطريقة قائمة كاملة بجميع اللاعبين في قائمة فريق معين. تعتبر مثالية للتطبيقات التي تحتاج إلى عرض تشكيلات الفرق، تحليل أدوار اللاعبين، أو إدارة الوظائف المتعلقة بقائمة الفريق.",
        getTeamGames: "تسترجع هذه الطريقة قائمة بجميع المباريات التي لعبها فريق معين. تعتبر مفيدة بشكل خاص للتطبيقات التي تركز على أداء الفريق، تتبع الجداول، أو توفير وصول المستخدمين إلى السجل الكامل لمباريات فريق معين.",
        getTeamGameStats: "توفر هذه الطريقة إحصاءات تفصيلية لفريق معين في مباراة محددة. تعتبر مفيدة بشكل خاص للتطبيقات التي تركز على تحليلات المباريات، تقييم الأداء، أو تقديم تحليلات متعمقة لأداء الفريق في المباريات الفردية.",
        getTeamTransfers: "تسترجع هذه الطريقة معلومات حول صفقات الانتقال التي تشمل فريقًا معينًا. تعتبر مفيدة بشكل خاص للتطبيقات التي تركز على تحليل سوق الانتقالات، تغييرات قوائم الفرق، أو تتبع تحركات اللاعبين على مدار الوقت.",
        getGameStatus: "توفر هذه الطريقة قائمة بجميع حالات المباريات المتوفرة في واجهة برمجة التطبيقات، مثل مجدولة، قيد التنفيذ، مكتملة، مؤجلة، أو ملغاة. تعتبر مفيدة بشكل خاص للتطبيقات التي تتطلب تتبع المباريات في الوقت الفعلي، تصفية المباريات حسب الحالة، أو توفير تحديثات واضحة حول تقدم المباراة أو حالتها.",
        getPlayerPositions: "تعيد هذه الطريقة قائمة بجميع المراكز الممكنة للاعبين، مثل حارس مرمى، مدافع، لاعب وسط، ومهاجم. تعتبر مفيدة بشكل خاص للتطبيقات التي تصنف اللاعبين، تحلل بيانات المراكز، أو تسمح للمستخدمين بتصفية اللاعبين بناءً على أدوارهم في الملعب.",
        getGameDetail: "توفر هذه الطريقة معلومات شاملة حول مباراة معينة، بما في ذلك تفاصيل مثل الفرق المشاركة، التاريخ والوقت، الملعب، النتيجة، والبيانات الوصفية الأخرى. تعتبر مثالية للتطبيقات التي تحتاج إلى رؤى متعمقة حول المباريات، مما يتيح ميزات مثل معاينات المباريات التفصيلية، التقارير، أو التحليلات.",
        getGameStats: "توفر هذه الطريقة إحصاءات تفصيلية لمباراة معينة، بما في ذلك مقاييس مثل الأهداف، التسديدات، نسب الاستحواذ، التمريرات، والإجراءات الدفاعية. تعتبر مفيدة بشكل خاص للتطبيقات التي تركز على تحليل المباريات، التقارير بعد المباراة، أو التصورات الخاصة بأداء الفرق خلال المباراة.",
        getGamePlayerStats: "تسترجع هذه الطريقة إحصاءات أداء مفصلة لجميع اللاعبين الذين شاركوا في مباراة معينة. تعتبر مفيدة بشكل خاص للتطبيقات التي تحلل أداء اللاعبين الفرديين، تنشئ تقارير المباريات، أو تقارن اللاعبين في سياق مباراة واحدة.",
        getGamePlayerPhysicalStats: "توفر هذه الطريقة مقاييس تفصيلية للأداء البدني للاعبين في مباراة معينة. تعتبر مفيدة بشكل خاص للتطبيقات التي تركز على تحليل لياقة اللاعبين، تتبع الأداء البدني، أو إنشاء رؤى تفصيلية حول اللاعبين في مباراة معينة.",
        getGameTeamPhysicalStats: "توفر هذه الطريقة مقاييس تفصيلية للأداء البدني للفرق في مباراة محددة. يشمل ذلك بيانات مثل المسافة الإجمالية المقطوعة، عدد الركضات السريعة، الجري عالي الكثافة، وغيرها من السمات البدنية. هذا مفيد بشكل خاص للتطبيقات التي تركز على تحليل اللياقة البدنية للفرق، مقارنة الجهود البدنية بين الفرق، أو تقييم الأداء العام في المباراة.",
        getGamePlayerArrigoMetrics: "توفر هذه الطريقة مقاييس أريجو مفصلة للاعبين في مباراة محددة. وهي مفيدة بشكل خاص للتطبيقات التي تركز على التحليلات وتوليد رؤى مفصلة حول اللاعبين في المباراة.",
        getGameTeamArrigoMetrics: "توفر هذه الطريقة مقاييس مفصلة حول أداء الفريق في مباراة محددة. تتضمن بيانات مثل عدد اللاعبين الذين هُزموا وخصائص أخرى. وهي مفيدة بشكل خاص للتطبيقات التي تُركز على تحليل وتقييم الأداء العام للمباريات.",
        getGameLineup: "تسترجع هذه الطريقة التشكيلة الأساسية لمباراة معينة، بما في ذلك اللاعبين الأساسيين، الاحتياطيات، ومراكزهم. تعتبر مفيدة بشكل خاص للتطبيقات التي تعرض معلومات ما قبل المباراة، تحليل تشكيلات الفرق، أو تقديم رؤى حول القرارات التكتيكية التي اتخذتها الفرق في مباراة محددة.",
        getGameTimeline: "توفر هذه الطريقة قائمة زمنية بالأحداث التي وقعت خلال مباراة معينة. تعتبر مفيدة بشكل خاص للتطبيقات التي تقدم تحديثات مباشرة للمباريات، ملخصات ما بعد المباراة، أو تحليلات تفصيلية للأحداث التي جرت خلال المباراة.",
        getGameTracking: "تسترجع هذه الطريقة رابطًا لتحميل ملف بيانات التتبع لمباراة معينة. يحتوي هذا الملف على بيانات تفصيلية للحركة والموقع للاعبين والكرة خلال المباراة. تعتبر مفيدة بشكل خاص للتطبيقات التي تركز على التحليلات المتقدمة، التحليل التكتيكي، أو إنشاء تصورات لحركات اللاعبين والكرة أثناء المباراة.",
        getTrackingStatus: "تقوم هذه الطريقة بإرجاع قائمة كاملة بجميع الحالات المتاحة في التتبع، مع توفير التفاصيل الأساسية مثل المعرف الفريد واسم كل ولاية. تعتبر نقطة النهاية هذه مثالية للتطبيقات التي تتطلب تتبع المطابقة، وتمكين ميزات مثل اختيار الحالة والتصفية والتحليل. كما أنه بمثابة مورد بالغ الأهمية للتفاعل مع نقاط النهاية الأخرى التي تعتمد على معلمة statusId، مما يضمن التنقل السلس والتكامل مع مجموعة البيانات الأوسع لواجهة برمجة التطبيقات.",
        getPlayerTransfersTypes: "تسترجع هذه الطريقة قائمة بأنواع انتقالات اللاعبين الممكنة، مثل الانتقال الدائم، الإعارة، الانتقال الحر، أو التبادل. تعتبر مفيدة بشكل خاص للتطبيقات التي تحلل اتجاهات سوق الانتقالات، تصنف تحركات اللاعبين، أو توفر رؤى تفصيلية للمستخدمين حول أنواع الصفقات التي تشمل اللاعبين.",
        getPlayerDetail: "توفر هذه الطريقة معلومات تفصيلية عن لاعب معين، بما في ذلك التفاصيل الشخصية، إحصاءات المسيرة المهنية، والانتماء الحالي للفريق. تعتبر مثالية للتطبيقات التي تقدم ملفات تعريف اللاعبين، رؤى تاريخية، أو تحليلات لأداء اللاعبين ومساراتهم المهنية.",
        getPlayerGames: "تسترجع هذه الطريقة قائمة بجميع المباريات التي شارك فيها لاعب معين. تعتبر مفيدة بشكل خاص للتطبيقات التي تركز على تتبع أداء اللاعبين، تحليل تاريخ المباريات، أو توفير سجلات شاملة لمباريات اللاعبين.",
        getPlayerInjuries: "توفر هذه الطريقة سجلًا تفصيليًا للإصابات التي تعرض لها لاعب معين. تعتبر مفيدة بشكل خاص للتطبيقات التي تركز على تحليل صحة اللاعبين، تقييم تأثير الإصابات على المسيرة المهنية، أو تتبع جداول التعافي.",
        getPlayerNationalTeam: "تسترجع هذه الطريقة معلومات تفصيلية عن مشاركة لاعب معين في مباريات المنتخب الوطني. تعتبر مفيدة للتطبيقات التي تركز على أداء اللاعبين على المستوى الوطني، تتبع المسيرة الدولية، أو تقديم رؤى حول المساهمات خلال البطولات والمباريات الودية.",
        getPlayerSeasons: "توفر هذه الطريقة قائمة بجميع المواسم التي شارك فيها لاعب معين. تعتبر مفيدة بشكل خاص للتطبيقات التي تتبع تطور مسيرة اللاعب المهنية، تحليل الأداء عبر المواسم، أو تقديم سياق تاريخي لإنجازاتهم.",
        getPlayerTransfers: "تسترجع هذه الطريقة تاريخًا تفصيليًا للانتقالات التي تشمل لاعبًا معينًا. تعتبر مفيدة بشكل خاص للتطبيقات التي تركز على تحليل مسيرة اللاعب المهنية، رؤى سوق الانتقالات، أو تتبع انتقالات اللاعبين بين الفرق على مدار الزمن.",
        getPlayerSeasonTeamStats: "توفر هذه الطريقة إحصاءات أداء تفصيلية للاعب معين خلال موسم معين مع فريق معين. تعتبر مفيدة للتطبيقات التي تركز على تحليل أداء اللاعبين خلال الموسم، المقارنات بين الفرق أو المواسم، وتتبع مساهماتهم الفردية في نجاح الفريق.",
        getPlayerSeasonPhysicalStats: "توفر هذه الطريقة مقاييس تفصيلية للأداء البدني للاعب معين طوال الموسم. تعتبر مفيدة للتطبيقات التي تركز على تتبع لياقة اللاعبين، تحليل الأداء البدني، أو تقييم عبء العمل الذي يتحمله اللاعب خلال الموسم.",
        getPlayerSeasonGamePhysicalStats: "توفر هذه الطريقة مقاييس تفصيلية للأداء البدني للاعب معين في كل مباراة خلال موسم. تعتبر مفيدة للتطبيقات التي تركز على تحليل اللياقة البدنية الخاصة بالمباريات، تتبع عبء العمل للاعبين، أو مقارنة الأداء البدني عبر المباريات المختلفة.",
        getPlayerSeasonGameStats: "تسترجع هذه الطريقة إحصاءات أداء تفصيلية للاعب معين في كل مباراة خلال موسم. تعتبر مفيدة للتطبيقات التي تركز على تحليل أداء اللاعبين في المباريات الفردية، اتجاهات الأداء، أو المقارنات التفصيلية عبر المباريات خلال الموسم.",
        getCoachDetail: "توفر هذه الطريقة معلومات تفصيلية عن مدرب معين، بما في ذلك اسمه، تاريخ مسيرته، الفرق التي دربها، وإنجازاته البارزة. تعتبر مفيدة للتطبيقات التي تبرز ملفات تعريف المدربين، تتبع المسيرة المهنية للإدارة الفنية، أو تحليل تأثير المدربين على أداء الفرق.",
        getCoachHistory: "تسترجع هذه الطريقة تاريخًا شاملاً لمسيرة مدرب معين، بما في ذلك الفرق التي دربها، البطولات التي شارك فيها، ومدد عمله. تعتبر مفيدة للتطبيقات التي تركز على تحليل مسيرة المدربين المهنية، تتبع التغيرات الإدارية، أو تقديم رؤى حول المسار المهني والإنجازات للمدرب."        
      },
      responseCodes: "رموز الاستجابة",
      furtherInformation: "لمزيد من المعلومات، يرجى قراءة documentation API الخاصة بنا",
      clipboard: "تم النسخ إلى الحافظة!"
    }
  },
  globalSearch: {
    subtitle: "التصفية العميقة"
  },
  iso: {
    AF: "أفغانستان",
    DZ: "الجزائر",
    AO: "أنغولا",
    AR: "الأرجنتين",
    AU: "أستراليا",
    AZ: "أذربيجان",
    BH: "البحرين",
    BB: "بربادوس",
    BE: "بلجيكا",
    BJ: "بنين",
    BO: "بوليفيا",
    BW: "بوتسوانا",
    BN: "بروناي",
    BF: "بوركينا فاسو",
    KH: "كمبوديا",
    CA: "كندا",
    CF: "جمهورية أفريقيا الوسطى",
    CL: "شيلي",
    CO: "كولومبيا",
    CD: "الكونغو د",
    CG: "الكونغو",
    CI: "كوت ديفوار",
    CU: "كوبا",
    CZ: "الجمهورية التشيكية",
    DJ: "جيبوتي",
    DO: "جمهورية الدومينيكان",
    EC: "الاكوادور",
    SV: "السلفادور",
    ER: "إريتريا",
    ET: "أثيوبيا",
    FI: "فنلندا",
    PF: "بولينيزيا الفرنسية",
    GM: "غامبيا",
    DE: "ألمانيا",
    GI: "جبل طارق",
    GL: "الأرض الخضراء",
    GP: "جوادلوب",
    GN: "غينيا",
    GY: "غيانا",
    HN: "هندوراس",
    HU: "هنغاريا",
    IN: "الهند",
    IR: "إيران",
    IE: "أيرلندا",
    IT: "إيطاليا",
    JP: "اليابان",
    KZ: "كازاخستان",
    KI: "كيريباتي",
    KR: "كوريا، جنوب",
    KG: "قيرغيزستان",
    LV: "لاتفيا",
    LS: "ليسوتو",
    LY: "ليبيا",
    LT: "ليتوانيا",
    MO: "منطقة ماكاو الإدارية الخاصة",
    MG: "مدغشقر",
    MY: "ماليزيا",
    ML: "مالي",
    MH: "جزر مارشال",
    MR: "موريتانيا",
    MX: "المكسيك",
    MD: "مولدوفا",
    MN: "منغوليا",
    MA: "المغرب",
    MM: "ميانمار",
    NR: "ناورو",
    NL: "هولندا",
    NZ: "نيوزيلندا",
    NE: "النيجر",
    MP: "جزر مريانا الشمالية",
    OM: "سلطنة عمان",
    PW: "بالاو",
    PA: "بنما",
    PY: "باراجواي",
    PH: "فيلبيني",
    PT: "البرتغال",
    QA: "دولة قطر",
    RO: "رومانيا",
    RW: "رواندا",
    LC: "القديسة لوسيا",
    SM: "سان مارينو",
    SA: "المملكة العربية السعودية",
    RS: "صربيا",
    SL: "سيرا ليون",
    SK: "سلوفاكيا",
    SB: "جزر سليمان",
    ZA: "جنوب أفريقيا",
    LK: "سيريلانكا",
    SD: "السودان",
    SZ: "سوازيلاند",
    CH: "سويسرا",
    TW: "تايوان",
    TZ: "تنزانيا",
    TG: "توجو",
    TT: "ترينداد وتوباغو",
    TR: "تركيا",
    TV: "توفالو",
    UA: "أوكرانيا",
    GB: "المملكة المتحدة",
    UY: "أوروغواي",
    VU: "فانواتو",
    VE: "فنزويلا",
    VG: "جزر العذراء البريطانية",
    EH: "الصحراء الغربية",
    ZM: "زامبيا",
    AL: "ألبانيا",
    AD: "أندورا",
    AG: "أنتيغوا وبربودا",
    AM: "أرمينيا",
    AT: "النمسا",
    BS: "جزر البهاما",
    BD: "بنغلاديش",
    BY: "بيلاروسيا",
    BZ: "بليز",
    BT: "بوتان",
    BA: "البوسنة والهرسك.",
    BR: "البرازيل",
    BG: "بلغاريا",
    BI: "بوروندي",
    CM: "الكاميرون",
    CV: "الرأس الأخضر",
    TD: "تشاد",
    CN: "الصين",
    KM: "جزر القمر",
    CR: "كوستا ريكا",
    HR: "كرواتيا",
    CY: "قبرص",
    DK: "الدنمارك",
    DM: "دومينيكا",
    TL: "تيمور الشرقية",
    EG: "مصر",
    GQ: "غينيا الإستوائية",
    EE: "إستونيا",
    FJ: "فيجي",
    FR: "فرنسا",
    GA: "الجابون",
    GE: "جورجيا",
    GH: "غانا",
    GR: "اليونان",
    GD: "غرينادا",
    GT: "غواتيمالا",
    GW: "غينيا بيساو",
    HT: "هايتي",
    HK: "منطقة هونغ كونغ الإدارية الخاصة",
    IS: "أيسلندا",
    ID: "إندونيسيا",
    IQ: "العراق",
    IL: "",
    JM: "جامايكا",
    JO: "الأردن",
    KE: "كينيا",
    KP: "كوريا الشمالية",
    KW: "الكويت",
    LA: "لاوس",
    LB: "لبنان",
    LR: "ليبيريا",
    LI: "ليختنشتاين",
    LU: "لوكسمبورغ",
    MK: "مقدونيا",
    MW: "ملاوي",
    MV: "جزر المالديف",
    MT: "مالطا",
    MQ: "مارتينيكا",
    MU: "موريشيوس",
    FM: "ميكرونيزيا",
    MC: "موناكو",
    ME: "الجبل الأسود",
    MZ: "موزمبيق",
    NA: "ناميبيا",
    NP: "نيبال",
    NC: "كاليدونيا الجديدة",
    NI: "نيكاراغوا",
    NG: "نيجيريا",
    NO: "النرويج",
    PK: "باكستان",
    PS: "فلسطين",
    PG: "بابوا غينيا الجديدة",
    PE: "بيرو",
    PL: "بولندا",
    PR: "بورتوريكو",
    RE: "جزر ريونيون",
    RU: "روسيا",
    KN: "سانت كيتس ونيفيس",
    WS: "ساموا",
    ST: "ساو تومي وبرينك.",
    SN: "السنغال",
    SC: "سيشيل",
    SG: "سنغافورة",
    SI: "سلوفينيا",
    SO: "الصومال",
    ES: "إسبانيا",
    VC: "سانت فنسنت وجرينادا",
    SR: "سورينام",
    SE: "السويد",
    SY: "سوريا",
    TJ: "طاجيكستان",
    TH: "تايلانديا",
    TO: "تونغا",
    TN: "تونس",
    TM: "تركمانستان",
    UG: "أوغندا",
    AE: "الإمارات العربية المتحدة",
    US: "الولايات المتحدة",
    UZ: "أوزبكستان",
    VA: "مدينة الفاتيكان",
    VN: "فيتنام",
    VI: "جزر فيرجن الأمريكية",
    YE: "اليمن",
    ZW: "زيمبابوي",
    EU: "أوروبا",
    INT: "دولي",
    CW: "كوراساو",
    AFC: "الاتحاد الآسيوي",
    CONCACAF: "اتحاد أمريكا الشمالية و الكراييب",
    "GB-ENG": "إنكلترا",
    "GB-WLS": "ويلز",
    "GB-SCT": "اسكتلندا",
    LATAM: "أمريكا الجنوبية",
    CAF: "الاتحاد الافريقي",
    XK: "كوسوفو",
    AI: "أنغيلا",
    AN: "جزر الأنتيل الهولندية",
    AS: "ساموا الأمريكية",
    AW: "أروبا",
    BM: "برمودا",
    BQ: "بونير، SE وسابا",
    CK: "جزر كوك",
    FO: "جزر فارو",
    GF: "جويان",
    GG: "بيليويك غيرنسي",
    GU: "إقليم غوام",
    IM: "جزيرة المان",
    JE: "بيليويك جيرسي",
    KY: "جزر كايمان",
    MF: "جماعة سان مارتن",
    MS: "مونتسيرات",
    NU: "نيوي",
    OC: "أوقيانوسيا",
    RI: "إندونيسيا",
    SS: "جمهورية جنوب السودان",
    TC: "جزر تركس وكايكوس",
    YT: "قسم مايوت",
    SX: "سينت مارتن"
  },
  loadingMessages: {
    players: "إعداد اللاعبين",
    teams: "ترتيب الفرق",
    games: "جلب المباريات",
    stats: "حساب المقاييس",
    graphs: "الرسوم البيانية",
    gettingReady: "الاحماء",
    placeholder: "إستعد"
  },
  requestReport: {
    subtitle: "احصل على تقرير عميق بكل ما تحتاجه",
    categories: {
      scouting: {
        title: "الكشافة",
        subtitle: "من هم أفضل اللاعبين في دوري معين؟ ومن عدة بطولات مجتمعة؟ اطلب تقريرًا مخصصًا باستخدام أي فلتر تريده (العمر، الطول، نهاية العقد، إلخ.) واكتشف اللاعبين المناسبين بشكل أفضل"
      },
      coaches: {
        title: "المدربين",
        subtitle: "كيف يتناسب المدرب مع نظام فريقك؟ احصل على معلومات تفصيلية أو، من خلال ملف تعريف معين، تعرف على المدربين المناسبين بشكل أفضل"
      },
      "team analysis": {
        title: "فريق",
        subtitle: "حدد فريقًا واحصل على ملخص الموسم الذي يحتوي على مغلومات قيّمة حول الأسلوب والأداء الدفاعي والهجومي ونقاط الضعف وأفضل اللاعبين وما إلى ذلك..."
      },
      "game analysis": {
        title: "تحليل المباراة",
        subtitle: "في حالة المباراة، احصل على تحليل عميق قبل المباراة وبعدها مع معلومات مفصلة"
      },
      "special projects": {
        title: "مشاريع خاصة",
        subtitle: "كيف يؤدي اللاعب في المباريات الخارجية؟ كيف يتغير اللاعبون من دوري إلى دوري؟ من هم اللاعبون المتاحون للإعارة؟ اسأل أي شيء يمكنك التفكير فيه"
      },
      conversation: {
        title: "محادثة",
        subtitle: "ابدأ محادثة مع فريقنا"
      }
    },
    notesPlaceholder: "أخبرنا بالدوري أو الملف الشخصي أو الإحصائيات أو المدرب أو الفريق أو اللعبة التي تريد معرفة المزيد عنها",
    chooseType: "حدد نوع التقرير",
    requestSummary: "ملخص الطلب",
    reportType: "نوع التقرير",
    reportLanguage: "لغة التقرير"
  },
  bugReport: {
    modalSubtitle: "ساعدنا على التحسن",
    about: "عن",
    sendSuccess: "تم الإشعاراع   بنجاح. تحقق من التحديثات في البريد الوارد",
    bugs: "أخطاء"
  },
  gbe: {
    autopass: "المرور التلقائي",
    bandX: "النطاق {0}",
    bandXCont: "المنافسة القارية للفرقة {0}.",
    points: "نقاط",
    titleWinner: "الفائز باللقب",
    qualifiedGroupsBandX: "تأهل لمرحلة المجموعات في المنافسة القارية لفرقة {0}.",
    qualifiedQualifiersBandX: "مؤهل لتصفيات مسابقة Band {0} القارية",
    midTable: "منتصف الجدول",
    relegation: "الهبوط",
    promotion: "صعود",
    final: "النهائي",
    semifinal: "نصف النهائي",
    quarterfinal: "الدور ربع النهائي",
    round16: "دور الـ16",
    round32: "دور الـ32",
    groupstage: "مرحلة المجموعات",
    firstRound: "الجولة الأولى",
    secondRound: "الجولة الثانية",
    thirdRound: "الجولة الثالثة",
    fourthRound: "الجولة الرابعة",
    preliminaryRound: "الدور التمهيدي",
    other: "آخر",
    score: "نتيجة",
    totalSummary: "ملخص إجمالي",
    currentlyPlayingInUK: "اللاعب مواطن في المملكة المتحدة أو أيرلندا، أو  اللاعب مقيم دائم في المملكة المتحدة",
    bandsAlert: "هناك دقائق لعب في أكثر من نطاق، المجموع هو القيمة القصوى",
    bandsAlertMax: "هناك دقائق لعبت في أكثر من نطاق، المجموع هو القيمة القصوى",
    bandsAlertAvg: "هناك دقائق لعب في أكثر من نطاق، المجموع هو متوسط ​​القيمة  ",
    generate: "نموذج تطبيق GBE",
    debutYouthPlayer: "الظهور الأول للاعب الشباب",
    table1: {
      name: "المشاركات الدولية للاعب",
      title1: "التصنيف العالمي المجمع للاعبي الفيفا",
      title2: "المشاركات الدولية للاعب"
    },
    table2: {
      name: "الدقائق المحلية للاعب",
      title1: "الدقائق المحلية للاعب"
    },
    table3: {
      name: "الدقائق القارية للاعب",
      title1: "الدقائق القارية للاعب"
    },
    table4: {
      name: "المركز النهائي في الدوري لأخر نادي للاعب",
      title1: "أخر مركز للنادي في الدوري"
    },
    table5: {
      name: "التقدم القاري لأخر نادي للاعب",
      title1: "التقدم القاري"
    },
    table6: {
      name: "جودة الدوري للنادي الحالي للاعب",
      title1: "فرقة النادي الحالي للاعب"
    },
    table7: {
      name: "الشباب - لاول مرة",
      title1: "فرقة"
    },
    table8: {
      name: "الشباب - المركز النهائي في الدوري",
      title1: "أخر مركز للنادي في الدوري"
    },
    table9: {
      name: "الشباب - التقدم القاري",
      title1: "التقدم القاري"
    },
    table10: {
      name: "الشباب - جودة الدوري للاعب الحالي",
      title1: "فرقة النادي الحالي للاعب"
    },
    table11: {
      name: "الشباب - جودة الدوري للاعب الحالي",
      title1: "فرقة النادي الحالي للاعب"
    },
    table12: {
      name: "الشباب - مشاركات دولية",
      title1: "المشاركات الدولية للاعب"
    }
  },
  mediaMode: {
    borderColor: "لون الحدود",
    fillColor: "لون التعبئة",
    bgColor: "لون الخلفية",
    upperText: "النص العلوي",
    lowerText: "النص السفلي",
    socialMedia: "وسائل التواصل الاجتماعي",
    textColor: "لون الخط",
    axisColor: "لون المحور",
    logo: "شعار",
    comparisonBorderColor: "لون حدود المقارنة",
    comparisonFillColor: "لون تعبئة المقارنة",
    comparisonUpperText: "مقارنة النص العلوي",
    comparisonLowerText: "مقارنة النص السفلي",
    homeFillColor: "لون تعبئة الصفحة الرئيسية",
    homeBorderColor: "لون الحدود الرئيسية",
    awayFillColor: "لون التعبئة للضيف",
    awayBorderColor: "لون الحدود  للضيف",
    face: "وجه",
    nationalTeam: "الفريق الوطني",
    comparisonFace: "وجه المقارنة",
    upperTextX: "النص العلوي {0}",
    lowerTextX: "النص السفلي {0}",
    borderColorX: "لون الحدود {0}",
    fillColorX: "لون التعبئة {0}",
    homeFillColorX: "لون التعبئة (الصفحة الرئيسية) {0}",
    homeBorderColorX: "لون الحدود (الصفحة الرئيسية) {0}",
    awayFillColorX: "لون التعبئة (بعيدًا) {0}",
    awayBorderColorX: "لون الحدود (للضيف) {0}",
    faceX: "الوجه {0}",
    selectField: "اختر خاصية",
    orientationX: "الاتجاه {0}",
    searchBarPlaceholder: "البحث عن اللاعبين و/أو المباريات...",
    title: "لوحة وسائل الإعلام",
    chooseChart: "اختر الرسم البياني...",
    headerTextX: "نص الرأس {0}",
    avatarLineLength: "طول خط الصورة الرمزية",
    avatarLineWeight: "وزن خط الصورة الرمزية",
    avatarSize: "حجم الصورة الرمزية",
    chartX: "الرسم البياني {0}",
    chartHeaderFontSize: "حجم خط رأس المخططات",
    chartHeaderFontWeight: "وزن خط رأس المخططات",
    upperTextFontSize: "حجم خط النص العلوي",
    upperTextFontWeight: "وزن خط النص العلوي",
    lowerTextFontSize: "حجم خط النص السفلي",
    lowerTextFontWeight: "وزن خط النص السفلي",
    socialMediaFontSize: "حجم خط الوسائط الاجتماعية",
    socialMediaFontWeight: "وزن خط الوسائط الاجتماعية",
    subtitle: "الترجمة",
    subtitleFontSize: "حجم خط الترجمة",
    subtitleFontWeight: "وزن خط الترجمة",
    subtitleX: "العنوان الفرعي {0}",
    subtitleFontSizeX: "الترجمة ${0} حجم الخط",
    subtitleFontWeightX: "عنوان فرعي ${0} وزن الخط",
    titleX: "العنوان {0}",
    titleFontSize: "حجم خط العنوان",
    titleFontWeight: "وزن خط العنوان",
    sponsor: "راعي"
  },
  documents: {
    types: {
      SCOUTING_REPORT: "التقارير الكشفية",
      GAME_REPORT: "تقارير المباراة",
      MEDICAL_REPORT: "التقارير الطبية",
      PHYSICAL_REPORT: "التقارير المادية",
      PSYCHOLOGICAL_REPORT: "التقارير النفسية",
      OTHER: "آخرون",
      QUICK_NOTES: "ملاحظات سريعة",
      PLAYER_REPORT: "تقارير اللاعب",
      GENERAL_COMMENTS: "التعليقات العامة",
      PLAYER_ANALYSIS: "تحليل اللاعب"
    },
    uploadDocument: "تحميل الوثيقة",
    notesPlaceholder: "اكتب ملاحظات أو تعليقات وصفية تتعلق بالمستند",
    notesPlaceholderAlt: "اكتب ملاحظات أو تعليقات وصفية تتعلق باللاعب",
    uploadedBy: "تم الرفع بواسطة",
    updatedBy: "تم التحديث بواسطة",
    seeNotes: "انظر إلى الملاحظات",
    addNote: "اضف ملاحظة",
    rating: "تقييم",
    position: "أفضل مركز",
    physical: "بدني",
    onBall: "على الكرة",
    offBall: "خارج الكرة",
    mental: "عقلي",
    potential: "محتمل",
    conclusion: "خاتمة",
    recommendation: {
      1: "وقّع",
      2: "راقب",
      3: "اخرج",
      label: "توصية",
      4: "مثير للاهتمام"
    },
    match: "مباراة",
    deleteQuickNote: "حذف الملاحظة",
    deleteQuickNoteMessage: "سيتم حذف الملاحظة نهائيًا. هل أنت متأكد؟",
    noQuickNotes: "لا توجد بيانات. ابدأ بإضافة بعض الملاحظات!",
    deleteDocument: "حذف الوثيقة",
    deleteDocumentMessage: "سيتم حذف الوثيقة نهائيًا. هل أنت متأكد؟",
    noDocuments: "لا توجد بيانات. ابدأ بإضافة بعض الوثائق!"
  },
  notifications: {
    newReportMessage: "توجد رسالة جديدة في التقرير"
  },
  blog: {
    subtitle: "أحدث المقالات والتحديثات والأخبار",
    newEntry: "دخول جديد",
    title: "عنوان",
    text: "نص",
    link: "وصلة",
    image: "صورة",
    author: "مؤلف",
    date: "موعد الإصدار",
    deleteEntry: "حذف المدخلات",
    deleteEntryMessage: "هل أنت متأكد أنك تريد حذف هذا الإدخال؟"
  },
  positionsOrlegi: {
    GK: "حارس مرمى",
    DC: "مدافع",
    DR: "الظهير",
    MC: "لاعب خط وسط",
    AMC: "لاعب وسط هوجومي",
    FW: "إلى الأمام",
    FWR: "الجناح"
  },
  library: {
    mediaSubtitle: "عرض ومشاركة المخططات المصدرة",
    subtitle: "عرض ومشاركة المستندات التي تم تحميلها",
    charts: "الرسوم البيانية",
    goToLibrary: "اذهب إلى المكتبة"
  },
  scatterPlot: {
    bubbleSize: "حجم الفقاعة",
    byMinutes: "بالدقائق",
    byAge: "حسب العمر",
    byMarketValue: "حسب القيمة السوقية"
  },
  eventChart: {
    successfulEvent: "حدث ناجح",
    unsuccessfulEvent: "حدث غير ناجح",
    successfulPass: "تمريرة ناجحة",
    unsuccessfulPass: "تمريرة غير ناجحة",
    successfulCarry: "حمل ناجح",
    unsuccessfulCarry: "حمل غير ناجح",
    carryAndKeyPass: "حمل و تمريرة مفتاحية",
    carryAndAssist: "حمل و تمريرة حاسمة",
    carryAndShot: "حمل و تسديدة",
    ballProgressionAndPass: "تقدم الكرة و التمريرة",
    ballProgression: "تقدم الكرة",
    ballProgressionAndKeyPass: "تقدم الكرة و تمريرة مفتاحية",
    ballProgressionAndAssist: "تقدم الكرة و  تمريرة حاسمة",
    ballProgressionAndShot: "تقدم الكرة و  تسديدة",
    ballProgressionAndGoal: "تقدم الكرة و هدف",
    pass: "تمريرة",
    carryAndPass: "حمل و تمرير",
    carryAndGoal: "حمل و هدف",
    totalTouches: "إجمالي اللمسات",
    successful: "ناجح",
    unsuccessful: "غير ناجح"
  },
  event: {
    Pass: "تمريرة",
    TakeOn: "مراوغة",
    Takeon: "مراوغة",
    Foul: "خطأ",
    Tackle: "تدخل",
    Interception: "اعتراض",
    Clearance: "تشتيت ",
    MissedShot: "تسديدة ضائعة",
    ShotOnPost: "تسديدة على القائم",
    SavedShot: "تسديدة تم التصدى لها",
    Goal: "هدف",
    Aerial: "هوائي",
    Error: "خطأ",
    BallRecovery: "استعادة الكرة",
    Dispossessed: "افتكاك الكرة",
    ChanceMissed: "فرصة ضائعة",
    BallTouch: "لمسة الكرة",
    BlockedPass: "تمريرة تم منعها",
    Challenge: "تحدي",
    lossPossession: "فقدان الاستحواذ",
    "Ball touch": "لمسة الكرة",
    Smother: "خنق",
    "Keeper pickup": "مسك الكرة من قبل الحارس",
    "Good skill": "مهارة جيدة",
    Punch: "لكمة",
    "Saved shot": "تسديدة تم التصدى لها",
    "Shot on post": "تسديدة في القائم",
    "Missed shot": "تسديدة ضائعة",
    Save: "تصدي",
    "Take on": "مراوغة",
    "Offside pass": "تمريرة الى التسلل",
    Claim: "مطالبة",
    "Blocked pass": "تمريرة تم منعها "
  },
  leagueTab: {
    leagueTable: "جدول الدوري",
    matchdays: "الجولات",
    playerInsights: "معلومات اللاعب",
    teamInsights: "معلومات الفريق",
    head2head: "وجها لوجه",
    addNewChart: "إضافة رسم بياني جديد",
    rounds: {
      16: "دور الـ16",
      32: "دور الـ32",
      W: "الفائز",
      F: "النهائي",
      SF: "نصف النهائي",
      QF: "الدور ربع النهائي",
      GR: "مرحلة المجموعات",
      "4R": "الجولة الرابعة",
      "3R": "الجولة الثالثة",
      "2R": "الجولة الثانية",
      "1R": "الجولة الأولى",
      PR: "الدور التمهيدي",
      QPO1: "قم بإجراء جولة من 32 مستوى أدناه",
      QPO2: "تصفيات دور الـ16"
    },
    prediction: "التنبؤات",
    predicted: "تنبؤ",
    groups: "مجموعات",
    ranking: "تصنيف",
    positions: "المراكز",
    numberOfTeams: "عدد الفرق",
    statsWithMinimum: {
      message: "عرض اللاعبين الذين لديهم أكثر من {0} {1} في الموسم المحدد فقط",
      dribblesTotal90: "مراوغات لكل 90 دقيقة",
      crosses90: "عرضيات لكل 90 دقيقة",
      tacklesAttempted90: "محاولات افتكاك لكل 90 دقيقة",
      aerialsTotal90: "التحامات هوائية لكل 90 دقيقة"
    }    
  },
  similarity: {
    subtitle: "العثور على لاعبين مماثلين",
    searchBarPlaceholder: "مرجع: ابحث عن لاعب واختره للعثور على لاعب مماثل",
    radarFilters: "مرشحات الرادار",
    similarityFilters: "مرشحات التشابه",
    playersFilters: "مرشحات اللاعبين",
    similarPlayers: "لاعبين مشابهين",
    seasonWarning: "المواسم المتوفرة فقط على أداة التشابه والتي لعب فيها اللاعب أكثر من 450 دقيقة"
  },
  squadBuilder: {
    subtitle: "ارسم تشكيلات فريدة من نوعها",
    playerSelector: "محدد اللاعب",
    loadSquad: "تحميل الفرقة",
    yearsOld: "سنة",
    playersPerPosition: "اللاعبين لكل مركز",
    custom: "مخصص",
    removeSquad: "حذف الفرقة",
    removeSquadMessage: "هل أنت متأكد أنك تريد حذف الفرقة؟",
    deleteSquadSuccess: "تم حذف الفرقة بنجاح",
    playerDetails: "إظهار التفاصيل",
    ageFormat: "تنسيق العمر",
    mainPlayer: "اللاعب الرئيسي",
    showDetails: "عرض التفاصيل",
    all: "الكل",
    squadPosition: "المركز في القائمة",
    noData: "لا توجد بيانات. ابدأ بإضافة بعض اللاعبين إلى الملعب!",
  },
  tours: {
    buttons: {
      dontShowAgain: "لا تظهر مرة أخرى",
      skipTour: " تخطى الجولة الإرشادية",
      previous: "سابق",
      next: "التالي",
      finish: "ينهي"
    },
    playerRadar: {
      step1: {
        title: "الملف الشخصي",
        message: "تحقق من بيانات اللاعب الأساسية: العمر أو الطول أو تاريخ العقد"
      },
      step2: {
        title: "مرشح GBE",
        message: "وظيفة تسمح لك بمعرفة ما إذا كان لدى اللاعب ما يكفي من نقاط GBE للعب في المملكة المتحدة"
      },
      step3: {
        title: "التوفر",
        message: "نسبة الدقائق المتاحة ونسبة الدقائق التي لعبها"
      },
      step4: {
        title: "المراكز",
        message: "تعرف على المراكز التي لعب فيها اللاعب وعدد الدقائق التي لعبها في كل مركز"
      },
      step5: {
        title: "تنسيقات العرض",
        message: "قم بقياس الأداء من خلال 4 تصورات مختلفة، الرادار، القطبي، المصاصة والنص، لمقارنته مع اللاعبين في مركزه"
      },
      step6: {
        title: "رادار الأداء",
        message: "هنا ينعكس الأداء بصريا. اللوحة تفاعلية، ويمكنك المرور فوق كل مقياس والحصول على تعريفه"
      },
      step7: {
        title: "اختيار الموسم",
        message: "حدد أو أضف مواسم لقياس أدائك"
      },
      step8: {
        title: "اختيار قالب مخصص",
        message: "استخدم القوالب المخصصة التي قمت بإنشائها لقياس اللاعب بمقاييس مختلفة عن الرادار القياسي"
      },
      step9: {
        title: "اختيار المراكز التي تم لعبها",
        message: "قم بتحديد وإلغاء تحديد المواضع المختلفة لقياسه في الوضع الذي تريد قياسه فيه"
      },
      step10: {
        title: "اختيار الحد الأدنى والحد الأقصى",
        message: "قم بتقييم اللاعب بالارتفاعات والانخفاضات في موسمه، من الدوريات الخمس الكبرى أو الموسم الخاص والافتراضي من حساب المستخدم"
      },
      step11: {
        title: "مقارنات",
        message: "يقارن أداء اللاعب مع أدائه السابق، مع لاعبين آخرين في مركزه، مع متوسط ​​المركز"
      },
      step12: {
        title: "وضعيات تنزيل الصور",
        message: "مرجع : تتوفر ثلاثة تنسيقات للتنزيل: png وsvg و embed"
      }
    },
    playerRanking: {
      step1: {
        title: "الموسم والتشكيلة والمركز",
        message: "حدد الموسم والفريق والمركز الذي تريد مقارنة اللاعب به"
      },
      step2: {
        title: "المرشحات الأساسية",
        message: "تصفية اللاعبين حسب العمر أو عدد دقائق اللعب أو الطول"
      },
      step3: {
        title: "تسليط الضوء والاستبعاد",
        message: "قم بتمييز اللاعبين الذين تريدهم واستبعاد الفرق من الشاشة"
      },
      step4: {
        title: "تصفية حسب الفئة",
        message: "قم بتصفية الإحصائيات حسب الفئة: الاتحاد، الدفاع، التمرير، التعامل مع الكرة، إلخ"
      },
      step5: {
        title: "تنسيقات تنزيل الصور",
        message: " مرجع : تتوفر ثلاثة تنسيقات للتنزيل: png وsvg و embed  "
      }
    },
    playerFinishing: {
      step1: {
        title: "اختر العرض",
        message: "يمكنك رؤية خريطة النهاية في العرض الرئيسي وعرض الهدف وفي جدول التوزيع"
      },
      step2: {
        title: "حدد المواسم",
        message: "أضف مواسمًا لقياس كفاءة التسديد لديك"
      },
      step3: {
        title: "موقع التسديد",
        message: "تحديد إمكانية رؤية الموقع الدقيق للتسديدة (الدوائر) أو حسب مناطق الصندوق والملعب (المناطق)"
      },
      step4: {
        title: "xG على الهدف",
        message: "حدد مربعي xG إلى الهدف وإكمال xG لمعرفة القيمة المضافة التي أضافها اللاعب بعد التسديدة"
      },
      step5: {
        title: "نوع التسديدة",
        message: "قم بالتصفية حسب نوع التسديدة أو الإستراتيجية أو المنطقة أو جزء من الجسم "
      },
      step6: {
        title: "تصفية دقائق",
        message: "شريط الدقائق لاختيار التسديدات والأهداف المسجلة خلال فترات لعب محددة"
      },
      step7: {
        title: "تنسيقات تنزيل الصور",
        message: " مرجع : تتوفر ثلاثة تنسيقات للتنزيل: png وsvg و embed "
      },
      step8: {
        title: "خريطة التسديد",
        message: " مرجع: الخريطة تفاعلية. تحقق من كل دائرة بالفئرة لمعرفة xG لكل تسديدة"
      }
    },
    playerKeyPass: {
      step1: {
        title: "اختيار الموسم",
        message: "أضف مواسمًا لقياس كفاءة التسديد لديك "
      },
      step2: {
        title: "موقع التمريرة المفتاحية",
        message: "تحديد إمكانية عرض الموقع الدقيق للتمريرة المفتاحية (الدائرة) أو حسب مناطق المنطقة والميدان (المناطق)"
      },
      step3: {
        title: "نوع الانهاء بعد  التمريرة المفتاحية ",
        message: "قم بالتصفية حسب نوع التسديدة أو الإستراتيجية أو المنطقة أو جزء الجسم الذي تم إجراؤها به بعد التمريرة المفتاحية  "
      },
      step4: {
        title: "تصفية  الدقائق",
        message: "شريط الدقائق لاختيار التسديدات والأهداف المسجلة خلال فترات لعب محددة"
      },
      step5: {
        title: "تنسيقات تنزيل الصور",
        message: "تتوفر ثلاثة تنسيقات للتنزيل: png وsvg وإدراج"
      },
      step6: {
        title: "خريطة التمريرات المفتاحية",
        message: "مرجع: الخريطة تفاعلية. استشر كل دائرة بالماوس لمعرفة xA لكل تمريرة"
      }
    },
    playerThreat: {
      step1: {
        title: "اختيار الموسم",
        message: "أضف مواسمًا لقياس كفاءة التصويب لديك"
      },
      step2: {
        title: "موقع التهديد",
        message: "حدد إمكانية عرض الموقع الدقيق للتمريرة المفتاحية (الدائرة) أو حسب المنطقة ومناطق المجال (المناطق) "
      },
      step3: {
        title: "العمل والإكمال",
        message: "قم بالتأشير وإلغاء التحديد وفقًا لنوع الإجراء والإكمال الذي تريد عرضه على الخريطة"
      },
      step4: {
        title: "دقائق وتهديد",
        message: "قم بالتصفية حسب الفترة والدقائق وقيمة التهديد للإجراءات"
      },
      step5: {
        title: "تنسيقات تنزيل الصور",
        message: "مرجع : تتوفر ثلاثة تنسيقات للتنزيل: png وsvg و embed"
      },
      step6: {
        title: "خريطة التهديد",
        message: "الخريطة تفاعلية. استشر كل دائرة بالماوس لمعرفة التهديد الناتج في كل لعبة xT لكل تمريرة"
      }
    },
    playerTouches: {
      step1: {
        title: "اختيار اللعبة والحدث",
        message: "حدد اللعبة والأحداث التي تريد عرضها على الخريطة"
      },
      step2: {
        title: "نوع الحدث",
        message: "قم بالتدقيق وإلغاء التحديد وفقًا للطبيعة الدفاعية أو الهجومية لحدث اللاعب طوال المباراة"
      },
      step3: {
        title: "مرشح العرض",
        message: "قم بتصفية الخريطة حسب الإجراءات الأساسية أو الخريطة الحرارية أو الدوائر أو المربعات"
      },
      step4: {
        title: "تنسيقات تنزيل الصور",
        message: "مرجع : تتوفر ثلاثة تنسيقات للتنزيل: png وsvg و embed "
      },
      step5: {
        title: "خريطة اللمسات",
        message: "الخريطة تفاعلية. يمكنك عرض كل حدث من خلال النقر على كل حدث"
      }
    },
    playerAllGames: {
      step1: {
        title: "التوفر",
        message: "تحقق من التوفر ودقائق اللعب على أساس كل مباراة على حدة"
      },
      step2: {
        title: "المراكز",
        message: "راجع المراكز التي لعب فيها في كل مباراة"
      }
    },
    playerInjuries: {
      step1: {
        title: "التاريخ والأيام المفقودة",
        message: "راجع إصابات العام الماضي أو التاريخ الكامل للإصابات ونطاقها حسب مدتها بالأيام"
      },
      step2: {
        title: "الإصابات حسب النادي",
        message: "راجع الإصابات المفصولة حسب الموسم و/أو النادي في مساره"
      }
    },
    playerInfo: {
      step1: {
        title: "المسيرة و الانتقالات",
        message: "يمكنك الاطلاع على الدقائق أو المركز أو تاريخ التوفر مع ناديه ومنتخبه الوطني وانتقالات اللاعب طوال حياته المهنية"
      }
    },
    teamOverview: {
      step1: {
        title: "ورقة الفريق",
        message: "راجع البيانات الأساسية للفريق: متوسط ​​العمر، التشكيل الأساسي، ELO أو رصيد الانتقالات"
      },
      step2: {
        title: "الإحصائيات الأساسية",
        message: "استشر االاستحواد أو xG أو التسديدات أو PPDA أو العمودية"
      },
      step3: {
        title: "الرادار والموسم",
        message: "حدد الرادار والموسم والمباريات على أرضه أو خارجه لقياس أداء الفريق"
      },
      step4: {
        title: "تصفية حسب المدرب والمباريات",
        message: "تحديد الأداء حسب المرحلة لكل مدرب"
      },
      step5: {
        title: "رادار الأداء",
        message: "اللوحة تفاعلية، ويمكنك المرور فوق كل مقياس والحصول على تعريفه"
      },
      step6: {
        title: "تنسيقات تنزيل الصور",
        message: "يتوفر تنسيقان للتنزيل: png وsvg"
      },
      step7: {
        title: "تقويم",
        message: "عرض جدول مباريات الفريق"
      },
      step8: {
        title: "أفضل اللاعبين حسب المقاييس",
        message: "في هذه اللوحة، يمكنك تحديد مقاييس مختلفة ومعرفة اللاعبين الأكثر أهمية"
      },
      step9: {
        title: "المباراة القادمة والإصابات",
        message: "تحقق من الخصم التالي ولاعبي الفريق المصابين والموقوفين"
      },
      step10: {
        title: "الرسوم البيانية والاتجاهات",
        message: "عرض الرسوم البيانية المختلفة لآخر 10 أو 20 مباراة"
      }
    },
    teamRoster: {
      step1: {
        title: "نوع العرض",
        message: "عرض الفريق من 6 فئات مختلفة: حسب المنصب، نهاية العقد، العمر، التوفر، ملف تعريف العمر والملعب"
      }
    },
    teamLoans: {
      step1: {
        title: "اللاعبون المعارون",
        message: "شاهد اللاعبين المعارين لفرق أخرى والمركز الذي يلعبون فيه"
      }
    },
    teamBeeswarm: {
      step1: {
        title: "الموسم والفرقة",
        message: "قم بالتصفية حسب الموسم وفرقة الرادار وقارن مع الدوريات التي تختارها"
      },
      step2: {
        title: "الأداء حسب المقاييس",
        message: "تعرف على مكان وجود الفريق في كل مقياس مقارنة بجميع الفرق في الدوريات المحددة مسبقًا"
      },
      step3: {
        title: "تنسيقات تنزيل الصور",
        message: "مرجع : تتوفر ثلاثة تنسيقات للتنزيل: png وsvg و embed  "
      }
    },
    teamFinishingMap: {
      step1: {
        title: "اختيار الموسم",
        message: "أضف مواسم لقياس كفاءة التصويب"
      },
      step2: {
        title: "الانهاء الخاص أو انهاء الخصم",
        message: "اختر ما إذا كنت تريد رؤية الخريطة الكاملة للفريق أو لجميع خصومه"
      },
      step3: {
        title: "موضع التسديدة",
        message: "حدد الطريقة التي تريد بها رؤية تسديدات الفريق، حسب الدوائر أو حسب المناطق (الصناديق)"
      },
      step4: {
        title: "نوع التسديدة",
        message: "قم بالتصفية حسب نوع اللقطة أو الإستراتيجية أو المنطقة أو جزء من الجسم"
      },
      step5: {
        title: "تصفية  الدقائق",
        message: "شريط الدقائق لاختيار التسديدات والأهداف المسجلة خلال فترات المباراة المحددة "
      },
      step6: {
        title: "تنسيقات تنزيل الصور",
        message: "تتوفر ثلاثة تنسيقات للتنزيل: png وsvg و embed  "
      },
      step7: {
        title: "خريطة التسديدات",
        message: "الخريطة تفاعلية. تحقق من كل دائرة بالماوس لمعرفة xG لكل تسديدة"
      }
    },
    teamKeyPassMap: {
      step1: {
        title: "اختيار الموسم",
        message: "أضف مواسم لقياس كفاءة التسديد"
      },
      step2: {
        title: "التمريرات التمريرات المفتاحية الخاصة أو المنافسة",
        message: "اختر ما إذا كنت تريد رؤية خريطة التمريرات المفتاحية للفريق أو جميع منافسيه  "
      },
      step3: {
        title: "موقع التمريرات المفتاحية",
        message: "حدد ما إذا كنت تريد رؤية الموقع الدقيق لتمريرة المفتاحية (الدائرة) أو حسب المنطقة والمجال (المربعات"
      },
      step4: {
        title: "نوع الانهاء بعد التمرير",
        message: "قم بالتصفية حسب نوع التسديدة أو الإستراتيجية أو المنطقة أو جزء الجسم الذي تم إجراؤه بعد تمريرة المفتاح"
      },
      step5: {
        title: "دقائق التصفية",
        message: "شريط الدقائق لاختيار التسديدات والأهداف المسجلة خلال فترات المباراة المحددة"
      },
      step6: {
        title: "تنسيقات تنزيل الصور",
        message: "تتوفر ثلاثة تنسيقات للتنزيل: png وsvg و embed "
      },
      step7: {
        title: "خريطة التسديدات",
        message: "الخريطة تفاعلية. استشر كل دائرة بالماوس لمعرفة xA لكل تمريرة"
      }
    },
    teamLatestGames: {
      step1: {
        title: "أحدث المباريات",
        message: "اطلع على النتائج والاستحواذ وxG و نسبة الفوز  من جميع مباريات الفريق"
      }
    },
    teamTransfers: {
      step1: {
        title: "الوصول",
        message: "ااطلع على جميع الوافدين (المشتريات + الانتقالات) لكل سنة تقويمية  "
      },
      step2: {
        title: "المغادرة",
        message: "راجع جميع  المغادرين (المبيعات + الانتقالات) حسب السنة التقويمية"
      }
    },
    teamAnalysis: {
      step1: {
        title: "اتجاهات",
        message: "أطلب وضع الفريق من خلال الخطوط، والانتصارات، والشباك النظيفة، والعودة، والفترات مع الأهداف أو أنواع الأهداف"
      },
      step2: {
        title: "الركلات الثابتة",
        message: "قارن أداء الفريق بين الكرات الثابتة واللعبات المفتوحة واحصل على نظرة عامة تفصيلية عن الكرات الثابتة"
      },
      step3: {
        title: "التبديلات ",
        message: "تعرف على الوقت الذي يقوم فيه الفريق بإجراء التبديلات وأي اللاعبين يتم استبدالهم أكثر من غيرهم"
      },
      step4: {
        title: "روابط",
        message: "راجع الروابط الأكثر شيوعًا بين اللاعبين. تصفية حسب الموسم ونوع اللعب"
      },
      step5: {
        title: "مناطق الهجوم",
        message: "اكتشف مناطق الهجوم الخاصة بالفريق وقم بالتصفية حسب الموسم أو نوع الهجوم"
      },
      step6: {
        title: "التشكيلات",
        message: "تحقق من التشكيلات الأكثر استخدامًا ونسبة الانتصارات والتعادلات والهزائم مع كل منها"
      },
      step7: {
        title: "مناطق التسديد",
        message: "قم بالتصفية حسب الموسم أو الفريق أو الخصم أو طريقة تصور الخريطة أو أنواع التسديدات أو الدقائق"
      },
      step8: {
        title: "التوزيعات",
        message: "الاستعلام والتصفية حسب الموسم، ونوع العرض، ناجحًا أو غير ناجح، من حيث البداية والنهاية أو بما في ذلك الركلات الركنية"
      }
    },
    teamOnOff: {
      step1: {
        title: "المواسم والمباريات",
        message: "قم بالتصفية حسب الموسم أو المباريات أو حسب مباريات الذهاب أو الاياب  "
      },
      step2: {
        title: "لاعبون",
        message: "عرض أداء جميع اللاعبين في الفريق من خلال عدد لا يحصى من المقاييس"
      }
    }
  },
  alerts: {
    numPlayers: "عدد اللاعبين",
    newPlayersLastWeek: "لاعبون جدد آخر أسبوع",
    subtitle: "استقبل تنبيهات عندما يتوفر لعمليات أبحاثك لاعبون جدد",
    generalSubtitle: "تنبيهات حول اللاعبين الجدد حسب معايرك، أخبار حول لاعبيك المفضلين ومهام تقويم الاستطلاع",
    subtitlePlayer: "احصل على تنبيهات عند وجود أخبار عن لاعبيك المفضلين",
    subtitleSearch: "احصل على تنبيهات عند تلبية لاعبين جدد لمعايير البحث الخاصة بك",
    favorite: "مفضل",
    newEventCalendar: "حدث جديد",
    updatedEventCalendar: "حدث محدث",
    newShareFrom: "مشاركة جديدة من",
    injuryAlert: "تنبيه إصابة",
    contractAlert: "تنبيه عقد",
    teamAlert: "تنبيه توقيع",
    marketValueAlert: "تنبيه قيمة السوق",
    gameAlert: "تنبيه مباراة",
  },
  videoEvents: {
    highlights: "أهم اللحظات",
    fullGame: "مباراة كاملة",
    autoplay: "تشغيل تلقائي",
    searchBarPlaceholder: "ابحث عن لاعبين، مباريات، فرق،...",
    subtitle: "حلل الأحداث في فيديو",
    successful: "تم ينجاح",
    unsuccessful: "فشل",
    playing: "جاري التشغيل",
    games: "مباريات",
    moreFilters: "تصفيات أخرى ...",
    startArea: "منطقة البداية",
    endArea: "منطقة النهاية",
    select: "اختار",
    selectLastXGames: "اختار {0} المباريات الأخيرة",
    advancedFilters: "تصفيات متقدمة",
    freeKicks: "الأخطاء",
    cornerKicks: "ضربات الزاوية",
    allShots: "التسديدات",
    generateZip:"Generate ZIP",
    zippedModalMessage:"ZIP process has been started, could take some minutes. You would receive an email when is finished",
    clickToSeeVideo:"Click to see video"
  },
  videoUpload: {
    subtitle: "تحميل فيديو وإنشاء مباراة",
    uploadVideo: "تحميل فيديو",
    selectPeriod: "اختر مباراة",
    gameData: "بيانات المباراة",
    venue: "إستاد",
    matchType: "نوع المباراة",
    matchGroup: "مجموعة المباراة",
    roundType: "نوع الجولة",
    roundNumber: "رقم الجولة",
    offsetFh: "تعويض الشوط الأول",
    offsetSh: "تعويض الشوط الثاني",
    offsetFhOT: "تعويض الوقت الضائع الشوط الأول",
    offsetShOT: "تعويض الوقت الضائع الشوط الثاني",
    homeLineup: "تشكيلة  الفريق المضيف",
    awayLineup: "تشكيلة الفريق الزائر",
    existingPlayer: "لاعب موجود",
    newPlayer: "لاعب جديد",
    startingTeam: "أساسي",
    saveAndUpload: "حفظ وتحميل",
    existingGame: "Game exists already",
    sendToKora:"Send",
    invalidForm:"Invalid form",
    warningModalTitle:"Anomalies have been detected",
    noScoreSheetWarning:"No scoresheet attached",
    onlyOnePartUploadedWarning: "Only one half time attached",
    continueQuestion: "continue?",
    slaLimit: "لقد قمت بتحميل {0} لعبة باستخدام {1}. الحد الخاص بك هو {2}",
    requestedGames: "المباريات المطلوبة",
    limitClose: "تبقَّت {0} مباريات فقط لطلبها",
    limitReached: "لقد وصلت إلى الحد الأقصى لرفع الفيديوهات. قد يؤدي رفع مباريات إضافية إلى تكاليف إضافية.",
    seasonFinishedWarning: "سيؤدي ذلك إلى إنشاء مباراة في موسم انتهى بالفعل. يرجى التحقق من أن هذا صحيح.",
    teamCountryWarning: "هذا الفريق من بلد مختلف عن البلد الخاص بالدوري المختار. يرجى التحقق من أن هذا صحيح.",
  },
  videoPlaylists: {
    subtitle: "مجموعة منتقاة من فيديوهات مميزة",
    savePlaylist: "حفظ قائمة التسجيلات",
    seeAllPlaylists: "عرض جميع القوائم"
  },
  videoHighlights: {
    recap:"خلاصة",
    homeCondensed:"لعبة منزلية مكثفة",
    awayCondensed:"بعيدا لعبة مكثفة",
    selectedActions: "الإجراءات المختارة",
    noActions: "لا توجد إجراءات مطابقة لمعايير الفلترة المحددة",
    noGames: "لم يتم تحميل أي مباريات بعد",
    attackingActions: "إجراءات هجومية",
    defensiveActions: "إجراءات دفاعية",
    groundDuels: "الالتحامات الأرضية",
    penaltiesProvoked: "ركلات جزاء محتسبة",
    goalkeeperActions: "إجراءات حارس المرمى",
    addSomeGames: "ابدأ بإضافة بعض المباريات!",
    goToVideoUploadTool: "اذهب لتحميل الفيديوهات",
    ballInPlay:"الكرة في اللعب",
    filterSeasons: "تصفية المواسم",
    streaming: "البث المباشر",
    clips: "مقاطع",
    qualifiers: {
      "Pass": "تمريرة",
      "Save": "تصدي",
      "Saved Shot": "تسديدة متصدى لها",
      "Shot": "تسديدة",
      "Goal": "هدف",
      "Missed Shot": "تسديدة ضائعة",
      "Shot on Post": "تسديدة على القائم",
      "Error": "خطأ",
      "Clearance": "تشتيت",
      "Aerial": "التحام هوائي",
      "Challenge": "التحام خاسر",
      "Dispossessed": "فقدان الكرة",
      "Foul": "خطأ",
      "Card": "بطاقة",
      "Offside Pass": "تمريرة تسلل",
      "Claim": "إمساك الكرة",
      "Keeper Pickup": "التقاط الحارس",
      "Ball Touch": "لمسة الكرة",
      "Dribble": "مراوغة",
      "Interception": "اعتراض",
      "Tackle": "عرقلة",
      "Ball Recovery": "استعادة الكرة"
    },
    qualifierIds: {
      "1": "تمريرة طويلة",
      "2": "عرضية",
      "5": "ركلة حرة مباشرة",
      "6": "ركلة ركنية",
      "9": "ركلة جزاء",
      "15": "ضربة رأسية",
      "20": "بالقدم اليمنى",
      "21": "بجزء آخر من الجسم",
      "22": "لعب مفتوح",
      "23": "هجمة مرتدة",
      "24": "كرة ثابتة",
      "25": "من الركلة الركنية",
      "26": "ركلة حرة",
      "28": "هدف عكسي",
      "29": "تمرير",
      "31": "بطاقة صفراء",
      "32": "البطاقة الصفراء الثانية",
      "33": "بطاقة حمراء",
      "72": "بالقدم اليسرى",
      "73": "يسار",
      "82": "تسديدة مُنقذة (بدون حارس)",
      "94": "تصدي دفاعي",
      "123": "رمية حارس المرمى",
      "124": "ركلة مرمى",
      "160": "رمية تماس",
      "170": "أدى إلى هدف",
      "173": "تشتيت آمن",
      "174": "تشتيت خطير",
      "177": "ممسوك",
      "178": "واقفًا",
      "179": "بالغوص",
      "182": "يدين",
      "183": "قدمين",
      "185": "عرضية محجوبة",
      "210": "تمريرة حاسمة",
      "215": "لعب فردي",
      "279": "ركلة البداية",
      "285": "دفاعي",
      "286": "هجومي"
    },
    areas: {
      "goalArea": "منطقة المرمى",
      "boxLeft": "منطقة الجزاء اليسرى",
      "boxCenter": "منطقة الجزاء الوسطى",
      "boxRight": "منطقة الجزاء اليمنى",
      "outBoxDeepLeft": "خارج منطقة الجزاء يسار عميق",
      "outBoxDeepRight": "خارج منطقة الجزاء يمين عميق",
      "outBoxLeft": "خارج منطقة الجزاء اليسرى",
      "outBoxCentreLeft": "خارج منطقة الجزاء وسط اليسار",
      "outBoxCentre": "خارج منطقة الجزاء الوسطى",
      "outBoxCentreRight": "خارج منطقة الجزاء وسط اليمين",
      "outBoxRight": "خارج منطقة الجزاء اليمنى",
      "midfieldLeft35": "وسط الملعب الأيسر",
      "midfieldCentreLeft35": "وسط الملعب وسط اليسار",
      "midfieldCentre35": "وسط الملعب الوسطى",
      "midfieldCentreRight35": "وسط الملعب وسط اليمين",
      "midfieldRight35": "وسط الملعب الأيمن",
      "ownGoalArea": "منطقة المرمى الخاصة",
      "ownBoxLeft": "منطقة الجزاء اليسرى الخاصة",
      "ownBoxCenter": "منطقة الجزاء الوسطى الخاصة",
      "ownBoxRight": "منطقة الجزاء اليمنى الخاصة",
      "ownFieldOutOfBoxDeepLeft": "منطقة خاصة خارج الجزاء يسار عميق",
      "ownFieldOutOfBoxDeepRight": "منطقة خاصة خارج الجزاء يمين عميق",
      "ownFieldOutOfBoxLeft": "منطقة خاصة خارج الجزاء اليسرى",
      "ownFieldOutOfBoxCentreLeft": "منطقة خاصة خارج الجزاء وسط اليسار",
      "ownFieldOutOfBoxCentre": "منطقة خاصة خارج الجزاء الوسطى",
      "ownFieldOutOfBoxCentreRight": "منطقة خاصة خارج الجزاء وسط اليمين",
      "ownFieldOutOfBoxRight": "منطقة خاصة خارج الجزاء اليمنى"
    },
    outcomes: {
      "success": "نجاح",
      "fail": "فشل",
      "possessionWon": "استحواذ ناجح",
      "possessionNotWon": "استحواذ غير ناجح",
      "received": "تم الاستلام",
      "provoked": "تم استدراجه"
    }    
  },  
  share: {
    shareTo: "مشاركة إلى",
    viaApp: "تطبيق (رسالة Driblab)",
    viaEmail: "بريد اليكتروني",
    description: "وصف",
    titleTab: "تمت مشاركتها",
    toMe: "تلقيت",
    fromMe: "أرسلت",
    typeInternal: "داخلي",
    typeExternal: "خارجي",
    title: "مشتركة",
    subtitle: "نظرة عامة على العناصر في قائمة المشاركة الخاصة بك",
    selectUser: "اختر المستخدم",
    expired:"منتهي الصلاحية",
    limitReached:"وصل الرابط إلى حد الاستخدامات"
  },
  homeStats: {
    data: "البيانات المتاحة",
    players: "لاعبون",
    totalPlayers: "إجمالي اللاعبين",
    teams: "فرق",
    totalTeams: "إجمالي الفرق",
    leagues: "دوريات",
    totalLeagues: "إجمالي الدوريات",
    seasons: "مواسم",
    totalSeasons: "إجمالي المواسم",
    games: "مباريات",
    totalGames: "إجمالي المباريات"
  },
  scoutingCalendar: {
    subtitle: "إنشاء وتنظيم مهمات الاستطلاع",
    myCalendars: "تقويمات خاصة",
    publicCalendars: "تقويمات عامة",
    otherCalendars: "تقويمات أخرى",
    calendarSettings: "إعدادات التقويم",
    moreInfo: "المزيد من المعلومات",
    individualScouting: "الاستكشاف الفردي",
    matchScouting: "استكشاف المباراة",
    calendarView: {
      type: "نوع التقويم",
      month: "شهر",
      week: "أسبوع",
      day: "يوم"
    },
    weekView: {
      type: "نوع الأسبوع",
      monSun: "الاثنين - الأحد",
      sunSat: "الأحد - السبت",
      monFri: "الاثنين - الجمعة"
    },
    tasks: {
      addNew: "إضافة مهمة جديدة",
      myTasks: "مهامي",
      filterTasks: "تصفية المهام",
      sharedWithMe: "تمت مشاركته معي",
      createTask: "إنشاء مهمة",
      newTask: "مهمة جديدة",
      taskName: "اسم المهمة",
      allDay: "طول اليوم",
      startDate: "تاريخ البدء",
      endDate: "تاريخ الانتهاء",
      startHour: "ساعة البدء ",
      endHour: "ساعة الانتهاء",
      assignedTo: "مخصص ل",
      assignedToMe: "مخصصة لي",
      color: "اللون",
      scoutingType: "نوع الاستطلاع",
      taskLocation: "موقع المهمة",
      selectLeague: "اختر الدوري",
      selectMatch: "اختر المباراة",
      useMatchdate: "استخدم تاريخ المبارة كتاريخ",
      stadium: "إستاد",
      travel: "رحلة",
      hotel: "فندق",
      tickets: "تذاكر",
      taskNotes: "أدخل ملاحظات وصفية أو تعليقات تخص المهمة.",
      states: {
        toDo: "للإنجاز",
        inProgress: "قيد التنفيذ",
        done: "منجز"
      },
      type: {
        player: "تقييم لاعب",
        team: "تقييم فريق",
        other: "آخر"
      },
      location: {
        stadium: "فى الإستاد",
        video: "فيديو"
      },
      accommodation: {
        accommodationDetails: "بيانات الإقامة",
        ownArrangement: "تنسيق خاص",
        required: "مطلوب",
        notRequired: "غير مطلوب",
        booked: "محجوز"
      },
      assignToMe: "خصصه لي",
      addOther: "إضافة آخر",
      deleteTask: "حذف مهمة",
      deleteTaskMessage: "سيتم إلغاء المهمة. هل أنت متأكد؟",
      cancelUpdate: "إلغاء التحديث",
      cancelUpdateMessage: "لن يتم حفظ التعديلات. هل أنت متأكد؟",
      selectGame: "يرجى اختار مباراة لإضافة ملفات",
      noData: "لا توجد بيانات. ابدأ بإضافة بعض المهام!",
      widgetSubtitle: "تحقق من مهامك القادمة",
      scoutingDetails: "تفاصيل الكشافة",
      taskDetails: "تفاصيل المهمة",
      playerDocuments: "وثائق اللاعب",
      teamDocuments: "وثائق الفريق",
      gameDocuments: "وثائق المباراة",
      taskDocuments: "وثائق المهمة",
      task: "مهمة"
    },
    nextGames: "المباريات القادمة"
  },
  scoutingTasksBoard: {
    period: {
      week: "هذا الأسبوع",
      month: "هذا الشهر",
      year: "هذه السنة",
    },
    noTasks: "قم بإنشاء مهام جديدة أو اسحب واحدة هنا!",
    goToBoard: "اذهب إلى board"
  },
  profile: {
    title: "الحساب",
    subtitle: "تخصيص حسابك وتفاصيل الاشتراك"
  },
  hub: {
    onlyHub: "متوفر فقط في Driblab Hub"
  },
  uploadedGames: {
    subtitle: "All uploaded games",
    timeRequested:"Time it was requested",
    timeReceived:"When it was received",
    diffHours:"Difference in hours",
    collectionCompleted: "Collection completed",
    dateFrom:"Date from",
    dateTo:"Date to",
    goToUploadedGames: "اذهب إلى المباريات المرفوعة",
    sla: "اتفاقية مستوى الخدمة",
    matchDate: "تاريخ المباراة",
    rejectedGame: "مرفوض"
  },
  gameMap: {
    title: "خريطة المباريات",
    subtitle: "استكشف مباريات الأيام القادمة",
    warning: "قد لا يكون الزمان والمكان صحيحين. يرجى التأكد من هذه المعلومات",
    taskAdded: "تم إنشاء المهمة بنجاح. تحقق من Scouting Calendar."
  },
  leagueRequestAccess: {
    sendSuccess: "تم  الاشعار بنجاح",
    notPermissions: "ليس لديك الاذن للرؤية",
    notPermissionsLeague: "ليس لديك الاذن لرؤية هذا الدوري",
    notPermissionsGame: "ليس لديك الاذن لرؤية هذه المبارات",
    requestAccessTo: "طلب الوصول إلى",
    sendRequest: "ارسل طلب"
  },
  videoTeams: {
    subtitle: "ابحث عن أحدث المباريات التي تم وضع علامة عليها بواسطة الفريق",
    noGamesUploaded: "لم يتم تحميل أي مباريات  حتى الآن"
  },
  scoutingAnalysis: {
    scoutingAnalysis: "تحليل الكشافة",
    scoutingAnalyses: "تحليلات الكشافة",
    analyses: "التحليلات",
    addReport: "إضافة تحليل",
    technical: "تقني",
    tactical: "تكتيكي",
    physical: "بدني",
    mental: "نفسي",
    technicalNotes: "ملاحظات تقنية",
    tacticalNotes: "ملاحظات تكتيكية",
    physicalNotes: "ملاحظات بدنية",
    mentalNotes: "ملاحظات عن البروفايل النفسي",
    conclusion: "الخلاصة",
    charactersMax: "أقصى 1000 حرف",
    globalRating: "التقييم العام",
    noData: "لا توجد بيانات. ابدأ بإضافة بعض التحليلات الكشفية!",
    deleteAnalysis: "حذف تحليل الكشافة",
    deleteAnalysisMessage: "سيتم إزالة التحليل نهائياً. هل أنت متأكد؟",
    avgTooltip: "المتوسط بناءً على التقييمات النهائية للتحليلات المرئية لك",
    avgOverallScoreTooltip: "المتوسط ​​مبني على النقاط الإجمالية للاعب المرئية لك",
    scouter: "الكشاف",
    lastEdited: "آخر تحديث",
    analysisFilters: "مرشحات التحليل",
    generalFilters: "مرشحات عامة",
    widgetSubtitle: "أحدث التحليلات المضافة",
    addPlayerReport: "إضافة تحليل الكشافة للاعب",
    seeReports: "عرض التقارير"  
  },
  addPlayerForm: {
    noLeague: "إنشاء فريق بدون دوري قد يكون له تأثير سلبي على فهرسته والبحث عنه لاحقًا داخل التطبيق."
  },
  expenses: {
    expense: "مصاريف",
    expenses: "نفقات",
    addExpense: "إضافة مصروف",
    transportation: "النقل",
    accommodation: "الإقامة",
    dietary: "النظام الغذائي",
    eventTicket: "تذكرة الحدث",
    expenseType: "نوع المصروف",
    amount: "المبلغ",
    expenseDate: "تاريخ المصروف",
    expenseFilters: "فلاتر النفقات",
    noData: "لا توجد بيانات. ابدأ بإضافة بعض النفقات!",
    deleteExpense: "حذف النفقة",
    deleteExpenseMessage: "سيتم حذف النفقة نهائيًا. هل أنت متأكد؟"
  },
  disabledTooltips: {
    general: "هذه الميزة معطلة حالياً",
    youth: "يجب أن يكون لاعب ناشئ لتحديد العمر",
    unit: "يجب أن تكون الإحصائية Runs أو HSR أو SPR",
    seasonsWithout60MinsGames: "اللاعب لم يلعب أكثر من 60 دقيقة في مباراة واحدة في الموسم/المواسم المختارة",
    notEditable: "لا يمكن تعديل هذا",
    noMatchdate: "تاريخ المباراة غير متوفر",
    selectGame: "يرجى اختيار مباراة أولاً",
    selectPlayer: "يرجى اختيار لاعب أولاً",
    selectTeam: "يرجى اختيار فريق أولاً",
    selectBoxes: "يجب اختيار عرض الصناديق",
    selectYear: "يرجى اختيار سنة أولاً",
    pdScoreNotAvailable: "النتيجة غير متاحة لأن اللاعب لم يلعب 60 دقيقة في المباراة",
    pdSeasonNotAvailable: "البيانات البدنية غير متوفرة لهذا الموسم",
    pdGameNotAvailable: "البيانات البدنية غير متوفرة لهذه المباراة",
  },
  leagueTypes: {
    regular: "عادي",
    continental: "قاري",
    nationalTeam: "المنتخب الوطني",
    countryCup: "كأس الدولة",
    qualifier: "تصفيات",
    playOff: "ملحق",
    regionalLeague: "الدوري الإقليمي",
    friendly: "ودية",
    nationalFriendly: "ودية وطنية",
    nationaQualifier: "تصفيات وطنية",
  },
  playerSides:{
    "Left/Right":"يسار/يمين",
    "Left/Centre/Right":"يسار/وسط/يمين",
    "Right":"يمين",
    "Centre":"وسط",
    "Centre/Right":"وسط/يمين",
    "Left":"يسار",
    "Left/Centre":"يسار/وسط"
  },
  areaSelector: {
    selectAreas: "اختر المناطق",
    filterAreas: "تصفية المناطق",
  },
  spatialCoverage:{
    lastDefenderDist: "المسافة الأخيرة للمدافع",
    defensiveLineDist: "مسافة الخط الدفاعي",
    fullBackAvgDist: "متوسط ​​المسافة الجانبية",
    offensiveLineDist: "مسافة الخط الهجومي",
    distanceToGoal: "المسافة إلى الهدف",
    avgLineWidth: "متوسط ​​عرض الخط",
    leagueAvgDistanceToGoal: "متوسط ​​المسافة إلى الهدف في الدوري",
    leagueAvgLineWidth:"متوسط ​​عرض الخط في الدوري",
    meters:" أمتار",
    leagueAvgDist: "متوسط ​​مسافة الدوري",
    distance: "مسافة",
    avgPositionYAxis: "متوسط ​​الموضع على المحور Y",
    leagueAvgPositionYAxis: "متوسط ​​موقع الدوري على المحور Y"
  }

}



// WEBPACK FOOTER //
// ./src/utils/translations/sa.js